/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TodoRouteRouteImport } from './routes/todo/route'
import { Route as TestSupportRouteRouteImport } from './routes/test-support/route'
import { Route as ProfielRouteRouteImport } from './routes/profiel/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TodoIndexRouteImport } from './routes/todo/index'
import { Route as TestSupportIndexRouteImport } from './routes/test-support/index'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as GeenRolIndexRouteImport } from './routes/geen-rol/index'
import { Route as Freelancer_omzettenIndexRouteImport } from './routes/freelancer_omzetten/index'
import { Route as FacturatieIndexRouteImport } from './routes/facturatie/index'
import { Route as DuoIndexRouteImport } from './routes/duo/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as CorrespondentieIndexRouteImport } from './routes/correspondentie/index'
import { Route as BeheerIndexRouteImport } from './routes/beheer/index'
import { Route as AgendaIndexRouteImport } from './routes/agenda/index'
import { Route as TestSupportRapportageTodoAanmakenRouteImport } from './routes/test-support/rapportage-todo-aanmaken'
import { Route as OnboardingOngeldige_tokenRouteImport } from './routes/onboarding/ongeldige_token'
import { Route as OnboardingTokenRouteImport } from './routes/onboarding/$token'
import { Route as LoginTokenRouteImport } from './routes/login/$token'
import { Route as CorrespondentieThreadIdRouteImport } from './routes/correspondentie/$threadId'
import { Route as ProfielZakelijke_gegevensIndexRouteImport } from './routes/profiel/zakelijke_gegevens/index'
import { Route as ProfielPersoonlijke_gegevensIndexRouteImport } from './routes/profiel/persoonlijke_gegevens/index'
import { Route as ProfielLocatiesIndexRouteImport } from './routes/profiel/locaties/index'
import { Route as ProfielLesbevoegdheidIndexRouteImport } from './routes/profiel/lesbevoegdheid/index'
import { Route as ProfielGroepenIndexRouteImport } from './routes/profiel/groepen/index'
import { Route as ProfielDossierIndexRouteImport } from './routes/profiel/dossier/index'
import { Route as ProfielBeschikbaarheidIndexRouteImport } from './routes/profiel/beschikbaarheid/index'
import { Route as ProfielAgendaIndexRouteImport } from './routes/profiel/agenda/index'
import { Route as OnboardingDocentOnboardingIndexRouteImport } from './routes/onboarding/docent-onboarding/index'
import { Route as FacturatieFacturenIndexRouteImport } from './routes/facturatie/facturen/index'
import { Route as FacturatieCursistenIndexRouteImport } from './routes/facturatie/cursisten/index'
import { Route as DuoTerugmeldingenIndexRouteImport } from './routes/duo/terugmeldingen/index'
import { Route as DuoFacturenIndexRouteImport } from './routes/duo/facturen/index'
import { Route as DuoExamenresultatenIndexRouteImport } from './routes/duo/examenresultaten/index'
import { Route as DuoContractenlijstenIndexRouteImport } from './routes/duo/contractenlijsten/index'
import { Route as BeheerToetsenIndexRouteImport } from './routes/beheer/toetsen/index'
import { Route as BeheerRoostersIndexRouteImport } from './routes/beheer/roosters/index'
import { Route as BeheerOrganisatiesIndexRouteImport } from './routes/beheer/organisaties/index'
import { Route as BeheerMedewerkersIndexRouteImport } from './routes/beheer/medewerkers/index'
import { Route as BeheerLocatiesIndexRouteImport } from './routes/beheer/locaties/index'
import { Route as BeheerLessenIndexRouteImport } from './routes/beheer/lessen/index'
import { Route as BeheerLesmaterialenIndexRouteImport } from './routes/beheer/lesmaterialen/index'
import { Route as BeheerLeerlijnenIndexRouteImport } from './routes/beheer/leerlijnen/index'
import { Route as BeheerLaptopsIndexRouteImport } from './routes/beheer/laptops/index'
import { Route as BeheerIntakesIndexRouteImport } from './routes/beheer/intakes/index'
import { Route as BeheerGroepenIndexRouteImport } from './routes/beheer/groepen/index'
import { Route as BeheerFeestdagenIndexRouteImport } from './routes/beheer/feestdagen/index'
import { Route as BeheerCursistenIndexRouteImport } from './routes/beheer/cursisten/index'
import { Route as BeheerContractenIndexRouteImport } from './routes/beheer/contracten/index'
import { Route as BeheerContactpersonenIndexRouteImport } from './routes/beheer/contactpersonen/index'
import { Route as AuthSso_callbackIndexRouteImport } from './routes/auth/sso_callback/index'
import { Route as AuthFailed_ssoIndexRouteImport } from './routes/auth/failed_sso/index'
import { Route as AuthConfirm_accountIndexRouteImport } from './routes/auth/confirm_account/index'
import { Route as BeheerOrganisatiesAanmakenRouteImport } from './routes/beheer/organisaties/aanmaken'
import { Route as BeheerLessenNieuweLesRouteImport } from './routes/beheer/lessen/nieuwe-les'
import { Route as BeheerLeerlijnenAanmakenRouteImport } from './routes/beheer/leerlijnen/aanmaken'
import { Route as BeheerLaptopsAanmakenRouteImport } from './routes/beheer/laptops/aanmaken'
import { Route as BeheerIntakesIntakePlannenRouteImport } from './routes/beheer/intakes/intake-plannen'
import { Route as BeheerIntakesAanmakenRouteImport } from './routes/beheer/intakes/aanmaken'
import { Route as BeheerGroepenAanmakenRouteImport } from './routes/beheer/groepen/aanmaken'
import { Route as BeheerCursistenAanmakenRouteImport } from './routes/beheer/cursisten/aanmaken'
import { Route as BeheerContactpersonenAanmakenRouteImport } from './routes/beheer/contactpersonen/aanmaken'
import { Route as AgendaLesLessonIdRouteImport } from './routes/agenda/les/$lessonId'
import { Route as BeheerOrganisatiesOrganizationIdRouteRouteImport } from './routes/beheer/organisaties/$organizationId/route'
import { Route as BeheerMedewerkersUserIdRouteRouteImport } from './routes/beheer/medewerkers/$userId/route'
import { Route as BeheerLocatiesLocationIdRouteRouteImport } from './routes/beheer/locaties/$locationId/route'
import { Route as BeheerLeerlijnenLearningPathIdRouteRouteImport } from './routes/beheer/leerlijnen/$learningPathId/route'
import { Route as BeheerLaptopsLaptopIdRouteRouteImport } from './routes/beheer/laptops/$laptopId/route'
import { Route as BeheerGroepenGroupIdRouteRouteImport } from './routes/beheer/groepen/$groupId/route'
import { Route as BeheerCursistenStudentIdRouteRouteImport } from './routes/beheer/cursisten/$studentId/route'
import { Route as BeheerContractenContractIdRouteRouteImport } from './routes/beheer/contracten/$contractId/route'
import { Route as BeheerContactpersonenOrganizationUserIdRouteRouteImport } from './routes/beheer/contactpersonen/$organizationUserId/route'
import { Route as TodoCategoryTodoIdIndexRouteImport } from './routes/todo/$category/$todoId/index'
import { Route as ProfielZakelijke_gegevensInvullenIndexRouteImport } from './routes/profiel/zakelijke_gegevens/invullen/index'
import { Route as ProfielLesbevoegdheidInvullenIndexRouteImport } from './routes/profiel/lesbevoegdheid/invullen/index'
import { Route as ProfielBeschikbaarheidInvullenIndexRouteImport } from './routes/profiel/beschikbaarheid/invullen/index'
import { Route as FacturatieFacturenInvoiceIdIndexRouteImport } from './routes/facturatie/facturen/$invoiceId/index'
import { Route as BeheerToetsenAanmakenIndexRouteImport } from './routes/beheer/toetsen/aanmaken/index'
import { Route as BeheerOrganisatiesOrganizationIdIndexRouteImport } from './routes/beheer/organisaties/$organizationId/index'
import { Route as BeheerLocatiesAanmakenIndexRouteImport } from './routes/beheer/locaties/aanmaken/index'
import { Route as BeheerLocatiesLocationIdIndexRouteImport } from './routes/beheer/locaties/$locationId/index'
import { Route as BeheerLesmaterialenAanmakenIndexRouteImport } from './routes/beheer/lesmaterialen/aanmaken/index'
import { Route as BeheerLeerlijnenLearningPathIdIndexRouteImport } from './routes/beheer/leerlijnen/$learningPathId/index'
import { Route as BeheerIntakesIntakeIdIndexRouteImport } from './routes/beheer/intakes/$intakeId/index'
import { Route as BeheerFeestdagenAanmakenIndexRouteImport } from './routes/beheer/feestdagen/aanmaken/index'
import { Route as BeheerContractenNieuwContractIndexRouteImport } from './routes/beheer/contracten/nieuw-contract/index'
import { Route as BeheerContractenContractIdIndexRouteImport } from './routes/beheer/contracten/$contractId/index'
import { Route as FacturatieCursistenStudentIdFactuurGenererenRouteImport } from './routes/facturatie/cursisten/$studentId/factuur-genereren'
import { Route as BeheerTodoStudentRegistrationIdVergelijkenRouteImport } from './routes/beheer/todo/$studentRegistrationId/vergelijken'
import { Route as BeheerTodoStudentRegistrationIdControlerenRouteImport } from './routes/beheer/todo/$studentRegistrationId/controleren'
import { Route as BeheerLaptopsLaptopIdLeengeschiedenisRouteImport } from './routes/beheer/laptops/$laptopId/leengeschiedenis'
import { Route as BeheerOrganisatiesOrganizationIdNotitiesIndexRouteImport } from './routes/beheer/organisaties/$organizationId/notities/index'
import { Route as BeheerOrganisatiesOrganizationIdGegevensIndexRouteImport } from './routes/beheer/organisaties/$organizationId/gegevens/index'
import { Route as BeheerOrganisatiesOrganizationIdDocumentenIndexRouteImport } from './routes/beheer/organisaties/$organizationId/documenten/index'
import { Route as BeheerOrganisatiesOrganizationIdCursistenIndexRouteImport } from './routes/beheer/organisaties/$organizationId/cursisten/index'
import { Route as BeheerOrganisatiesOrganizationIdContractenIndexRouteImport } from './routes/beheer/organisaties/$organizationId/contracten/index'
import { Route as BeheerOrganisatiesOrganizationIdContactpersonenIndexRouteImport } from './routes/beheer/organisaties/$organizationId/contactpersonen/index'
import { Route as BeheerMedewerkersUserIdZakelijke_gegevensIndexRouteImport } from './routes/beheer/medewerkers/$userId/zakelijke_gegevens/index'
import { Route as BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRouteImport } from './routes/beheer/medewerkers/$userId/persoonlijke_gegevens/index'
import { Route as BeheerMedewerkersUserIdLeslocatiesIndexRouteImport } from './routes/beheer/medewerkers/$userId/leslocaties/index'
import { Route as BeheerMedewerkersUserIdLesbevoegdheidIndexRouteImport } from './routes/beheer/medewerkers/$userId/lesbevoegdheid/index'
import { Route as BeheerMedewerkersUserIdGroepenIndexRouteImport } from './routes/beheer/medewerkers/$userId/groepen/index'
import { Route as BeheerMedewerkersUserIdDossierIndexRouteImport } from './routes/beheer/medewerkers/$userId/dossier/index'
import { Route as BeheerMedewerkersUserIdBeschikbaarheidIndexRouteImport } from './routes/beheer/medewerkers/$userId/beschikbaarheid/index'
import { Route as BeheerMedewerkersUserIdAgendaIndexRouteImport } from './routes/beheer/medewerkers/$userId/agenda/index'
import { Route as BeheerLocatiesLocationIdNotitiesIndexRouteImport } from './routes/beheer/locaties/$locationId/notities/index'
import { Route as BeheerLocatiesLocationIdGegevensIndexRouteImport } from './routes/beheer/locaties/$locationId/gegevens/index'
import { Route as BeheerLocatiesLocationIdDocumentenIndexRouteImport } from './routes/beheer/locaties/$locationId/documenten/index'
import { Route as BeheerGroepenGroupIdToetsOverzichtIndexRouteImport } from './routes/beheer/groepen/$groupId/toets-overzicht/index'
import { Route as BeheerGroepenGroupIdStudentsIndexRouteImport } from './routes/beheer/groepen/$groupId/students/index'
import { Route as BeheerGroepenGroupIdRoosterIndexRouteImport } from './routes/beheer/groepen/$groupId/rooster/index'
import { Route as BeheerGroepenGroupIdPresentieOverzichtIndexRouteImport } from './routes/beheer/groepen/$groupId/presentie-overzicht/index'
import { Route as BeheerGroepenGroupIdNotitiesIndexRouteImport } from './routes/beheer/groepen/$groupId/notities/index'
import { Route as BeheerGroepenGroupIdLessenIndexRouteImport } from './routes/beheer/groepen/$groupId/lessen/index'
import { Route as BeheerGroepenGroupIdLesmaterialenIndexRouteImport } from './routes/beheer/groepen/$groupId/lesmaterialen/index'
import { Route as BeheerGroepenGroupIdGegevensIndexRouteImport } from './routes/beheer/groepen/$groupId/gegevens/index'
import { Route as BeheerGroepenGroupIdDocumentenIndexRouteImport } from './routes/beheer/groepen/$groupId/documenten/index'
import { Route as BeheerGroepenGroupIdCorrespondentieIndexRouteImport } from './routes/beheer/groepen/$groupId/correspondentie/index'
import { Route as BeheerCursistenStudentIdVoortgangIndexRouteImport } from './routes/beheer/cursisten/$studentId/voortgang/index'
import { Route as BeheerCursistenStudentIdTweedeAanspreekpuntIndexRouteImport } from './routes/beheer/cursisten/$studentId/tweede-aanspreekpunt/index'
import { Route as BeheerCursistenStudentIdRapportagesIndexRouteImport } from './routes/beheer/cursisten/$studentId/rapportages/index'
import { Route as BeheerCursistenStudentIdNotitiesIndexRouteImport } from './routes/beheer/cursisten/$studentId/notities/index'
import { Route as BeheerCursistenStudentIdLessenIndexRouteImport } from './routes/beheer/cursisten/$studentId/lessen/index'
import { Route as BeheerCursistenStudentIdLaptopsIndexRouteImport } from './routes/beheer/cursisten/$studentId/laptops/index'
import { Route as BeheerCursistenStudentIdIntakeIndexRouteImport } from './routes/beheer/cursisten/$studentId/intake/index'
import { Route as BeheerCursistenStudentIdGegevensIndexRouteImport } from './routes/beheer/cursisten/$studentId/gegevens/index'
import { Route as BeheerCursistenStudentIdExamenresultatenIndexRouteImport } from './routes/beheer/cursisten/$studentId/examenresultaten/index'
import { Route as BeheerCursistenStudentIdDocumentenIndexRouteImport } from './routes/beheer/cursisten/$studentId/documenten/index'
import { Route as BeheerCursistenStudentIdCorrespondentieIndexRouteImport } from './routes/beheer/cursisten/$studentId/correspondentie/index'
import { Route as BeheerCursistenStudentIdBeschikbaarheidIndexRouteImport } from './routes/beheer/cursisten/$studentId/beschikbaarheid/index'
import { Route as BeheerContractenContractIdNotitiesIndexRouteImport } from './routes/beheer/contracten/$contractId/notities/index'
import { Route as BeheerContractenContractIdGegevensIndexRouteImport } from './routes/beheer/contracten/$contractId/gegevens/index'
import { Route as BeheerContractenContractIdDossierIndexRouteImport } from './routes/beheer/contracten/$contractId/dossier/index'
import { Route as BeheerContractenContractIdCorrespondentieIndexRouteImport } from './routes/beheer/contracten/$contractId/correspondentie/index'
import { Route as BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRouteImport } from './routes/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten/index'
import { Route as BeheerContactpersonenOrganizationUserIdGegevensIndexRouteImport } from './routes/beheer/contactpersonen/$organizationUserId/gegevens/index'
import { Route as BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRouteImport } from './routes/beheer/organisaties/$organizationId/contactpersonen/aanmaken'
import { Route as BeheerMedewerkersUserIdLesbevoegdheidControlerenRouteImport } from './routes/beheer/medewerkers/$userId/lesbevoegdheid/controleren'
import { Route as BeheerLocatiesLocationIdClassroomsClassroomRouteImport } from './routes/beheer/locaties/$locationId/classrooms/$classroom'
import { Route as BeheerLeerlijnenLearningPathIdModulesModuleIdRouteImport } from './routes/beheer/leerlijnen/$learningPathId/modules/$moduleId'
import { Route as BeheerGroepenWijzigenGroupIdLocatiesWijzigenRouteImport } from './routes/beheer/groepen/wijzigen/$groupId/locaties-wijzigen'
import { Route as BeheerGroepenGroupIdToetsOverzichtEntryIdRouteImport } from './routes/beheer/groepen/$groupId/toets-overzicht/$entryId'
import { Route as BeheerGroepenGroupIdLessenNieuweLesRouteImport } from './routes/beheer/groepen/$groupId/lessen/nieuwe-les'
import { Route as BeheerGroepenGroupIdCorrespondentieThreadIdRouteImport } from './routes/beheer/groepen/$groupId/correspondentie/$threadId'
import { Route as BeheerCursistenStudentIdCorrespondentieThreadIdRouteImport } from './routes/beheer/cursisten/$studentId/correspondentie/$threadId'
import { Route as BeheerContractenWijzigenContractIdVakantiesRouteImport } from './routes/beheer/contracten/wijzigen/$contractId/vakanties'
import { Route as BeheerContractenWijzigenContractIdTeamGegevensRouteImport } from './routes/beheer/contracten/wijzigen/$contractId/team-gegevens'
import { Route as BeheerContractenWijzigenContractIdLocatiesRouteImport } from './routes/beheer/contracten/wijzigen/$contractId/locaties'
import { Route as BeheerContractenWijzigenContractIdContractGegevensRouteImport } from './routes/beheer/contracten/wijzigen/$contractId/contract-gegevens'
import { Route as BeheerContractenContractIdOrganisatiesOrganizationRouteImport } from './routes/beheer/contracten/$contractId/organisaties/$organization'
import { Route as BeheerContractenContractIdCorrespondentieThreadIdRouteImport } from './routes/beheer/contracten/$contractId/correspondentie/$threadId'
import { Route as BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRouteImport } from './routes/beheer/organisaties/$organizationId/notities/$noteThreadId/index'
import { Route as BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRouteImport } from './routes/beheer/locaties/$locationId/notities/$noteThreadId/index'
import { Route as BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRouteImport } from './routes/beheer/groepen/$groupId/notities/$noteThreadId/index'
import { Route as BeheerCursistenStudentIdRapportagesReportIdIndexRouteImport } from './routes/beheer/cursisten/$studentId/rapportages/$reportId/index'
import { Route as BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRouteImport } from './routes/beheer/cursisten/$studentId/notities/$noteThreadId/index'
import { Route as BeheerContractenContractIdNotitiesNoteThreadIdIndexRouteImport } from './routes/beheer/contracten/$contractId/notities/$noteThreadId/index'
import { Route as BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRouteImport } from './routes/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/index'
import { Route as BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRouteImport } from './routes/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen'

const TodoRouteRoute = TodoRouteRouteImport.update({
  id: '/todo',
  path: '/todo',
  getParentRoute: () => rootRouteImport,
} as any)
const TestSupportRouteRoute = TestSupportRouteRouteImport.update({
  id: '/test-support',
  path: '/test-support',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfielRouteRoute = ProfielRouteRouteImport.update({
  id: '/profiel',
  path: '/profiel',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TodoIndexRoute = TodoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TodoRouteRoute,
} as any)
const TestSupportIndexRoute = TestSupportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TestSupportRouteRoute,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const GeenRolIndexRoute = GeenRolIndexRouteImport.update({
  id: '/geen-rol/',
  path: '/geen-rol/',
  getParentRoute: () => rootRouteImport,
} as any)
const Freelancer_omzettenIndexRoute =
  Freelancer_omzettenIndexRouteImport.update({
    id: '/freelancer_omzetten/',
    path: '/freelancer_omzetten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const FacturatieIndexRoute = FacturatieIndexRouteImport.update({
  id: '/facturatie/',
  path: '/facturatie/',
  getParentRoute: () => rootRouteImport,
} as any)
const DuoIndexRoute = DuoIndexRouteImport.update({
  id: '/duo/',
  path: '/duo/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const CorrespondentieIndexRoute = CorrespondentieIndexRouteImport.update({
  id: '/correspondentie/',
  path: '/correspondentie/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerIndexRoute = BeheerIndexRouteImport.update({
  id: '/beheer/',
  path: '/beheer/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgendaIndexRoute = AgendaIndexRouteImport.update({
  id: '/agenda/',
  path: '/agenda/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestSupportRapportageTodoAanmakenRoute =
  TestSupportRapportageTodoAanmakenRouteImport.update({
    id: '/rapportage-todo-aanmaken',
    path: '/rapportage-todo-aanmaken',
    getParentRoute: () => TestSupportRouteRoute,
  } as any)
const OnboardingOngeldige_tokenRoute =
  OnboardingOngeldige_tokenRouteImport.update({
    id: '/onboarding/ongeldige_token',
    path: '/onboarding/ongeldige_token',
    getParentRoute: () => rootRouteImport,
  } as any)
const OnboardingTokenRoute = OnboardingTokenRouteImport.update({
  id: '/onboarding/$token',
  path: '/onboarding/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginTokenRoute = LoginTokenRouteImport.update({
  id: '/login/$token',
  path: '/login/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CorrespondentieThreadIdRoute = CorrespondentieThreadIdRouteImport.update({
  id: '/correspondentie/$threadId',
  path: '/correspondentie/$threadId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfielZakelijke_gegevensIndexRoute =
  ProfielZakelijke_gegevensIndexRouteImport.update({
    id: '/zakelijke_gegevens/',
    path: '/zakelijke_gegevens/',
    getParentRoute: () => ProfielRouteRoute,
  } as any)
const ProfielPersoonlijke_gegevensIndexRoute =
  ProfielPersoonlijke_gegevensIndexRouteImport.update({
    id: '/persoonlijke_gegevens/',
    path: '/persoonlijke_gegevens/',
    getParentRoute: () => ProfielRouteRoute,
  } as any)
const ProfielLocatiesIndexRoute = ProfielLocatiesIndexRouteImport.update({
  id: '/locaties/',
  path: '/locaties/',
  getParentRoute: () => ProfielRouteRoute,
} as any)
const ProfielLesbevoegdheidIndexRoute =
  ProfielLesbevoegdheidIndexRouteImport.update({
    id: '/lesbevoegdheid/',
    path: '/lesbevoegdheid/',
    getParentRoute: () => ProfielRouteRoute,
  } as any)
const ProfielGroepenIndexRoute = ProfielGroepenIndexRouteImport.update({
  id: '/groepen/',
  path: '/groepen/',
  getParentRoute: () => ProfielRouteRoute,
} as any)
const ProfielDossierIndexRoute = ProfielDossierIndexRouteImport.update({
  id: '/dossier/',
  path: '/dossier/',
  getParentRoute: () => ProfielRouteRoute,
} as any)
const ProfielBeschikbaarheidIndexRoute =
  ProfielBeschikbaarheidIndexRouteImport.update({
    id: '/beschikbaarheid/',
    path: '/beschikbaarheid/',
    getParentRoute: () => ProfielRouteRoute,
  } as any)
const ProfielAgendaIndexRoute = ProfielAgendaIndexRouteImport.update({
  id: '/agenda/',
  path: '/agenda/',
  getParentRoute: () => ProfielRouteRoute,
} as any)
const OnboardingDocentOnboardingIndexRoute =
  OnboardingDocentOnboardingIndexRouteImport.update({
    id: '/onboarding/docent-onboarding/',
    path: '/onboarding/docent-onboarding/',
    getParentRoute: () => rootRouteImport,
  } as any)
const FacturatieFacturenIndexRoute = FacturatieFacturenIndexRouteImport.update({
  id: '/facturatie/facturen/',
  path: '/facturatie/facturen/',
  getParentRoute: () => rootRouteImport,
} as any)
const FacturatieCursistenIndexRoute =
  FacturatieCursistenIndexRouteImport.update({
    id: '/facturatie/cursisten/',
    path: '/facturatie/cursisten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DuoTerugmeldingenIndexRoute = DuoTerugmeldingenIndexRouteImport.update({
  id: '/duo/terugmeldingen/',
  path: '/duo/terugmeldingen/',
  getParentRoute: () => rootRouteImport,
} as any)
const DuoFacturenIndexRoute = DuoFacturenIndexRouteImport.update({
  id: '/duo/facturen/',
  path: '/duo/facturen/',
  getParentRoute: () => rootRouteImport,
} as any)
const DuoExamenresultatenIndexRoute =
  DuoExamenresultatenIndexRouteImport.update({
    id: '/duo/examenresultaten/',
    path: '/duo/examenresultaten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DuoContractenlijstenIndexRoute =
  DuoContractenlijstenIndexRouteImport.update({
    id: '/duo/contractenlijsten/',
    path: '/duo/contractenlijsten/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerToetsenIndexRoute = BeheerToetsenIndexRouteImport.update({
  id: '/beheer/toetsen/',
  path: '/beheer/toetsen/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerRoostersIndexRoute = BeheerRoostersIndexRouteImport.update({
  id: '/beheer/roosters/',
  path: '/beheer/roosters/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerOrganisatiesIndexRoute = BeheerOrganisatiesIndexRouteImport.update({
  id: '/beheer/organisaties/',
  path: '/beheer/organisaties/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerMedewerkersIndexRoute = BeheerMedewerkersIndexRouteImport.update({
  id: '/beheer/medewerkers/',
  path: '/beheer/medewerkers/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerLocatiesIndexRoute = BeheerLocatiesIndexRouteImport.update({
  id: '/beheer/locaties/',
  path: '/beheer/locaties/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerLessenIndexRoute = BeheerLessenIndexRouteImport.update({
  id: '/beheer/lessen/',
  path: '/beheer/lessen/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerLesmaterialenIndexRoute =
  BeheerLesmaterialenIndexRouteImport.update({
    id: '/beheer/lesmaterialen/',
    path: '/beheer/lesmaterialen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerLeerlijnenIndexRoute = BeheerLeerlijnenIndexRouteImport.update({
  id: '/beheer/leerlijnen/',
  path: '/beheer/leerlijnen/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerLaptopsIndexRoute = BeheerLaptopsIndexRouteImport.update({
  id: '/beheer/laptops/',
  path: '/beheer/laptops/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerIntakesIndexRoute = BeheerIntakesIndexRouteImport.update({
  id: '/beheer/intakes/',
  path: '/beheer/intakes/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerGroepenIndexRoute = BeheerGroepenIndexRouteImport.update({
  id: '/beheer/groepen/',
  path: '/beheer/groepen/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerFeestdagenIndexRoute = BeheerFeestdagenIndexRouteImport.update({
  id: '/beheer/feestdagen/',
  path: '/beheer/feestdagen/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerCursistenIndexRoute = BeheerCursistenIndexRouteImport.update({
  id: '/beheer/cursisten/',
  path: '/beheer/cursisten/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerContractenIndexRoute = BeheerContractenIndexRouteImport.update({
  id: '/beheer/contracten/',
  path: '/beheer/contracten/',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerContactpersonenIndexRoute =
  BeheerContactpersonenIndexRouteImport.update({
    id: '/beheer/contactpersonen/',
    path: '/beheer/contactpersonen/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthSso_callbackIndexRoute = AuthSso_callbackIndexRouteImport.update({
  id: '/auth/sso_callback/',
  path: '/auth/sso_callback/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthFailed_ssoIndexRoute = AuthFailed_ssoIndexRouteImport.update({
  id: '/auth/failed_sso/',
  path: '/auth/failed_sso/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthConfirm_accountIndexRoute =
  AuthConfirm_accountIndexRouteImport.update({
    id: '/auth/confirm_account/',
    path: '/auth/confirm_account/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerOrganisatiesAanmakenRoute =
  BeheerOrganisatiesAanmakenRouteImport.update({
    id: '/beheer/organisaties/aanmaken',
    path: '/beheer/organisaties/aanmaken',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerLessenNieuweLesRoute = BeheerLessenNieuweLesRouteImport.update({
  id: '/beheer/lessen/nieuwe-les',
  path: '/beheer/lessen/nieuwe-les',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerLeerlijnenAanmakenRoute =
  BeheerLeerlijnenAanmakenRouteImport.update({
    id: '/beheer/leerlijnen/aanmaken',
    path: '/beheer/leerlijnen/aanmaken',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerLaptopsAanmakenRoute = BeheerLaptopsAanmakenRouteImport.update({
  id: '/beheer/laptops/aanmaken',
  path: '/beheer/laptops/aanmaken',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerIntakesIntakePlannenRoute =
  BeheerIntakesIntakePlannenRouteImport.update({
    id: '/beheer/intakes/intake-plannen',
    path: '/beheer/intakes/intake-plannen',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerIntakesAanmakenRoute = BeheerIntakesAanmakenRouteImport.update({
  id: '/beheer/intakes/aanmaken',
  path: '/beheer/intakes/aanmaken',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerGroepenAanmakenRoute = BeheerGroepenAanmakenRouteImport.update({
  id: '/beheer/groepen/aanmaken',
  path: '/beheer/groepen/aanmaken',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerCursistenAanmakenRoute = BeheerCursistenAanmakenRouteImport.update({
  id: '/beheer/cursisten/aanmaken',
  path: '/beheer/cursisten/aanmaken',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerContactpersonenAanmakenRoute =
  BeheerContactpersonenAanmakenRouteImport.update({
    id: '/beheer/contactpersonen/aanmaken',
    path: '/beheer/contactpersonen/aanmaken',
    getParentRoute: () => rootRouteImport,
  } as any)
const AgendaLesLessonIdRoute = AgendaLesLessonIdRouteImport.update({
  id: '/agenda/les/$lessonId',
  path: '/agenda/les/$lessonId',
  getParentRoute: () => rootRouteImport,
} as any)
const BeheerOrganisatiesOrganizationIdRouteRoute =
  BeheerOrganisatiesOrganizationIdRouteRouteImport.update({
    id: '/beheer/organisaties/$organizationId',
    path: '/beheer/organisaties/$organizationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerMedewerkersUserIdRouteRoute =
  BeheerMedewerkersUserIdRouteRouteImport.update({
    id: '/beheer/medewerkers/$userId',
    path: '/beheer/medewerkers/$userId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerLocatiesLocationIdRouteRoute =
  BeheerLocatiesLocationIdRouteRouteImport.update({
    id: '/beheer/locaties/$locationId',
    path: '/beheer/locaties/$locationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerLeerlijnenLearningPathIdRouteRoute =
  BeheerLeerlijnenLearningPathIdRouteRouteImport.update({
    id: '/beheer/leerlijnen/$learningPathId',
    path: '/beheer/leerlijnen/$learningPathId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerLaptopsLaptopIdRouteRoute =
  BeheerLaptopsLaptopIdRouteRouteImport.update({
    id: '/beheer/laptops/$laptopId',
    path: '/beheer/laptops/$laptopId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerGroepenGroupIdRouteRoute =
  BeheerGroepenGroupIdRouteRouteImport.update({
    id: '/beheer/groepen/$groupId',
    path: '/beheer/groepen/$groupId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerCursistenStudentIdRouteRoute =
  BeheerCursistenStudentIdRouteRouteImport.update({
    id: '/beheer/cursisten/$studentId',
    path: '/beheer/cursisten/$studentId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerContractenContractIdRouteRoute =
  BeheerContractenContractIdRouteRouteImport.update({
    id: '/beheer/contracten/$contractId',
    path: '/beheer/contracten/$contractId',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerContactpersonenOrganizationUserIdRouteRoute =
  BeheerContactpersonenOrganizationUserIdRouteRouteImport.update({
    id: '/beheer/contactpersonen/$organizationUserId',
    path: '/beheer/contactpersonen/$organizationUserId',
    getParentRoute: () => rootRouteImport,
  } as any)
const TodoCategoryTodoIdIndexRoute = TodoCategoryTodoIdIndexRouteImport.update({
  id: '/$category/$todoId/',
  path: '/$category/$todoId/',
  getParentRoute: () => TodoRouteRoute,
} as any)
const ProfielZakelijke_gegevensInvullenIndexRoute =
  ProfielZakelijke_gegevensInvullenIndexRouteImport.update({
    id: '/zakelijke_gegevens/invullen/',
    path: '/zakelijke_gegevens/invullen/',
    getParentRoute: () => ProfielRouteRoute,
  } as any)
const ProfielLesbevoegdheidInvullenIndexRoute =
  ProfielLesbevoegdheidInvullenIndexRouteImport.update({
    id: '/lesbevoegdheid/invullen/',
    path: '/lesbevoegdheid/invullen/',
    getParentRoute: () => ProfielRouteRoute,
  } as any)
const ProfielBeschikbaarheidInvullenIndexRoute =
  ProfielBeschikbaarheidInvullenIndexRouteImport.update({
    id: '/beschikbaarheid/invullen/',
    path: '/beschikbaarheid/invullen/',
    getParentRoute: () => ProfielRouteRoute,
  } as any)
const FacturatieFacturenInvoiceIdIndexRoute =
  FacturatieFacturenInvoiceIdIndexRouteImport.update({
    id: '/facturatie/facturen/$invoiceId/',
    path: '/facturatie/facturen/$invoiceId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerToetsenAanmakenIndexRoute =
  BeheerToetsenAanmakenIndexRouteImport.update({
    id: '/beheer/toetsen/aanmaken/',
    path: '/beheer/toetsen/aanmaken/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerOrganisatiesOrganizationIdIndexRoute =
  BeheerOrganisatiesOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BeheerOrganisatiesOrganizationIdRouteRoute,
  } as any)
const BeheerLocatiesAanmakenIndexRoute =
  BeheerLocatiesAanmakenIndexRouteImport.update({
    id: '/beheer/locaties/aanmaken/',
    path: '/beheer/locaties/aanmaken/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerLocatiesLocationIdIndexRoute =
  BeheerLocatiesLocationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BeheerLocatiesLocationIdRouteRoute,
  } as any)
const BeheerLesmaterialenAanmakenIndexRoute =
  BeheerLesmaterialenAanmakenIndexRouteImport.update({
    id: '/beheer/lesmaterialen/aanmaken/',
    path: '/beheer/lesmaterialen/aanmaken/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerLeerlijnenLearningPathIdIndexRoute =
  BeheerLeerlijnenLearningPathIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BeheerLeerlijnenLearningPathIdRouteRoute,
  } as any)
const BeheerIntakesIntakeIdIndexRoute =
  BeheerIntakesIntakeIdIndexRouteImport.update({
    id: '/beheer/intakes/$intakeId/',
    path: '/beheer/intakes/$intakeId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerFeestdagenAanmakenIndexRoute =
  BeheerFeestdagenAanmakenIndexRouteImport.update({
    id: '/beheer/feestdagen/aanmaken/',
    path: '/beheer/feestdagen/aanmaken/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerContractenNieuwContractIndexRoute =
  BeheerContractenNieuwContractIndexRouteImport.update({
    id: '/beheer/contracten/nieuw-contract/',
    path: '/beheer/contracten/nieuw-contract/',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerContractenContractIdIndexRoute =
  BeheerContractenContractIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const FacturatieCursistenStudentIdFactuurGenererenRoute =
  FacturatieCursistenStudentIdFactuurGenererenRouteImport.update({
    id: '/facturatie/cursisten/$studentId/factuur-genereren',
    path: '/facturatie/cursisten/$studentId/factuur-genereren',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerTodoStudentRegistrationIdVergelijkenRoute =
  BeheerTodoStudentRegistrationIdVergelijkenRouteImport.update({
    id: '/beheer/todo/$studentRegistrationId/vergelijken',
    path: '/beheer/todo/$studentRegistrationId/vergelijken',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerTodoStudentRegistrationIdControlerenRoute =
  BeheerTodoStudentRegistrationIdControlerenRouteImport.update({
    id: '/beheer/todo/$studentRegistrationId/controleren',
    path: '/beheer/todo/$studentRegistrationId/controleren',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerLaptopsLaptopIdLeengeschiedenisRoute =
  BeheerLaptopsLaptopIdLeengeschiedenisRouteImport.update({
    id: '/leengeschiedenis',
    path: '/leengeschiedenis',
    getParentRoute: () => BeheerLaptopsLaptopIdRouteRoute,
  } as any)
const BeheerOrganisatiesOrganizationIdNotitiesIndexRoute =
  BeheerOrganisatiesOrganizationIdNotitiesIndexRouteImport.update({
    id: '/notities/',
    path: '/notities/',
    getParentRoute: () => BeheerOrganisatiesOrganizationIdRouteRoute,
  } as any)
const BeheerOrganisatiesOrganizationIdGegevensIndexRoute =
  BeheerOrganisatiesOrganizationIdGegevensIndexRouteImport.update({
    id: '/gegevens/',
    path: '/gegevens/',
    getParentRoute: () => BeheerOrganisatiesOrganizationIdRouteRoute,
  } as any)
const BeheerOrganisatiesOrganizationIdDocumentenIndexRoute =
  BeheerOrganisatiesOrganizationIdDocumentenIndexRouteImport.update({
    id: '/documenten/',
    path: '/documenten/',
    getParentRoute: () => BeheerOrganisatiesOrganizationIdRouteRoute,
  } as any)
const BeheerOrganisatiesOrganizationIdCursistenIndexRoute =
  BeheerOrganisatiesOrganizationIdCursistenIndexRouteImport.update({
    id: '/cursisten/',
    path: '/cursisten/',
    getParentRoute: () => BeheerOrganisatiesOrganizationIdRouteRoute,
  } as any)
const BeheerOrganisatiesOrganizationIdContractenIndexRoute =
  BeheerOrganisatiesOrganizationIdContractenIndexRouteImport.update({
    id: '/contracten/',
    path: '/contracten/',
    getParentRoute: () => BeheerOrganisatiesOrganizationIdRouteRoute,
  } as any)
const BeheerOrganisatiesOrganizationIdContactpersonenIndexRoute =
  BeheerOrganisatiesOrganizationIdContactpersonenIndexRouteImport.update({
    id: '/contactpersonen/',
    path: '/contactpersonen/',
    getParentRoute: () => BeheerOrganisatiesOrganizationIdRouteRoute,
  } as any)
const BeheerMedewerkersUserIdZakelijke_gegevensIndexRoute =
  BeheerMedewerkersUserIdZakelijke_gegevensIndexRouteImport.update({
    id: '/zakelijke_gegevens/',
    path: '/zakelijke_gegevens/',
    getParentRoute: () => BeheerMedewerkersUserIdRouteRoute,
  } as any)
const BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRoute =
  BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRouteImport.update({
    id: '/persoonlijke_gegevens/',
    path: '/persoonlijke_gegevens/',
    getParentRoute: () => BeheerMedewerkersUserIdRouteRoute,
  } as any)
const BeheerMedewerkersUserIdLeslocatiesIndexRoute =
  BeheerMedewerkersUserIdLeslocatiesIndexRouteImport.update({
    id: '/leslocaties/',
    path: '/leslocaties/',
    getParentRoute: () => BeheerMedewerkersUserIdRouteRoute,
  } as any)
const BeheerMedewerkersUserIdLesbevoegdheidIndexRoute =
  BeheerMedewerkersUserIdLesbevoegdheidIndexRouteImport.update({
    id: '/lesbevoegdheid/',
    path: '/lesbevoegdheid/',
    getParentRoute: () => BeheerMedewerkersUserIdRouteRoute,
  } as any)
const BeheerMedewerkersUserIdGroepenIndexRoute =
  BeheerMedewerkersUserIdGroepenIndexRouteImport.update({
    id: '/groepen/',
    path: '/groepen/',
    getParentRoute: () => BeheerMedewerkersUserIdRouteRoute,
  } as any)
const BeheerMedewerkersUserIdDossierIndexRoute =
  BeheerMedewerkersUserIdDossierIndexRouteImport.update({
    id: '/dossier/',
    path: '/dossier/',
    getParentRoute: () => BeheerMedewerkersUserIdRouteRoute,
  } as any)
const BeheerMedewerkersUserIdBeschikbaarheidIndexRoute =
  BeheerMedewerkersUserIdBeschikbaarheidIndexRouteImport.update({
    id: '/beschikbaarheid/',
    path: '/beschikbaarheid/',
    getParentRoute: () => BeheerMedewerkersUserIdRouteRoute,
  } as any)
const BeheerMedewerkersUserIdAgendaIndexRoute =
  BeheerMedewerkersUserIdAgendaIndexRouteImport.update({
    id: '/agenda/',
    path: '/agenda/',
    getParentRoute: () => BeheerMedewerkersUserIdRouteRoute,
  } as any)
const BeheerLocatiesLocationIdNotitiesIndexRoute =
  BeheerLocatiesLocationIdNotitiesIndexRouteImport.update({
    id: '/notities/',
    path: '/notities/',
    getParentRoute: () => BeheerLocatiesLocationIdRouteRoute,
  } as any)
const BeheerLocatiesLocationIdGegevensIndexRoute =
  BeheerLocatiesLocationIdGegevensIndexRouteImport.update({
    id: '/gegevens/',
    path: '/gegevens/',
    getParentRoute: () => BeheerLocatiesLocationIdRouteRoute,
  } as any)
const BeheerLocatiesLocationIdDocumentenIndexRoute =
  BeheerLocatiesLocationIdDocumentenIndexRouteImport.update({
    id: '/documenten/',
    path: '/documenten/',
    getParentRoute: () => BeheerLocatiesLocationIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdToetsOverzichtIndexRoute =
  BeheerGroepenGroupIdToetsOverzichtIndexRouteImport.update({
    id: '/toets-overzicht/',
    path: '/toets-overzicht/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdStudentsIndexRoute =
  BeheerGroepenGroupIdStudentsIndexRouteImport.update({
    id: '/students/',
    path: '/students/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdRoosterIndexRoute =
  BeheerGroepenGroupIdRoosterIndexRouteImport.update({
    id: '/rooster/',
    path: '/rooster/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdPresentieOverzichtIndexRoute =
  BeheerGroepenGroupIdPresentieOverzichtIndexRouteImport.update({
    id: '/presentie-overzicht/',
    path: '/presentie-overzicht/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdNotitiesIndexRoute =
  BeheerGroepenGroupIdNotitiesIndexRouteImport.update({
    id: '/notities/',
    path: '/notities/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdLessenIndexRoute =
  BeheerGroepenGroupIdLessenIndexRouteImport.update({
    id: '/lessen/',
    path: '/lessen/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdLesmaterialenIndexRoute =
  BeheerGroepenGroupIdLesmaterialenIndexRouteImport.update({
    id: '/lesmaterialen/',
    path: '/lesmaterialen/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdGegevensIndexRoute =
  BeheerGroepenGroupIdGegevensIndexRouteImport.update({
    id: '/gegevens/',
    path: '/gegevens/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdDocumentenIndexRoute =
  BeheerGroepenGroupIdDocumentenIndexRouteImport.update({
    id: '/documenten/',
    path: '/documenten/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdCorrespondentieIndexRoute =
  BeheerGroepenGroupIdCorrespondentieIndexRouteImport.update({
    id: '/correspondentie/',
    path: '/correspondentie/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdVoortgangIndexRoute =
  BeheerCursistenStudentIdVoortgangIndexRouteImport.update({
    id: '/voortgang/',
    path: '/voortgang/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute =
  BeheerCursistenStudentIdTweedeAanspreekpuntIndexRouteImport.update({
    id: '/tweede-aanspreekpunt/',
    path: '/tweede-aanspreekpunt/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdRapportagesIndexRoute =
  BeheerCursistenStudentIdRapportagesIndexRouteImport.update({
    id: '/rapportages/',
    path: '/rapportages/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdNotitiesIndexRoute =
  BeheerCursistenStudentIdNotitiesIndexRouteImport.update({
    id: '/notities/',
    path: '/notities/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdLessenIndexRoute =
  BeheerCursistenStudentIdLessenIndexRouteImport.update({
    id: '/lessen/',
    path: '/lessen/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdLaptopsIndexRoute =
  BeheerCursistenStudentIdLaptopsIndexRouteImport.update({
    id: '/laptops/',
    path: '/laptops/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdIntakeIndexRoute =
  BeheerCursistenStudentIdIntakeIndexRouteImport.update({
    id: '/intake/',
    path: '/intake/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdGegevensIndexRoute =
  BeheerCursistenStudentIdGegevensIndexRouteImport.update({
    id: '/gegevens/',
    path: '/gegevens/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdExamenresultatenIndexRoute =
  BeheerCursistenStudentIdExamenresultatenIndexRouteImport.update({
    id: '/examenresultaten/',
    path: '/examenresultaten/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdDocumentenIndexRoute =
  BeheerCursistenStudentIdDocumentenIndexRouteImport.update({
    id: '/documenten/',
    path: '/documenten/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdCorrespondentieIndexRoute =
  BeheerCursistenStudentIdCorrespondentieIndexRouteImport.update({
    id: '/correspondentie/',
    path: '/correspondentie/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdBeschikbaarheidIndexRoute =
  BeheerCursistenStudentIdBeschikbaarheidIndexRouteImport.update({
    id: '/beschikbaarheid/',
    path: '/beschikbaarheid/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerContractenContractIdNotitiesIndexRoute =
  BeheerContractenContractIdNotitiesIndexRouteImport.update({
    id: '/notities/',
    path: '/notities/',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const BeheerContractenContractIdGegevensIndexRoute =
  BeheerContractenContractIdGegevensIndexRouteImport.update({
    id: '/gegevens/',
    path: '/gegevens/',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const BeheerContractenContractIdDossierIndexRoute =
  BeheerContractenContractIdDossierIndexRouteImport.update({
    id: '/dossier/',
    path: '/dossier/',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const BeheerContractenContractIdCorrespondentieIndexRoute =
  BeheerContractenContractIdCorrespondentieIndexRouteImport.update({
    id: '/correspondentie/',
    path: '/correspondentie/',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRoute =
  BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRouteImport.update(
    {
      id: '/gekoppelde-cursisten/',
      path: '/gekoppelde-cursisten/',
      getParentRoute: () => BeheerContactpersonenOrganizationUserIdRouteRoute,
    } as any,
  )
const BeheerContactpersonenOrganizationUserIdGegevensIndexRoute =
  BeheerContactpersonenOrganizationUserIdGegevensIndexRouteImport.update({
    id: '/gegevens/',
    path: '/gegevens/',
    getParentRoute: () => BeheerContactpersonenOrganizationUserIdRouteRoute,
  } as any)
const BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRoute =
  BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRouteImport.update({
    id: '/contactpersonen/aanmaken',
    path: '/contactpersonen/aanmaken',
    getParentRoute: () => BeheerOrganisatiesOrganizationIdRouteRoute,
  } as any)
const BeheerMedewerkersUserIdLesbevoegdheidControlerenRoute =
  BeheerMedewerkersUserIdLesbevoegdheidControlerenRouteImport.update({
    id: '/lesbevoegdheid/controleren',
    path: '/lesbevoegdheid/controleren',
    getParentRoute: () => BeheerMedewerkersUserIdRouteRoute,
  } as any)
const BeheerLocatiesLocationIdClassroomsClassroomRoute =
  BeheerLocatiesLocationIdClassroomsClassroomRouteImport.update({
    id: '/classrooms/$classroom',
    path: '/classrooms/$classroom',
    getParentRoute: () => BeheerLocatiesLocationIdRouteRoute,
  } as any)
const BeheerLeerlijnenLearningPathIdModulesModuleIdRoute =
  BeheerLeerlijnenLearningPathIdModulesModuleIdRouteImport.update({
    id: '/modules/$moduleId',
    path: '/modules/$moduleId',
    getParentRoute: () => BeheerLeerlijnenLearningPathIdRouteRoute,
  } as any)
const BeheerGroepenWijzigenGroupIdLocatiesWijzigenRoute =
  BeheerGroepenWijzigenGroupIdLocatiesWijzigenRouteImport.update({
    id: '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen',
    path: '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerGroepenGroupIdToetsOverzichtEntryIdRoute =
  BeheerGroepenGroupIdToetsOverzichtEntryIdRouteImport.update({
    id: '/toets-overzicht/$entryId',
    path: '/toets-overzicht/$entryId',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdLessenNieuweLesRoute =
  BeheerGroepenGroupIdLessenNieuweLesRouteImport.update({
    id: '/lessen/nieuwe-les',
    path: '/lessen/nieuwe-les',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdCorrespondentieThreadIdRoute =
  BeheerGroepenGroupIdCorrespondentieThreadIdRouteImport.update({
    id: '/correspondentie/$threadId',
    path: '/correspondentie/$threadId',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdCorrespondentieThreadIdRoute =
  BeheerCursistenStudentIdCorrespondentieThreadIdRouteImport.update({
    id: '/correspondentie/$threadId',
    path: '/correspondentie/$threadId',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerContractenWijzigenContractIdVakantiesRoute =
  BeheerContractenWijzigenContractIdVakantiesRouteImport.update({
    id: '/beheer/contracten/wijzigen/$contractId/vakanties',
    path: '/beheer/contracten/wijzigen/$contractId/vakanties',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerContractenWijzigenContractIdTeamGegevensRoute =
  BeheerContractenWijzigenContractIdTeamGegevensRouteImport.update({
    id: '/beheer/contracten/wijzigen/$contractId/team-gegevens',
    path: '/beheer/contracten/wijzigen/$contractId/team-gegevens',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerContractenWijzigenContractIdLocatiesRoute =
  BeheerContractenWijzigenContractIdLocatiesRouteImport.update({
    id: '/beheer/contracten/wijzigen/$contractId/locaties',
    path: '/beheer/contracten/wijzigen/$contractId/locaties',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerContractenWijzigenContractIdContractGegevensRoute =
  BeheerContractenWijzigenContractIdContractGegevensRouteImport.update({
    id: '/beheer/contracten/wijzigen/$contractId/contract-gegevens',
    path: '/beheer/contracten/wijzigen/$contractId/contract-gegevens',
    getParentRoute: () => rootRouteImport,
  } as any)
const BeheerContractenContractIdOrganisatiesOrganizationRoute =
  BeheerContractenContractIdOrganisatiesOrganizationRouteImport.update({
    id: '/organisaties/$organization',
    path: '/organisaties/$organization',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const BeheerContractenContractIdCorrespondentieThreadIdRoute =
  BeheerContractenContractIdCorrespondentieThreadIdRouteImport.update({
    id: '/correspondentie/$threadId',
    path: '/correspondentie/$threadId',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRoute =
  BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRouteImport.update({
    id: '/notities/$noteThreadId/',
    path: '/notities/$noteThreadId/',
    getParentRoute: () => BeheerOrganisatiesOrganizationIdRouteRoute,
  } as any)
const BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRoute =
  BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRouteImport.update({
    id: '/notities/$noteThreadId/',
    path: '/notities/$noteThreadId/',
    getParentRoute: () => BeheerLocatiesLocationIdRouteRoute,
  } as any)
const BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRoute =
  BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRouteImport.update({
    id: '/notities/$noteThreadId/',
    path: '/notities/$noteThreadId/',
    getParentRoute: () => BeheerGroepenGroupIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdRapportagesReportIdIndexRoute =
  BeheerCursistenStudentIdRapportagesReportIdIndexRouteImport.update({
    id: '/rapportages/$reportId/',
    path: '/rapportages/$reportId/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRoute =
  BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRouteImport.update({
    id: '/notities/$noteThreadId/',
    path: '/notities/$noteThreadId/',
    getParentRoute: () => BeheerCursistenStudentIdRouteRoute,
  } as any)
const BeheerContractenContractIdNotitiesNoteThreadIdIndexRoute =
  BeheerContractenContractIdNotitiesNoteThreadIdIndexRouteImport.update({
    id: '/notities/$noteThreadId/',
    path: '/notities/$noteThreadId/',
    getParentRoute: () => BeheerContractenContractIdRouteRoute,
  } as any)
const BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRoute =
  BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRouteImport.update(
    {
      id: '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/',
      path: '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/',
      getParentRoute: () => rootRouteImport,
    } as any,
  )
const BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRoute =
  BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRouteImport.update(
    {
      id: '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen',
      path: '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen',
      getParentRoute: () => rootRouteImport,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/profiel': typeof ProfielRouteRouteWithChildren
  '/test-support': typeof TestSupportRouteRouteWithChildren
  '/todo': typeof TodoRouteRouteWithChildren
  '/correspondentie/$threadId': typeof CorrespondentieThreadIdRoute
  '/login/$token': typeof LoginTokenRoute
  '/onboarding/$token': typeof OnboardingTokenRoute
  '/onboarding/ongeldige_token': typeof OnboardingOngeldige_tokenRoute
  '/test-support/rapportage-todo-aanmaken': typeof TestSupportRapportageTodoAanmakenRoute
  '/agenda/': typeof AgendaIndexRoute
  '/beheer/': typeof BeheerIndexRoute
  '/correspondentie/': typeof CorrespondentieIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/duo/': typeof DuoIndexRoute
  '/facturatie/': typeof FacturatieIndexRoute
  '/freelancer_omzetten/': typeof Freelancer_omzettenIndexRoute
  '/geen-rol/': typeof GeenRolIndexRoute
  '/login/': typeof LoginIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/test-support/': typeof TestSupportIndexRoute
  '/todo/': typeof TodoIndexRoute
  '/beheer/contactpersonen/$organizationUserId': typeof BeheerContactpersonenOrganizationUserIdRouteRouteWithChildren
  '/beheer/contracten/$contractId': typeof BeheerContractenContractIdRouteRouteWithChildren
  '/beheer/cursisten/$studentId': typeof BeheerCursistenStudentIdRouteRouteWithChildren
  '/beheer/groepen/$groupId': typeof BeheerGroepenGroupIdRouteRouteWithChildren
  '/beheer/laptops/$laptopId': typeof BeheerLaptopsLaptopIdRouteRouteWithChildren
  '/beheer/leerlijnen/$learningPathId': typeof BeheerLeerlijnenLearningPathIdRouteRouteWithChildren
  '/beheer/locaties/$locationId': typeof BeheerLocatiesLocationIdRouteRouteWithChildren
  '/beheer/medewerkers/$userId': typeof BeheerMedewerkersUserIdRouteRouteWithChildren
  '/beheer/organisaties/$organizationId': typeof BeheerOrganisatiesOrganizationIdRouteRouteWithChildren
  '/agenda/les/$lessonId': typeof AgendaLesLessonIdRoute
  '/beheer/contactpersonen/aanmaken': typeof BeheerContactpersonenAanmakenRoute
  '/beheer/cursisten/aanmaken': typeof BeheerCursistenAanmakenRoute
  '/beheer/groepen/aanmaken': typeof BeheerGroepenAanmakenRoute
  '/beheer/intakes/aanmaken': typeof BeheerIntakesAanmakenRoute
  '/beheer/intakes/intake-plannen': typeof BeheerIntakesIntakePlannenRoute
  '/beheer/laptops/aanmaken': typeof BeheerLaptopsAanmakenRoute
  '/beheer/leerlijnen/aanmaken': typeof BeheerLeerlijnenAanmakenRoute
  '/beheer/lessen/nieuwe-les': typeof BeheerLessenNieuweLesRoute
  '/beheer/organisaties/aanmaken': typeof BeheerOrganisatiesAanmakenRoute
  '/auth/confirm_account/': typeof AuthConfirm_accountIndexRoute
  '/auth/failed_sso/': typeof AuthFailed_ssoIndexRoute
  '/auth/sso_callback/': typeof AuthSso_callbackIndexRoute
  '/beheer/contactpersonen/': typeof BeheerContactpersonenIndexRoute
  '/beheer/contracten/': typeof BeheerContractenIndexRoute
  '/beheer/cursisten/': typeof BeheerCursistenIndexRoute
  '/beheer/feestdagen/': typeof BeheerFeestdagenIndexRoute
  '/beheer/groepen/': typeof BeheerGroepenIndexRoute
  '/beheer/intakes/': typeof BeheerIntakesIndexRoute
  '/beheer/laptops/': typeof BeheerLaptopsIndexRoute
  '/beheer/leerlijnen/': typeof BeheerLeerlijnenIndexRoute
  '/beheer/lesmaterialen/': typeof BeheerLesmaterialenIndexRoute
  '/beheer/lessen/': typeof BeheerLessenIndexRoute
  '/beheer/locaties/': typeof BeheerLocatiesIndexRoute
  '/beheer/medewerkers/': typeof BeheerMedewerkersIndexRoute
  '/beheer/organisaties/': typeof BeheerOrganisatiesIndexRoute
  '/beheer/roosters/': typeof BeheerRoostersIndexRoute
  '/beheer/toetsen/': typeof BeheerToetsenIndexRoute
  '/duo/contractenlijsten/': typeof DuoContractenlijstenIndexRoute
  '/duo/examenresultaten/': typeof DuoExamenresultatenIndexRoute
  '/duo/facturen/': typeof DuoFacturenIndexRoute
  '/duo/terugmeldingen/': typeof DuoTerugmeldingenIndexRoute
  '/facturatie/cursisten/': typeof FacturatieCursistenIndexRoute
  '/facturatie/facturen/': typeof FacturatieFacturenIndexRoute
  '/onboarding/docent-onboarding/': typeof OnboardingDocentOnboardingIndexRoute
  '/profiel/agenda/': typeof ProfielAgendaIndexRoute
  '/profiel/beschikbaarheid/': typeof ProfielBeschikbaarheidIndexRoute
  '/profiel/dossier/': typeof ProfielDossierIndexRoute
  '/profiel/groepen/': typeof ProfielGroepenIndexRoute
  '/profiel/lesbevoegdheid/': typeof ProfielLesbevoegdheidIndexRoute
  '/profiel/locaties/': typeof ProfielLocatiesIndexRoute
  '/profiel/persoonlijke_gegevens/': typeof ProfielPersoonlijke_gegevensIndexRoute
  '/profiel/zakelijke_gegevens/': typeof ProfielZakelijke_gegevensIndexRoute
  '/beheer/laptops/$laptopId/leengeschiedenis': typeof BeheerLaptopsLaptopIdLeengeschiedenisRoute
  '/beheer/todo/$studentRegistrationId/controleren': typeof BeheerTodoStudentRegistrationIdControlerenRoute
  '/beheer/todo/$studentRegistrationId/vergelijken': typeof BeheerTodoStudentRegistrationIdVergelijkenRoute
  '/facturatie/cursisten/$studentId/factuur-genereren': typeof FacturatieCursistenStudentIdFactuurGenererenRoute
  '/beheer/contracten/$contractId/': typeof BeheerContractenContractIdIndexRoute
  '/beheer/contracten/nieuw-contract/': typeof BeheerContractenNieuwContractIndexRoute
  '/beheer/feestdagen/aanmaken/': typeof BeheerFeestdagenAanmakenIndexRoute
  '/beheer/intakes/$intakeId/': typeof BeheerIntakesIntakeIdIndexRoute
  '/beheer/leerlijnen/$learningPathId/': typeof BeheerLeerlijnenLearningPathIdIndexRoute
  '/beheer/lesmaterialen/aanmaken/': typeof BeheerLesmaterialenAanmakenIndexRoute
  '/beheer/locaties/$locationId/': typeof BeheerLocatiesLocationIdIndexRoute
  '/beheer/locaties/aanmaken/': typeof BeheerLocatiesAanmakenIndexRoute
  '/beheer/organisaties/$organizationId/': typeof BeheerOrganisatiesOrganizationIdIndexRoute
  '/beheer/toetsen/aanmaken/': typeof BeheerToetsenAanmakenIndexRoute
  '/facturatie/facturen/$invoiceId/': typeof FacturatieFacturenInvoiceIdIndexRoute
  '/profiel/beschikbaarheid/invullen/': typeof ProfielBeschikbaarheidInvullenIndexRoute
  '/profiel/lesbevoegdheid/invullen/': typeof ProfielLesbevoegdheidInvullenIndexRoute
  '/profiel/zakelijke_gegevens/invullen/': typeof ProfielZakelijke_gegevensInvullenIndexRoute
  '/todo/$category/$todoId/': typeof TodoCategoryTodoIdIndexRoute
  '/beheer/contracten/$contractId/correspondentie/$threadId': typeof BeheerContractenContractIdCorrespondentieThreadIdRoute
  '/beheer/contracten/$contractId/organisaties/$organization': typeof BeheerContractenContractIdOrganisatiesOrganizationRoute
  '/beheer/contracten/wijzigen/$contractId/contract-gegevens': typeof BeheerContractenWijzigenContractIdContractGegevensRoute
  '/beheer/contracten/wijzigen/$contractId/locaties': typeof BeheerContractenWijzigenContractIdLocatiesRoute
  '/beheer/contracten/wijzigen/$contractId/team-gegevens': typeof BeheerContractenWijzigenContractIdTeamGegevensRoute
  '/beheer/contracten/wijzigen/$contractId/vakanties': typeof BeheerContractenWijzigenContractIdVakantiesRoute
  '/beheer/cursisten/$studentId/correspondentie/$threadId': typeof BeheerCursistenStudentIdCorrespondentieThreadIdRoute
  '/beheer/groepen/$groupId/correspondentie/$threadId': typeof BeheerGroepenGroupIdCorrespondentieThreadIdRoute
  '/beheer/groepen/$groupId/lessen/nieuwe-les': typeof BeheerGroepenGroupIdLessenNieuweLesRoute
  '/beheer/groepen/$groupId/toets-overzicht/$entryId': typeof BeheerGroepenGroupIdToetsOverzichtEntryIdRoute
  '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen': typeof BeheerGroepenWijzigenGroupIdLocatiesWijzigenRoute
  '/beheer/leerlijnen/$learningPathId/modules/$moduleId': typeof BeheerLeerlijnenLearningPathIdModulesModuleIdRoute
  '/beheer/locaties/$locationId/classrooms/$classroom': typeof BeheerLocatiesLocationIdClassroomsClassroomRoute
  '/beheer/medewerkers/$userId/lesbevoegdheid/controleren': typeof BeheerMedewerkersUserIdLesbevoegdheidControlerenRoute
  '/beheer/organisaties/$organizationId/contactpersonen/aanmaken': typeof BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRoute
  '/beheer/contactpersonen/$organizationUserId/gegevens/': typeof BeheerContactpersonenOrganizationUserIdGegevensIndexRoute
  '/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten/': typeof BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRoute
  '/beheer/contracten/$contractId/correspondentie/': typeof BeheerContractenContractIdCorrespondentieIndexRoute
  '/beheer/contracten/$contractId/dossier/': typeof BeheerContractenContractIdDossierIndexRoute
  '/beheer/contracten/$contractId/gegevens/': typeof BeheerContractenContractIdGegevensIndexRoute
  '/beheer/contracten/$contractId/notities/': typeof BeheerContractenContractIdNotitiesIndexRoute
  '/beheer/cursisten/$studentId/beschikbaarheid/': typeof BeheerCursistenStudentIdBeschikbaarheidIndexRoute
  '/beheer/cursisten/$studentId/correspondentie/': typeof BeheerCursistenStudentIdCorrespondentieIndexRoute
  '/beheer/cursisten/$studentId/documenten/': typeof BeheerCursistenStudentIdDocumentenIndexRoute
  '/beheer/cursisten/$studentId/examenresultaten/': typeof BeheerCursistenStudentIdExamenresultatenIndexRoute
  '/beheer/cursisten/$studentId/gegevens/': typeof BeheerCursistenStudentIdGegevensIndexRoute
  '/beheer/cursisten/$studentId/intake/': typeof BeheerCursistenStudentIdIntakeIndexRoute
  '/beheer/cursisten/$studentId/laptops/': typeof BeheerCursistenStudentIdLaptopsIndexRoute
  '/beheer/cursisten/$studentId/lessen/': typeof BeheerCursistenStudentIdLessenIndexRoute
  '/beheer/cursisten/$studentId/notities/': typeof BeheerCursistenStudentIdNotitiesIndexRoute
  '/beheer/cursisten/$studentId/rapportages/': typeof BeheerCursistenStudentIdRapportagesIndexRoute
  '/beheer/cursisten/$studentId/tweede-aanspreekpunt/': typeof BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute
  '/beheer/cursisten/$studentId/voortgang/': typeof BeheerCursistenStudentIdVoortgangIndexRoute
  '/beheer/groepen/$groupId/correspondentie/': typeof BeheerGroepenGroupIdCorrespondentieIndexRoute
  '/beheer/groepen/$groupId/documenten/': typeof BeheerGroepenGroupIdDocumentenIndexRoute
  '/beheer/groepen/$groupId/gegevens/': typeof BeheerGroepenGroupIdGegevensIndexRoute
  '/beheer/groepen/$groupId/lesmaterialen/': typeof BeheerGroepenGroupIdLesmaterialenIndexRoute
  '/beheer/groepen/$groupId/lessen/': typeof BeheerGroepenGroupIdLessenIndexRoute
  '/beheer/groepen/$groupId/notities/': typeof BeheerGroepenGroupIdNotitiesIndexRoute
  '/beheer/groepen/$groupId/presentie-overzicht/': typeof BeheerGroepenGroupIdPresentieOverzichtIndexRoute
  '/beheer/groepen/$groupId/rooster/': typeof BeheerGroepenGroupIdRoosterIndexRoute
  '/beheer/groepen/$groupId/students/': typeof BeheerGroepenGroupIdStudentsIndexRoute
  '/beheer/groepen/$groupId/toets-overzicht/': typeof BeheerGroepenGroupIdToetsOverzichtIndexRoute
  '/beheer/locaties/$locationId/documenten/': typeof BeheerLocatiesLocationIdDocumentenIndexRoute
  '/beheer/locaties/$locationId/gegevens/': typeof BeheerLocatiesLocationIdGegevensIndexRoute
  '/beheer/locaties/$locationId/notities/': typeof BeheerLocatiesLocationIdNotitiesIndexRoute
  '/beheer/medewerkers/$userId/agenda/': typeof BeheerMedewerkersUserIdAgendaIndexRoute
  '/beheer/medewerkers/$userId/beschikbaarheid/': typeof BeheerMedewerkersUserIdBeschikbaarheidIndexRoute
  '/beheer/medewerkers/$userId/dossier/': typeof BeheerMedewerkersUserIdDossierIndexRoute
  '/beheer/medewerkers/$userId/groepen/': typeof BeheerMedewerkersUserIdGroepenIndexRoute
  '/beheer/medewerkers/$userId/lesbevoegdheid/': typeof BeheerMedewerkersUserIdLesbevoegdheidIndexRoute
  '/beheer/medewerkers/$userId/leslocaties/': typeof BeheerMedewerkersUserIdLeslocatiesIndexRoute
  '/beheer/medewerkers/$userId/persoonlijke_gegevens/': typeof BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRoute
  '/beheer/medewerkers/$userId/zakelijke_gegevens/': typeof BeheerMedewerkersUserIdZakelijke_gegevensIndexRoute
  '/beheer/organisaties/$organizationId/contactpersonen/': typeof BeheerOrganisatiesOrganizationIdContactpersonenIndexRoute
  '/beheer/organisaties/$organizationId/contracten/': typeof BeheerOrganisatiesOrganizationIdContractenIndexRoute
  '/beheer/organisaties/$organizationId/cursisten/': typeof BeheerOrganisatiesOrganizationIdCursistenIndexRoute
  '/beheer/organisaties/$organizationId/documenten/': typeof BeheerOrganisatiesOrganizationIdDocumentenIndexRoute
  '/beheer/organisaties/$organizationId/gegevens/': typeof BeheerOrganisatiesOrganizationIdGegevensIndexRoute
  '/beheer/organisaties/$organizationId/notities/': typeof BeheerOrganisatiesOrganizationIdNotitiesIndexRoute
  '/beheer/contracten/$contractId/notities/$noteThreadId/': typeof BeheerContractenContractIdNotitiesNoteThreadIdIndexRoute
  '/beheer/cursisten/$studentId/notities/$noteThreadId/': typeof BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRoute
  '/beheer/cursisten/$studentId/rapportages/$reportId/': typeof BeheerCursistenStudentIdRapportagesReportIdIndexRoute
  '/beheer/groepen/$groupId/notities/$noteThreadId/': typeof BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRoute
  '/beheer/locaties/$locationId/notities/$noteThreadId/': typeof BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRoute
  '/beheer/organisaties/$organizationId/notities/$noteThreadId/': typeof BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRoute
  '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen': typeof BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRoute
  '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/': typeof BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/profiel': typeof ProfielRouteRouteWithChildren
  '/correspondentie/$threadId': typeof CorrespondentieThreadIdRoute
  '/login/$token': typeof LoginTokenRoute
  '/onboarding/$token': typeof OnboardingTokenRoute
  '/onboarding/ongeldige_token': typeof OnboardingOngeldige_tokenRoute
  '/test-support/rapportage-todo-aanmaken': typeof TestSupportRapportageTodoAanmakenRoute
  '/agenda': typeof AgendaIndexRoute
  '/beheer': typeof BeheerIndexRoute
  '/correspondentie': typeof CorrespondentieIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/duo': typeof DuoIndexRoute
  '/facturatie': typeof FacturatieIndexRoute
  '/freelancer_omzetten': typeof Freelancer_omzettenIndexRoute
  '/geen-rol': typeof GeenRolIndexRoute
  '/login': typeof LoginIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/test-support': typeof TestSupportIndexRoute
  '/todo': typeof TodoIndexRoute
  '/beheer/contactpersonen/$organizationUserId': typeof BeheerContactpersonenOrganizationUserIdRouteRouteWithChildren
  '/beheer/cursisten/$studentId': typeof BeheerCursistenStudentIdRouteRouteWithChildren
  '/beheer/groepen/$groupId': typeof BeheerGroepenGroupIdRouteRouteWithChildren
  '/beheer/laptops/$laptopId': typeof BeheerLaptopsLaptopIdRouteRouteWithChildren
  '/beheer/medewerkers/$userId': typeof BeheerMedewerkersUserIdRouteRouteWithChildren
  '/agenda/les/$lessonId': typeof AgendaLesLessonIdRoute
  '/beheer/contactpersonen/aanmaken': typeof BeheerContactpersonenAanmakenRoute
  '/beheer/cursisten/aanmaken': typeof BeheerCursistenAanmakenRoute
  '/beheer/groepen/aanmaken': typeof BeheerGroepenAanmakenRoute
  '/beheer/intakes/aanmaken': typeof BeheerIntakesAanmakenRoute
  '/beheer/intakes/intake-plannen': typeof BeheerIntakesIntakePlannenRoute
  '/beheer/laptops/aanmaken': typeof BeheerLaptopsAanmakenRoute
  '/beheer/leerlijnen/aanmaken': typeof BeheerLeerlijnenAanmakenRoute
  '/beheer/lessen/nieuwe-les': typeof BeheerLessenNieuweLesRoute
  '/beheer/organisaties/aanmaken': typeof BeheerOrganisatiesAanmakenRoute
  '/auth/confirm_account': typeof AuthConfirm_accountIndexRoute
  '/auth/failed_sso': typeof AuthFailed_ssoIndexRoute
  '/auth/sso_callback': typeof AuthSso_callbackIndexRoute
  '/beheer/contactpersonen': typeof BeheerContactpersonenIndexRoute
  '/beheer/contracten': typeof BeheerContractenIndexRoute
  '/beheer/cursisten': typeof BeheerCursistenIndexRoute
  '/beheer/feestdagen': typeof BeheerFeestdagenIndexRoute
  '/beheer/groepen': typeof BeheerGroepenIndexRoute
  '/beheer/intakes': typeof BeheerIntakesIndexRoute
  '/beheer/laptops': typeof BeheerLaptopsIndexRoute
  '/beheer/leerlijnen': typeof BeheerLeerlijnenIndexRoute
  '/beheer/lesmaterialen': typeof BeheerLesmaterialenIndexRoute
  '/beheer/lessen': typeof BeheerLessenIndexRoute
  '/beheer/locaties': typeof BeheerLocatiesIndexRoute
  '/beheer/medewerkers': typeof BeheerMedewerkersIndexRoute
  '/beheer/organisaties': typeof BeheerOrganisatiesIndexRoute
  '/beheer/roosters': typeof BeheerRoostersIndexRoute
  '/beheer/toetsen': typeof BeheerToetsenIndexRoute
  '/duo/contractenlijsten': typeof DuoContractenlijstenIndexRoute
  '/duo/examenresultaten': typeof DuoExamenresultatenIndexRoute
  '/duo/facturen': typeof DuoFacturenIndexRoute
  '/duo/terugmeldingen': typeof DuoTerugmeldingenIndexRoute
  '/facturatie/cursisten': typeof FacturatieCursistenIndexRoute
  '/facturatie/facturen': typeof FacturatieFacturenIndexRoute
  '/onboarding/docent-onboarding': typeof OnboardingDocentOnboardingIndexRoute
  '/profiel/agenda': typeof ProfielAgendaIndexRoute
  '/profiel/beschikbaarheid': typeof ProfielBeschikbaarheidIndexRoute
  '/profiel/dossier': typeof ProfielDossierIndexRoute
  '/profiel/groepen': typeof ProfielGroepenIndexRoute
  '/profiel/lesbevoegdheid': typeof ProfielLesbevoegdheidIndexRoute
  '/profiel/locaties': typeof ProfielLocatiesIndexRoute
  '/profiel/persoonlijke_gegevens': typeof ProfielPersoonlijke_gegevensIndexRoute
  '/profiel/zakelijke_gegevens': typeof ProfielZakelijke_gegevensIndexRoute
  '/beheer/laptops/$laptopId/leengeschiedenis': typeof BeheerLaptopsLaptopIdLeengeschiedenisRoute
  '/beheer/todo/$studentRegistrationId/controleren': typeof BeheerTodoStudentRegistrationIdControlerenRoute
  '/beheer/todo/$studentRegistrationId/vergelijken': typeof BeheerTodoStudentRegistrationIdVergelijkenRoute
  '/facturatie/cursisten/$studentId/factuur-genereren': typeof FacturatieCursistenStudentIdFactuurGenererenRoute
  '/beheer/contracten/$contractId': typeof BeheerContractenContractIdIndexRoute
  '/beheer/contracten/nieuw-contract': typeof BeheerContractenNieuwContractIndexRoute
  '/beheer/feestdagen/aanmaken': typeof BeheerFeestdagenAanmakenIndexRoute
  '/beheer/intakes/$intakeId': typeof BeheerIntakesIntakeIdIndexRoute
  '/beheer/leerlijnen/$learningPathId': typeof BeheerLeerlijnenLearningPathIdIndexRoute
  '/beheer/lesmaterialen/aanmaken': typeof BeheerLesmaterialenAanmakenIndexRoute
  '/beheer/locaties/$locationId': typeof BeheerLocatiesLocationIdIndexRoute
  '/beheer/locaties/aanmaken': typeof BeheerLocatiesAanmakenIndexRoute
  '/beheer/organisaties/$organizationId': typeof BeheerOrganisatiesOrganizationIdIndexRoute
  '/beheer/toetsen/aanmaken': typeof BeheerToetsenAanmakenIndexRoute
  '/facturatie/facturen/$invoiceId': typeof FacturatieFacturenInvoiceIdIndexRoute
  '/profiel/beschikbaarheid/invullen': typeof ProfielBeschikbaarheidInvullenIndexRoute
  '/profiel/lesbevoegdheid/invullen': typeof ProfielLesbevoegdheidInvullenIndexRoute
  '/profiel/zakelijke_gegevens/invullen': typeof ProfielZakelijke_gegevensInvullenIndexRoute
  '/todo/$category/$todoId': typeof TodoCategoryTodoIdIndexRoute
  '/beheer/contracten/$contractId/correspondentie/$threadId': typeof BeheerContractenContractIdCorrespondentieThreadIdRoute
  '/beheer/contracten/$contractId/organisaties/$organization': typeof BeheerContractenContractIdOrganisatiesOrganizationRoute
  '/beheer/contracten/wijzigen/$contractId/contract-gegevens': typeof BeheerContractenWijzigenContractIdContractGegevensRoute
  '/beheer/contracten/wijzigen/$contractId/locaties': typeof BeheerContractenWijzigenContractIdLocatiesRoute
  '/beheer/contracten/wijzigen/$contractId/team-gegevens': typeof BeheerContractenWijzigenContractIdTeamGegevensRoute
  '/beheer/contracten/wijzigen/$contractId/vakanties': typeof BeheerContractenWijzigenContractIdVakantiesRoute
  '/beheer/cursisten/$studentId/correspondentie/$threadId': typeof BeheerCursistenStudentIdCorrespondentieThreadIdRoute
  '/beheer/groepen/$groupId/correspondentie/$threadId': typeof BeheerGroepenGroupIdCorrespondentieThreadIdRoute
  '/beheer/groepen/$groupId/lessen/nieuwe-les': typeof BeheerGroepenGroupIdLessenNieuweLesRoute
  '/beheer/groepen/$groupId/toets-overzicht/$entryId': typeof BeheerGroepenGroupIdToetsOverzichtEntryIdRoute
  '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen': typeof BeheerGroepenWijzigenGroupIdLocatiesWijzigenRoute
  '/beheer/leerlijnen/$learningPathId/modules/$moduleId': typeof BeheerLeerlijnenLearningPathIdModulesModuleIdRoute
  '/beheer/locaties/$locationId/classrooms/$classroom': typeof BeheerLocatiesLocationIdClassroomsClassroomRoute
  '/beheer/medewerkers/$userId/lesbevoegdheid/controleren': typeof BeheerMedewerkersUserIdLesbevoegdheidControlerenRoute
  '/beheer/organisaties/$organizationId/contactpersonen/aanmaken': typeof BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRoute
  '/beheer/contactpersonen/$organizationUserId/gegevens': typeof BeheerContactpersonenOrganizationUserIdGegevensIndexRoute
  '/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten': typeof BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRoute
  '/beheer/contracten/$contractId/correspondentie': typeof BeheerContractenContractIdCorrespondentieIndexRoute
  '/beheer/contracten/$contractId/dossier': typeof BeheerContractenContractIdDossierIndexRoute
  '/beheer/contracten/$contractId/gegevens': typeof BeheerContractenContractIdGegevensIndexRoute
  '/beheer/contracten/$contractId/notities': typeof BeheerContractenContractIdNotitiesIndexRoute
  '/beheer/cursisten/$studentId/beschikbaarheid': typeof BeheerCursistenStudentIdBeschikbaarheidIndexRoute
  '/beheer/cursisten/$studentId/correspondentie': typeof BeheerCursistenStudentIdCorrespondentieIndexRoute
  '/beheer/cursisten/$studentId/documenten': typeof BeheerCursistenStudentIdDocumentenIndexRoute
  '/beheer/cursisten/$studentId/examenresultaten': typeof BeheerCursistenStudentIdExamenresultatenIndexRoute
  '/beheer/cursisten/$studentId/gegevens': typeof BeheerCursistenStudentIdGegevensIndexRoute
  '/beheer/cursisten/$studentId/intake': typeof BeheerCursistenStudentIdIntakeIndexRoute
  '/beheer/cursisten/$studentId/laptops': typeof BeheerCursistenStudentIdLaptopsIndexRoute
  '/beheer/cursisten/$studentId/lessen': typeof BeheerCursistenStudentIdLessenIndexRoute
  '/beheer/cursisten/$studentId/notities': typeof BeheerCursistenStudentIdNotitiesIndexRoute
  '/beheer/cursisten/$studentId/rapportages': typeof BeheerCursistenStudentIdRapportagesIndexRoute
  '/beheer/cursisten/$studentId/tweede-aanspreekpunt': typeof BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute
  '/beheer/cursisten/$studentId/voortgang': typeof BeheerCursistenStudentIdVoortgangIndexRoute
  '/beheer/groepen/$groupId/correspondentie': typeof BeheerGroepenGroupIdCorrespondentieIndexRoute
  '/beheer/groepen/$groupId/documenten': typeof BeheerGroepenGroupIdDocumentenIndexRoute
  '/beheer/groepen/$groupId/gegevens': typeof BeheerGroepenGroupIdGegevensIndexRoute
  '/beheer/groepen/$groupId/lesmaterialen': typeof BeheerGroepenGroupIdLesmaterialenIndexRoute
  '/beheer/groepen/$groupId/lessen': typeof BeheerGroepenGroupIdLessenIndexRoute
  '/beheer/groepen/$groupId/notities': typeof BeheerGroepenGroupIdNotitiesIndexRoute
  '/beheer/groepen/$groupId/presentie-overzicht': typeof BeheerGroepenGroupIdPresentieOverzichtIndexRoute
  '/beheer/groepen/$groupId/rooster': typeof BeheerGroepenGroupIdRoosterIndexRoute
  '/beheer/groepen/$groupId/students': typeof BeheerGroepenGroupIdStudentsIndexRoute
  '/beheer/groepen/$groupId/toets-overzicht': typeof BeheerGroepenGroupIdToetsOverzichtIndexRoute
  '/beheer/locaties/$locationId/documenten': typeof BeheerLocatiesLocationIdDocumentenIndexRoute
  '/beheer/locaties/$locationId/gegevens': typeof BeheerLocatiesLocationIdGegevensIndexRoute
  '/beheer/locaties/$locationId/notities': typeof BeheerLocatiesLocationIdNotitiesIndexRoute
  '/beheer/medewerkers/$userId/agenda': typeof BeheerMedewerkersUserIdAgendaIndexRoute
  '/beheer/medewerkers/$userId/beschikbaarheid': typeof BeheerMedewerkersUserIdBeschikbaarheidIndexRoute
  '/beheer/medewerkers/$userId/dossier': typeof BeheerMedewerkersUserIdDossierIndexRoute
  '/beheer/medewerkers/$userId/groepen': typeof BeheerMedewerkersUserIdGroepenIndexRoute
  '/beheer/medewerkers/$userId/lesbevoegdheid': typeof BeheerMedewerkersUserIdLesbevoegdheidIndexRoute
  '/beheer/medewerkers/$userId/leslocaties': typeof BeheerMedewerkersUserIdLeslocatiesIndexRoute
  '/beheer/medewerkers/$userId/persoonlijke_gegevens': typeof BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRoute
  '/beheer/medewerkers/$userId/zakelijke_gegevens': typeof BeheerMedewerkersUserIdZakelijke_gegevensIndexRoute
  '/beheer/organisaties/$organizationId/contactpersonen': typeof BeheerOrganisatiesOrganizationIdContactpersonenIndexRoute
  '/beheer/organisaties/$organizationId/contracten': typeof BeheerOrganisatiesOrganizationIdContractenIndexRoute
  '/beheer/organisaties/$organizationId/cursisten': typeof BeheerOrganisatiesOrganizationIdCursistenIndexRoute
  '/beheer/organisaties/$organizationId/documenten': typeof BeheerOrganisatiesOrganizationIdDocumentenIndexRoute
  '/beheer/organisaties/$organizationId/gegevens': typeof BeheerOrganisatiesOrganizationIdGegevensIndexRoute
  '/beheer/organisaties/$organizationId/notities': typeof BeheerOrganisatiesOrganizationIdNotitiesIndexRoute
  '/beheer/contracten/$contractId/notities/$noteThreadId': typeof BeheerContractenContractIdNotitiesNoteThreadIdIndexRoute
  '/beheer/cursisten/$studentId/notities/$noteThreadId': typeof BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRoute
  '/beheer/cursisten/$studentId/rapportages/$reportId': typeof BeheerCursistenStudentIdRapportagesReportIdIndexRoute
  '/beheer/groepen/$groupId/notities/$noteThreadId': typeof BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRoute
  '/beheer/locaties/$locationId/notities/$noteThreadId': typeof BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRoute
  '/beheer/organisaties/$organizationId/notities/$noteThreadId': typeof BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRoute
  '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen': typeof BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRoute
  '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId': typeof BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/profiel': typeof ProfielRouteRouteWithChildren
  '/test-support': typeof TestSupportRouteRouteWithChildren
  '/todo': typeof TodoRouteRouteWithChildren
  '/correspondentie/$threadId': typeof CorrespondentieThreadIdRoute
  '/login/$token': typeof LoginTokenRoute
  '/onboarding/$token': typeof OnboardingTokenRoute
  '/onboarding/ongeldige_token': typeof OnboardingOngeldige_tokenRoute
  '/test-support/rapportage-todo-aanmaken': typeof TestSupportRapportageTodoAanmakenRoute
  '/agenda/': typeof AgendaIndexRoute
  '/beheer/': typeof BeheerIndexRoute
  '/correspondentie/': typeof CorrespondentieIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/duo/': typeof DuoIndexRoute
  '/facturatie/': typeof FacturatieIndexRoute
  '/freelancer_omzetten/': typeof Freelancer_omzettenIndexRoute
  '/geen-rol/': typeof GeenRolIndexRoute
  '/login/': typeof LoginIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/test-support/': typeof TestSupportIndexRoute
  '/todo/': typeof TodoIndexRoute
  '/beheer/contactpersonen/$organizationUserId': typeof BeheerContactpersonenOrganizationUserIdRouteRouteWithChildren
  '/beheer/contracten/$contractId': typeof BeheerContractenContractIdRouteRouteWithChildren
  '/beheer/cursisten/$studentId': typeof BeheerCursistenStudentIdRouteRouteWithChildren
  '/beheer/groepen/$groupId': typeof BeheerGroepenGroupIdRouteRouteWithChildren
  '/beheer/laptops/$laptopId': typeof BeheerLaptopsLaptopIdRouteRouteWithChildren
  '/beheer/leerlijnen/$learningPathId': typeof BeheerLeerlijnenLearningPathIdRouteRouteWithChildren
  '/beheer/locaties/$locationId': typeof BeheerLocatiesLocationIdRouteRouteWithChildren
  '/beheer/medewerkers/$userId': typeof BeheerMedewerkersUserIdRouteRouteWithChildren
  '/beheer/organisaties/$organizationId': typeof BeheerOrganisatiesOrganizationIdRouteRouteWithChildren
  '/agenda/les/$lessonId': typeof AgendaLesLessonIdRoute
  '/beheer/contactpersonen/aanmaken': typeof BeheerContactpersonenAanmakenRoute
  '/beheer/cursisten/aanmaken': typeof BeheerCursistenAanmakenRoute
  '/beheer/groepen/aanmaken': typeof BeheerGroepenAanmakenRoute
  '/beheer/intakes/aanmaken': typeof BeheerIntakesAanmakenRoute
  '/beheer/intakes/intake-plannen': typeof BeheerIntakesIntakePlannenRoute
  '/beheer/laptops/aanmaken': typeof BeheerLaptopsAanmakenRoute
  '/beheer/leerlijnen/aanmaken': typeof BeheerLeerlijnenAanmakenRoute
  '/beheer/lessen/nieuwe-les': typeof BeheerLessenNieuweLesRoute
  '/beheer/organisaties/aanmaken': typeof BeheerOrganisatiesAanmakenRoute
  '/auth/confirm_account/': typeof AuthConfirm_accountIndexRoute
  '/auth/failed_sso/': typeof AuthFailed_ssoIndexRoute
  '/auth/sso_callback/': typeof AuthSso_callbackIndexRoute
  '/beheer/contactpersonen/': typeof BeheerContactpersonenIndexRoute
  '/beheer/contracten/': typeof BeheerContractenIndexRoute
  '/beheer/cursisten/': typeof BeheerCursistenIndexRoute
  '/beheer/feestdagen/': typeof BeheerFeestdagenIndexRoute
  '/beheer/groepen/': typeof BeheerGroepenIndexRoute
  '/beheer/intakes/': typeof BeheerIntakesIndexRoute
  '/beheer/laptops/': typeof BeheerLaptopsIndexRoute
  '/beheer/leerlijnen/': typeof BeheerLeerlijnenIndexRoute
  '/beheer/lesmaterialen/': typeof BeheerLesmaterialenIndexRoute
  '/beheer/lessen/': typeof BeheerLessenIndexRoute
  '/beheer/locaties/': typeof BeheerLocatiesIndexRoute
  '/beheer/medewerkers/': typeof BeheerMedewerkersIndexRoute
  '/beheer/organisaties/': typeof BeheerOrganisatiesIndexRoute
  '/beheer/roosters/': typeof BeheerRoostersIndexRoute
  '/beheer/toetsen/': typeof BeheerToetsenIndexRoute
  '/duo/contractenlijsten/': typeof DuoContractenlijstenIndexRoute
  '/duo/examenresultaten/': typeof DuoExamenresultatenIndexRoute
  '/duo/facturen/': typeof DuoFacturenIndexRoute
  '/duo/terugmeldingen/': typeof DuoTerugmeldingenIndexRoute
  '/facturatie/cursisten/': typeof FacturatieCursistenIndexRoute
  '/facturatie/facturen/': typeof FacturatieFacturenIndexRoute
  '/onboarding/docent-onboarding/': typeof OnboardingDocentOnboardingIndexRoute
  '/profiel/agenda/': typeof ProfielAgendaIndexRoute
  '/profiel/beschikbaarheid/': typeof ProfielBeschikbaarheidIndexRoute
  '/profiel/dossier/': typeof ProfielDossierIndexRoute
  '/profiel/groepen/': typeof ProfielGroepenIndexRoute
  '/profiel/lesbevoegdheid/': typeof ProfielLesbevoegdheidIndexRoute
  '/profiel/locaties/': typeof ProfielLocatiesIndexRoute
  '/profiel/persoonlijke_gegevens/': typeof ProfielPersoonlijke_gegevensIndexRoute
  '/profiel/zakelijke_gegevens/': typeof ProfielZakelijke_gegevensIndexRoute
  '/beheer/laptops/$laptopId/leengeschiedenis': typeof BeheerLaptopsLaptopIdLeengeschiedenisRoute
  '/beheer/todo/$studentRegistrationId/controleren': typeof BeheerTodoStudentRegistrationIdControlerenRoute
  '/beheer/todo/$studentRegistrationId/vergelijken': typeof BeheerTodoStudentRegistrationIdVergelijkenRoute
  '/facturatie/cursisten/$studentId/factuur-genereren': typeof FacturatieCursistenStudentIdFactuurGenererenRoute
  '/beheer/contracten/$contractId/': typeof BeheerContractenContractIdIndexRoute
  '/beheer/contracten/nieuw-contract/': typeof BeheerContractenNieuwContractIndexRoute
  '/beheer/feestdagen/aanmaken/': typeof BeheerFeestdagenAanmakenIndexRoute
  '/beheer/intakes/$intakeId/': typeof BeheerIntakesIntakeIdIndexRoute
  '/beheer/leerlijnen/$learningPathId/': typeof BeheerLeerlijnenLearningPathIdIndexRoute
  '/beheer/lesmaterialen/aanmaken/': typeof BeheerLesmaterialenAanmakenIndexRoute
  '/beheer/locaties/$locationId/': typeof BeheerLocatiesLocationIdIndexRoute
  '/beheer/locaties/aanmaken/': typeof BeheerLocatiesAanmakenIndexRoute
  '/beheer/organisaties/$organizationId/': typeof BeheerOrganisatiesOrganizationIdIndexRoute
  '/beheer/toetsen/aanmaken/': typeof BeheerToetsenAanmakenIndexRoute
  '/facturatie/facturen/$invoiceId/': typeof FacturatieFacturenInvoiceIdIndexRoute
  '/profiel/beschikbaarheid/invullen/': typeof ProfielBeschikbaarheidInvullenIndexRoute
  '/profiel/lesbevoegdheid/invullen/': typeof ProfielLesbevoegdheidInvullenIndexRoute
  '/profiel/zakelijke_gegevens/invullen/': typeof ProfielZakelijke_gegevensInvullenIndexRoute
  '/todo/$category/$todoId/': typeof TodoCategoryTodoIdIndexRoute
  '/beheer/contracten/$contractId/correspondentie/$threadId': typeof BeheerContractenContractIdCorrespondentieThreadIdRoute
  '/beheer/contracten/$contractId/organisaties/$organization': typeof BeheerContractenContractIdOrganisatiesOrganizationRoute
  '/beheer/contracten/wijzigen/$contractId/contract-gegevens': typeof BeheerContractenWijzigenContractIdContractGegevensRoute
  '/beheer/contracten/wijzigen/$contractId/locaties': typeof BeheerContractenWijzigenContractIdLocatiesRoute
  '/beheer/contracten/wijzigen/$contractId/team-gegevens': typeof BeheerContractenWijzigenContractIdTeamGegevensRoute
  '/beheer/contracten/wijzigen/$contractId/vakanties': typeof BeheerContractenWijzigenContractIdVakantiesRoute
  '/beheer/cursisten/$studentId/correspondentie/$threadId': typeof BeheerCursistenStudentIdCorrespondentieThreadIdRoute
  '/beheer/groepen/$groupId/correspondentie/$threadId': typeof BeheerGroepenGroupIdCorrespondentieThreadIdRoute
  '/beheer/groepen/$groupId/lessen/nieuwe-les': typeof BeheerGroepenGroupIdLessenNieuweLesRoute
  '/beheer/groepen/$groupId/toets-overzicht/$entryId': typeof BeheerGroepenGroupIdToetsOverzichtEntryIdRoute
  '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen': typeof BeheerGroepenWijzigenGroupIdLocatiesWijzigenRoute
  '/beheer/leerlijnen/$learningPathId/modules/$moduleId': typeof BeheerLeerlijnenLearningPathIdModulesModuleIdRoute
  '/beheer/locaties/$locationId/classrooms/$classroom': typeof BeheerLocatiesLocationIdClassroomsClassroomRoute
  '/beheer/medewerkers/$userId/lesbevoegdheid/controleren': typeof BeheerMedewerkersUserIdLesbevoegdheidControlerenRoute
  '/beheer/organisaties/$organizationId/contactpersonen/aanmaken': typeof BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRoute
  '/beheer/contactpersonen/$organizationUserId/gegevens/': typeof BeheerContactpersonenOrganizationUserIdGegevensIndexRoute
  '/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten/': typeof BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRoute
  '/beheer/contracten/$contractId/correspondentie/': typeof BeheerContractenContractIdCorrespondentieIndexRoute
  '/beheer/contracten/$contractId/dossier/': typeof BeheerContractenContractIdDossierIndexRoute
  '/beheer/contracten/$contractId/gegevens/': typeof BeheerContractenContractIdGegevensIndexRoute
  '/beheer/contracten/$contractId/notities/': typeof BeheerContractenContractIdNotitiesIndexRoute
  '/beheer/cursisten/$studentId/beschikbaarheid/': typeof BeheerCursistenStudentIdBeschikbaarheidIndexRoute
  '/beheer/cursisten/$studentId/correspondentie/': typeof BeheerCursistenStudentIdCorrespondentieIndexRoute
  '/beheer/cursisten/$studentId/documenten/': typeof BeheerCursistenStudentIdDocumentenIndexRoute
  '/beheer/cursisten/$studentId/examenresultaten/': typeof BeheerCursistenStudentIdExamenresultatenIndexRoute
  '/beheer/cursisten/$studentId/gegevens/': typeof BeheerCursistenStudentIdGegevensIndexRoute
  '/beheer/cursisten/$studentId/intake/': typeof BeheerCursistenStudentIdIntakeIndexRoute
  '/beheer/cursisten/$studentId/laptops/': typeof BeheerCursistenStudentIdLaptopsIndexRoute
  '/beheer/cursisten/$studentId/lessen/': typeof BeheerCursistenStudentIdLessenIndexRoute
  '/beheer/cursisten/$studentId/notities/': typeof BeheerCursistenStudentIdNotitiesIndexRoute
  '/beheer/cursisten/$studentId/rapportages/': typeof BeheerCursistenStudentIdRapportagesIndexRoute
  '/beheer/cursisten/$studentId/tweede-aanspreekpunt/': typeof BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute
  '/beheer/cursisten/$studentId/voortgang/': typeof BeheerCursistenStudentIdVoortgangIndexRoute
  '/beheer/groepen/$groupId/correspondentie/': typeof BeheerGroepenGroupIdCorrespondentieIndexRoute
  '/beheer/groepen/$groupId/documenten/': typeof BeheerGroepenGroupIdDocumentenIndexRoute
  '/beheer/groepen/$groupId/gegevens/': typeof BeheerGroepenGroupIdGegevensIndexRoute
  '/beheer/groepen/$groupId/lesmaterialen/': typeof BeheerGroepenGroupIdLesmaterialenIndexRoute
  '/beheer/groepen/$groupId/lessen/': typeof BeheerGroepenGroupIdLessenIndexRoute
  '/beheer/groepen/$groupId/notities/': typeof BeheerGroepenGroupIdNotitiesIndexRoute
  '/beheer/groepen/$groupId/presentie-overzicht/': typeof BeheerGroepenGroupIdPresentieOverzichtIndexRoute
  '/beheer/groepen/$groupId/rooster/': typeof BeheerGroepenGroupIdRoosterIndexRoute
  '/beheer/groepen/$groupId/students/': typeof BeheerGroepenGroupIdStudentsIndexRoute
  '/beheer/groepen/$groupId/toets-overzicht/': typeof BeheerGroepenGroupIdToetsOverzichtIndexRoute
  '/beheer/locaties/$locationId/documenten/': typeof BeheerLocatiesLocationIdDocumentenIndexRoute
  '/beheer/locaties/$locationId/gegevens/': typeof BeheerLocatiesLocationIdGegevensIndexRoute
  '/beheer/locaties/$locationId/notities/': typeof BeheerLocatiesLocationIdNotitiesIndexRoute
  '/beheer/medewerkers/$userId/agenda/': typeof BeheerMedewerkersUserIdAgendaIndexRoute
  '/beheer/medewerkers/$userId/beschikbaarheid/': typeof BeheerMedewerkersUserIdBeschikbaarheidIndexRoute
  '/beheer/medewerkers/$userId/dossier/': typeof BeheerMedewerkersUserIdDossierIndexRoute
  '/beheer/medewerkers/$userId/groepen/': typeof BeheerMedewerkersUserIdGroepenIndexRoute
  '/beheer/medewerkers/$userId/lesbevoegdheid/': typeof BeheerMedewerkersUserIdLesbevoegdheidIndexRoute
  '/beheer/medewerkers/$userId/leslocaties/': typeof BeheerMedewerkersUserIdLeslocatiesIndexRoute
  '/beheer/medewerkers/$userId/persoonlijke_gegevens/': typeof BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRoute
  '/beheer/medewerkers/$userId/zakelijke_gegevens/': typeof BeheerMedewerkersUserIdZakelijke_gegevensIndexRoute
  '/beheer/organisaties/$organizationId/contactpersonen/': typeof BeheerOrganisatiesOrganizationIdContactpersonenIndexRoute
  '/beheer/organisaties/$organizationId/contracten/': typeof BeheerOrganisatiesOrganizationIdContractenIndexRoute
  '/beheer/organisaties/$organizationId/cursisten/': typeof BeheerOrganisatiesOrganizationIdCursistenIndexRoute
  '/beheer/organisaties/$organizationId/documenten/': typeof BeheerOrganisatiesOrganizationIdDocumentenIndexRoute
  '/beheer/organisaties/$organizationId/gegevens/': typeof BeheerOrganisatiesOrganizationIdGegevensIndexRoute
  '/beheer/organisaties/$organizationId/notities/': typeof BeheerOrganisatiesOrganizationIdNotitiesIndexRoute
  '/beheer/contracten/$contractId/notities/$noteThreadId/': typeof BeheerContractenContractIdNotitiesNoteThreadIdIndexRoute
  '/beheer/cursisten/$studentId/notities/$noteThreadId/': typeof BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRoute
  '/beheer/cursisten/$studentId/rapportages/$reportId/': typeof BeheerCursistenStudentIdRapportagesReportIdIndexRoute
  '/beheer/groepen/$groupId/notities/$noteThreadId/': typeof BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRoute
  '/beheer/locaties/$locationId/notities/$noteThreadId/': typeof BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRoute
  '/beheer/organisaties/$organizationId/notities/$noteThreadId/': typeof BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRoute
  '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen': typeof BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRoute
  '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/': typeof BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/profiel'
    | '/test-support'
    | '/todo'
    | '/correspondentie/$threadId'
    | '/login/$token'
    | '/onboarding/$token'
    | '/onboarding/ongeldige_token'
    | '/test-support/rapportage-todo-aanmaken'
    | '/agenda/'
    | '/beheer/'
    | '/correspondentie/'
    | '/dashboard/'
    | '/duo/'
    | '/facturatie/'
    | '/freelancer_omzetten/'
    | '/geen-rol/'
    | '/login/'
    | '/onboarding/'
    | '/test-support/'
    | '/todo/'
    | '/beheer/contactpersonen/$organizationUserId'
    | '/beheer/contracten/$contractId'
    | '/beheer/cursisten/$studentId'
    | '/beheer/groepen/$groupId'
    | '/beheer/laptops/$laptopId'
    | '/beheer/leerlijnen/$learningPathId'
    | '/beheer/locaties/$locationId'
    | '/beheer/medewerkers/$userId'
    | '/beheer/organisaties/$organizationId'
    | '/agenda/les/$lessonId'
    | '/beheer/contactpersonen/aanmaken'
    | '/beheer/cursisten/aanmaken'
    | '/beheer/groepen/aanmaken'
    | '/beheer/intakes/aanmaken'
    | '/beheer/intakes/intake-plannen'
    | '/beheer/laptops/aanmaken'
    | '/beheer/leerlijnen/aanmaken'
    | '/beheer/lessen/nieuwe-les'
    | '/beheer/organisaties/aanmaken'
    | '/auth/confirm_account/'
    | '/auth/failed_sso/'
    | '/auth/sso_callback/'
    | '/beheer/contactpersonen/'
    | '/beheer/contracten/'
    | '/beheer/cursisten/'
    | '/beheer/feestdagen/'
    | '/beheer/groepen/'
    | '/beheer/intakes/'
    | '/beheer/laptops/'
    | '/beheer/leerlijnen/'
    | '/beheer/lesmaterialen/'
    | '/beheer/lessen/'
    | '/beheer/locaties/'
    | '/beheer/medewerkers/'
    | '/beheer/organisaties/'
    | '/beheer/roosters/'
    | '/beheer/toetsen/'
    | '/duo/contractenlijsten/'
    | '/duo/examenresultaten/'
    | '/duo/facturen/'
    | '/duo/terugmeldingen/'
    | '/facturatie/cursisten/'
    | '/facturatie/facturen/'
    | '/onboarding/docent-onboarding/'
    | '/profiel/agenda/'
    | '/profiel/beschikbaarheid/'
    | '/profiel/dossier/'
    | '/profiel/groepen/'
    | '/profiel/lesbevoegdheid/'
    | '/profiel/locaties/'
    | '/profiel/persoonlijke_gegevens/'
    | '/profiel/zakelijke_gegevens/'
    | '/beheer/laptops/$laptopId/leengeschiedenis'
    | '/beheer/todo/$studentRegistrationId/controleren'
    | '/beheer/todo/$studentRegistrationId/vergelijken'
    | '/facturatie/cursisten/$studentId/factuur-genereren'
    | '/beheer/contracten/$contractId/'
    | '/beheer/contracten/nieuw-contract/'
    | '/beheer/feestdagen/aanmaken/'
    | '/beheer/intakes/$intakeId/'
    | '/beheer/leerlijnen/$learningPathId/'
    | '/beheer/lesmaterialen/aanmaken/'
    | '/beheer/locaties/$locationId/'
    | '/beheer/locaties/aanmaken/'
    | '/beheer/organisaties/$organizationId/'
    | '/beheer/toetsen/aanmaken/'
    | '/facturatie/facturen/$invoiceId/'
    | '/profiel/beschikbaarheid/invullen/'
    | '/profiel/lesbevoegdheid/invullen/'
    | '/profiel/zakelijke_gegevens/invullen/'
    | '/todo/$category/$todoId/'
    | '/beheer/contracten/$contractId/correspondentie/$threadId'
    | '/beheer/contracten/$contractId/organisaties/$organization'
    | '/beheer/contracten/wijzigen/$contractId/contract-gegevens'
    | '/beheer/contracten/wijzigen/$contractId/locaties'
    | '/beheer/contracten/wijzigen/$contractId/team-gegevens'
    | '/beheer/contracten/wijzigen/$contractId/vakanties'
    | '/beheer/cursisten/$studentId/correspondentie/$threadId'
    | '/beheer/groepen/$groupId/correspondentie/$threadId'
    | '/beheer/groepen/$groupId/lessen/nieuwe-les'
    | '/beheer/groepen/$groupId/toets-overzicht/$entryId'
    | '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen'
    | '/beheer/leerlijnen/$learningPathId/modules/$moduleId'
    | '/beheer/locaties/$locationId/classrooms/$classroom'
    | '/beheer/medewerkers/$userId/lesbevoegdheid/controleren'
    | '/beheer/organisaties/$organizationId/contactpersonen/aanmaken'
    | '/beheer/contactpersonen/$organizationUserId/gegevens/'
    | '/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten/'
    | '/beheer/contracten/$contractId/correspondentie/'
    | '/beheer/contracten/$contractId/dossier/'
    | '/beheer/contracten/$contractId/gegevens/'
    | '/beheer/contracten/$contractId/notities/'
    | '/beheer/cursisten/$studentId/beschikbaarheid/'
    | '/beheer/cursisten/$studentId/correspondentie/'
    | '/beheer/cursisten/$studentId/documenten/'
    | '/beheer/cursisten/$studentId/examenresultaten/'
    | '/beheer/cursisten/$studentId/gegevens/'
    | '/beheer/cursisten/$studentId/intake/'
    | '/beheer/cursisten/$studentId/laptops/'
    | '/beheer/cursisten/$studentId/lessen/'
    | '/beheer/cursisten/$studentId/notities/'
    | '/beheer/cursisten/$studentId/rapportages/'
    | '/beheer/cursisten/$studentId/tweede-aanspreekpunt/'
    | '/beheer/cursisten/$studentId/voortgang/'
    | '/beheer/groepen/$groupId/correspondentie/'
    | '/beheer/groepen/$groupId/documenten/'
    | '/beheer/groepen/$groupId/gegevens/'
    | '/beheer/groepen/$groupId/lesmaterialen/'
    | '/beheer/groepen/$groupId/lessen/'
    | '/beheer/groepen/$groupId/notities/'
    | '/beheer/groepen/$groupId/presentie-overzicht/'
    | '/beheer/groepen/$groupId/rooster/'
    | '/beheer/groepen/$groupId/students/'
    | '/beheer/groepen/$groupId/toets-overzicht/'
    | '/beheer/locaties/$locationId/documenten/'
    | '/beheer/locaties/$locationId/gegevens/'
    | '/beheer/locaties/$locationId/notities/'
    | '/beheer/medewerkers/$userId/agenda/'
    | '/beheer/medewerkers/$userId/beschikbaarheid/'
    | '/beheer/medewerkers/$userId/dossier/'
    | '/beheer/medewerkers/$userId/groepen/'
    | '/beheer/medewerkers/$userId/lesbevoegdheid/'
    | '/beheer/medewerkers/$userId/leslocaties/'
    | '/beheer/medewerkers/$userId/persoonlijke_gegevens/'
    | '/beheer/medewerkers/$userId/zakelijke_gegevens/'
    | '/beheer/organisaties/$organizationId/contactpersonen/'
    | '/beheer/organisaties/$organizationId/contracten/'
    | '/beheer/organisaties/$organizationId/cursisten/'
    | '/beheer/organisaties/$organizationId/documenten/'
    | '/beheer/organisaties/$organizationId/gegevens/'
    | '/beheer/organisaties/$organizationId/notities/'
    | '/beheer/contracten/$contractId/notities/$noteThreadId/'
    | '/beheer/cursisten/$studentId/notities/$noteThreadId/'
    | '/beheer/cursisten/$studentId/rapportages/$reportId/'
    | '/beheer/groepen/$groupId/notities/$noteThreadId/'
    | '/beheer/locaties/$locationId/notities/$noteThreadId/'
    | '/beheer/organisaties/$organizationId/notities/$noteThreadId/'
    | '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen'
    | '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/profiel'
    | '/correspondentie/$threadId'
    | '/login/$token'
    | '/onboarding/$token'
    | '/onboarding/ongeldige_token'
    | '/test-support/rapportage-todo-aanmaken'
    | '/agenda'
    | '/beheer'
    | '/correspondentie'
    | '/dashboard'
    | '/duo'
    | '/facturatie'
    | '/freelancer_omzetten'
    | '/geen-rol'
    | '/login'
    | '/onboarding'
    | '/test-support'
    | '/todo'
    | '/beheer/contactpersonen/$organizationUserId'
    | '/beheer/cursisten/$studentId'
    | '/beheer/groepen/$groupId'
    | '/beheer/laptops/$laptopId'
    | '/beheer/medewerkers/$userId'
    | '/agenda/les/$lessonId'
    | '/beheer/contactpersonen/aanmaken'
    | '/beheer/cursisten/aanmaken'
    | '/beheer/groepen/aanmaken'
    | '/beheer/intakes/aanmaken'
    | '/beheer/intakes/intake-plannen'
    | '/beheer/laptops/aanmaken'
    | '/beheer/leerlijnen/aanmaken'
    | '/beheer/lessen/nieuwe-les'
    | '/beheer/organisaties/aanmaken'
    | '/auth/confirm_account'
    | '/auth/failed_sso'
    | '/auth/sso_callback'
    | '/beheer/contactpersonen'
    | '/beheer/contracten'
    | '/beheer/cursisten'
    | '/beheer/feestdagen'
    | '/beheer/groepen'
    | '/beheer/intakes'
    | '/beheer/laptops'
    | '/beheer/leerlijnen'
    | '/beheer/lesmaterialen'
    | '/beheer/lessen'
    | '/beheer/locaties'
    | '/beheer/medewerkers'
    | '/beheer/organisaties'
    | '/beheer/roosters'
    | '/beheer/toetsen'
    | '/duo/contractenlijsten'
    | '/duo/examenresultaten'
    | '/duo/facturen'
    | '/duo/terugmeldingen'
    | '/facturatie/cursisten'
    | '/facturatie/facturen'
    | '/onboarding/docent-onboarding'
    | '/profiel/agenda'
    | '/profiel/beschikbaarheid'
    | '/profiel/dossier'
    | '/profiel/groepen'
    | '/profiel/lesbevoegdheid'
    | '/profiel/locaties'
    | '/profiel/persoonlijke_gegevens'
    | '/profiel/zakelijke_gegevens'
    | '/beheer/laptops/$laptopId/leengeschiedenis'
    | '/beheer/todo/$studentRegistrationId/controleren'
    | '/beheer/todo/$studentRegistrationId/vergelijken'
    | '/facturatie/cursisten/$studentId/factuur-genereren'
    | '/beheer/contracten/$contractId'
    | '/beheer/contracten/nieuw-contract'
    | '/beheer/feestdagen/aanmaken'
    | '/beheer/intakes/$intakeId'
    | '/beheer/leerlijnen/$learningPathId'
    | '/beheer/lesmaterialen/aanmaken'
    | '/beheer/locaties/$locationId'
    | '/beheer/locaties/aanmaken'
    | '/beheer/organisaties/$organizationId'
    | '/beheer/toetsen/aanmaken'
    | '/facturatie/facturen/$invoiceId'
    | '/profiel/beschikbaarheid/invullen'
    | '/profiel/lesbevoegdheid/invullen'
    | '/profiel/zakelijke_gegevens/invullen'
    | '/todo/$category/$todoId'
    | '/beheer/contracten/$contractId/correspondentie/$threadId'
    | '/beheer/contracten/$contractId/organisaties/$organization'
    | '/beheer/contracten/wijzigen/$contractId/contract-gegevens'
    | '/beheer/contracten/wijzigen/$contractId/locaties'
    | '/beheer/contracten/wijzigen/$contractId/team-gegevens'
    | '/beheer/contracten/wijzigen/$contractId/vakanties'
    | '/beheer/cursisten/$studentId/correspondentie/$threadId'
    | '/beheer/groepen/$groupId/correspondentie/$threadId'
    | '/beheer/groepen/$groupId/lessen/nieuwe-les'
    | '/beheer/groepen/$groupId/toets-overzicht/$entryId'
    | '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen'
    | '/beheer/leerlijnen/$learningPathId/modules/$moduleId'
    | '/beheer/locaties/$locationId/classrooms/$classroom'
    | '/beheer/medewerkers/$userId/lesbevoegdheid/controleren'
    | '/beheer/organisaties/$organizationId/contactpersonen/aanmaken'
    | '/beheer/contactpersonen/$organizationUserId/gegevens'
    | '/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten'
    | '/beheer/contracten/$contractId/correspondentie'
    | '/beheer/contracten/$contractId/dossier'
    | '/beheer/contracten/$contractId/gegevens'
    | '/beheer/contracten/$contractId/notities'
    | '/beheer/cursisten/$studentId/beschikbaarheid'
    | '/beheer/cursisten/$studentId/correspondentie'
    | '/beheer/cursisten/$studentId/documenten'
    | '/beheer/cursisten/$studentId/examenresultaten'
    | '/beheer/cursisten/$studentId/gegevens'
    | '/beheer/cursisten/$studentId/intake'
    | '/beheer/cursisten/$studentId/laptops'
    | '/beheer/cursisten/$studentId/lessen'
    | '/beheer/cursisten/$studentId/notities'
    | '/beheer/cursisten/$studentId/rapportages'
    | '/beheer/cursisten/$studentId/tweede-aanspreekpunt'
    | '/beheer/cursisten/$studentId/voortgang'
    | '/beheer/groepen/$groupId/correspondentie'
    | '/beheer/groepen/$groupId/documenten'
    | '/beheer/groepen/$groupId/gegevens'
    | '/beheer/groepen/$groupId/lesmaterialen'
    | '/beheer/groepen/$groupId/lessen'
    | '/beheer/groepen/$groupId/notities'
    | '/beheer/groepen/$groupId/presentie-overzicht'
    | '/beheer/groepen/$groupId/rooster'
    | '/beheer/groepen/$groupId/students'
    | '/beheer/groepen/$groupId/toets-overzicht'
    | '/beheer/locaties/$locationId/documenten'
    | '/beheer/locaties/$locationId/gegevens'
    | '/beheer/locaties/$locationId/notities'
    | '/beheer/medewerkers/$userId/agenda'
    | '/beheer/medewerkers/$userId/beschikbaarheid'
    | '/beheer/medewerkers/$userId/dossier'
    | '/beheer/medewerkers/$userId/groepen'
    | '/beheer/medewerkers/$userId/lesbevoegdheid'
    | '/beheer/medewerkers/$userId/leslocaties'
    | '/beheer/medewerkers/$userId/persoonlijke_gegevens'
    | '/beheer/medewerkers/$userId/zakelijke_gegevens'
    | '/beheer/organisaties/$organizationId/contactpersonen'
    | '/beheer/organisaties/$organizationId/contracten'
    | '/beheer/organisaties/$organizationId/cursisten'
    | '/beheer/organisaties/$organizationId/documenten'
    | '/beheer/organisaties/$organizationId/gegevens'
    | '/beheer/organisaties/$organizationId/notities'
    | '/beheer/contracten/$contractId/notities/$noteThreadId'
    | '/beheer/cursisten/$studentId/notities/$noteThreadId'
    | '/beheer/cursisten/$studentId/rapportages/$reportId'
    | '/beheer/groepen/$groupId/notities/$noteThreadId'
    | '/beheer/locaties/$locationId/notities/$noteThreadId'
    | '/beheer/organisaties/$organizationId/notities/$noteThreadId'
    | '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen'
    | '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId'
  id:
    | '__root__'
    | '/'
    | '/profiel'
    | '/test-support'
    | '/todo'
    | '/correspondentie/$threadId'
    | '/login/$token'
    | '/onboarding/$token'
    | '/onboarding/ongeldige_token'
    | '/test-support/rapportage-todo-aanmaken'
    | '/agenda/'
    | '/beheer/'
    | '/correspondentie/'
    | '/dashboard/'
    | '/duo/'
    | '/facturatie/'
    | '/freelancer_omzetten/'
    | '/geen-rol/'
    | '/login/'
    | '/onboarding/'
    | '/test-support/'
    | '/todo/'
    | '/beheer/contactpersonen/$organizationUserId'
    | '/beheer/contracten/$contractId'
    | '/beheer/cursisten/$studentId'
    | '/beheer/groepen/$groupId'
    | '/beheer/laptops/$laptopId'
    | '/beheer/leerlijnen/$learningPathId'
    | '/beheer/locaties/$locationId'
    | '/beheer/medewerkers/$userId'
    | '/beheer/organisaties/$organizationId'
    | '/agenda/les/$lessonId'
    | '/beheer/contactpersonen/aanmaken'
    | '/beheer/cursisten/aanmaken'
    | '/beheer/groepen/aanmaken'
    | '/beheer/intakes/aanmaken'
    | '/beheer/intakes/intake-plannen'
    | '/beheer/laptops/aanmaken'
    | '/beheer/leerlijnen/aanmaken'
    | '/beheer/lessen/nieuwe-les'
    | '/beheer/organisaties/aanmaken'
    | '/auth/confirm_account/'
    | '/auth/failed_sso/'
    | '/auth/sso_callback/'
    | '/beheer/contactpersonen/'
    | '/beheer/contracten/'
    | '/beheer/cursisten/'
    | '/beheer/feestdagen/'
    | '/beheer/groepen/'
    | '/beheer/intakes/'
    | '/beheer/laptops/'
    | '/beheer/leerlijnen/'
    | '/beheer/lesmaterialen/'
    | '/beheer/lessen/'
    | '/beheer/locaties/'
    | '/beheer/medewerkers/'
    | '/beheer/organisaties/'
    | '/beheer/roosters/'
    | '/beheer/toetsen/'
    | '/duo/contractenlijsten/'
    | '/duo/examenresultaten/'
    | '/duo/facturen/'
    | '/duo/terugmeldingen/'
    | '/facturatie/cursisten/'
    | '/facturatie/facturen/'
    | '/onboarding/docent-onboarding/'
    | '/profiel/agenda/'
    | '/profiel/beschikbaarheid/'
    | '/profiel/dossier/'
    | '/profiel/groepen/'
    | '/profiel/lesbevoegdheid/'
    | '/profiel/locaties/'
    | '/profiel/persoonlijke_gegevens/'
    | '/profiel/zakelijke_gegevens/'
    | '/beheer/laptops/$laptopId/leengeschiedenis'
    | '/beheer/todo/$studentRegistrationId/controleren'
    | '/beheer/todo/$studentRegistrationId/vergelijken'
    | '/facturatie/cursisten/$studentId/factuur-genereren'
    | '/beheer/contracten/$contractId/'
    | '/beheer/contracten/nieuw-contract/'
    | '/beheer/feestdagen/aanmaken/'
    | '/beheer/intakes/$intakeId/'
    | '/beheer/leerlijnen/$learningPathId/'
    | '/beheer/lesmaterialen/aanmaken/'
    | '/beheer/locaties/$locationId/'
    | '/beheer/locaties/aanmaken/'
    | '/beheer/organisaties/$organizationId/'
    | '/beheer/toetsen/aanmaken/'
    | '/facturatie/facturen/$invoiceId/'
    | '/profiel/beschikbaarheid/invullen/'
    | '/profiel/lesbevoegdheid/invullen/'
    | '/profiel/zakelijke_gegevens/invullen/'
    | '/todo/$category/$todoId/'
    | '/beheer/contracten/$contractId/correspondentie/$threadId'
    | '/beheer/contracten/$contractId/organisaties/$organization'
    | '/beheer/contracten/wijzigen/$contractId/contract-gegevens'
    | '/beheer/contracten/wijzigen/$contractId/locaties'
    | '/beheer/contracten/wijzigen/$contractId/team-gegevens'
    | '/beheer/contracten/wijzigen/$contractId/vakanties'
    | '/beheer/cursisten/$studentId/correspondentie/$threadId'
    | '/beheer/groepen/$groupId/correspondentie/$threadId'
    | '/beheer/groepen/$groupId/lessen/nieuwe-les'
    | '/beheer/groepen/$groupId/toets-overzicht/$entryId'
    | '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen'
    | '/beheer/leerlijnen/$learningPathId/modules/$moduleId'
    | '/beheer/locaties/$locationId/classrooms/$classroom'
    | '/beheer/medewerkers/$userId/lesbevoegdheid/controleren'
    | '/beheer/organisaties/$organizationId/contactpersonen/aanmaken'
    | '/beheer/contactpersonen/$organizationUserId/gegevens/'
    | '/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten/'
    | '/beheer/contracten/$contractId/correspondentie/'
    | '/beheer/contracten/$contractId/dossier/'
    | '/beheer/contracten/$contractId/gegevens/'
    | '/beheer/contracten/$contractId/notities/'
    | '/beheer/cursisten/$studentId/beschikbaarheid/'
    | '/beheer/cursisten/$studentId/correspondentie/'
    | '/beheer/cursisten/$studentId/documenten/'
    | '/beheer/cursisten/$studentId/examenresultaten/'
    | '/beheer/cursisten/$studentId/gegevens/'
    | '/beheer/cursisten/$studentId/intake/'
    | '/beheer/cursisten/$studentId/laptops/'
    | '/beheer/cursisten/$studentId/lessen/'
    | '/beheer/cursisten/$studentId/notities/'
    | '/beheer/cursisten/$studentId/rapportages/'
    | '/beheer/cursisten/$studentId/tweede-aanspreekpunt/'
    | '/beheer/cursisten/$studentId/voortgang/'
    | '/beheer/groepen/$groupId/correspondentie/'
    | '/beheer/groepen/$groupId/documenten/'
    | '/beheer/groepen/$groupId/gegevens/'
    | '/beheer/groepen/$groupId/lesmaterialen/'
    | '/beheer/groepen/$groupId/lessen/'
    | '/beheer/groepen/$groupId/notities/'
    | '/beheer/groepen/$groupId/presentie-overzicht/'
    | '/beheer/groepen/$groupId/rooster/'
    | '/beheer/groepen/$groupId/students/'
    | '/beheer/groepen/$groupId/toets-overzicht/'
    | '/beheer/locaties/$locationId/documenten/'
    | '/beheer/locaties/$locationId/gegevens/'
    | '/beheer/locaties/$locationId/notities/'
    | '/beheer/medewerkers/$userId/agenda/'
    | '/beheer/medewerkers/$userId/beschikbaarheid/'
    | '/beheer/medewerkers/$userId/dossier/'
    | '/beheer/medewerkers/$userId/groepen/'
    | '/beheer/medewerkers/$userId/lesbevoegdheid/'
    | '/beheer/medewerkers/$userId/leslocaties/'
    | '/beheer/medewerkers/$userId/persoonlijke_gegevens/'
    | '/beheer/medewerkers/$userId/zakelijke_gegevens/'
    | '/beheer/organisaties/$organizationId/contactpersonen/'
    | '/beheer/organisaties/$organizationId/contracten/'
    | '/beheer/organisaties/$organizationId/cursisten/'
    | '/beheer/organisaties/$organizationId/documenten/'
    | '/beheer/organisaties/$organizationId/gegevens/'
    | '/beheer/organisaties/$organizationId/notities/'
    | '/beheer/contracten/$contractId/notities/$noteThreadId/'
    | '/beheer/cursisten/$studentId/notities/$noteThreadId/'
    | '/beheer/cursisten/$studentId/rapportages/$reportId/'
    | '/beheer/groepen/$groupId/notities/$noteThreadId/'
    | '/beheer/locaties/$locationId/notities/$noteThreadId/'
    | '/beheer/organisaties/$organizationId/notities/$noteThreadId/'
    | '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen'
    | '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProfielRouteRoute: typeof ProfielRouteRouteWithChildren
  TestSupportRouteRoute: typeof TestSupportRouteRouteWithChildren
  TodoRouteRoute: typeof TodoRouteRouteWithChildren
  CorrespondentieThreadIdRoute: typeof CorrespondentieThreadIdRoute
  LoginTokenRoute: typeof LoginTokenRoute
  OnboardingTokenRoute: typeof OnboardingTokenRoute
  OnboardingOngeldige_tokenRoute: typeof OnboardingOngeldige_tokenRoute
  AgendaIndexRoute: typeof AgendaIndexRoute
  BeheerIndexRoute: typeof BeheerIndexRoute
  CorrespondentieIndexRoute: typeof CorrespondentieIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DuoIndexRoute: typeof DuoIndexRoute
  FacturatieIndexRoute: typeof FacturatieIndexRoute
  Freelancer_omzettenIndexRoute: typeof Freelancer_omzettenIndexRoute
  GeenRolIndexRoute: typeof GeenRolIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
  BeheerContactpersonenOrganizationUserIdRouteRoute: typeof BeheerContactpersonenOrganizationUserIdRouteRouteWithChildren
  BeheerContractenContractIdRouteRoute: typeof BeheerContractenContractIdRouteRouteWithChildren
  BeheerCursistenStudentIdRouteRoute: typeof BeheerCursistenStudentIdRouteRouteWithChildren
  BeheerGroepenGroupIdRouteRoute: typeof BeheerGroepenGroupIdRouteRouteWithChildren
  BeheerLaptopsLaptopIdRouteRoute: typeof BeheerLaptopsLaptopIdRouteRouteWithChildren
  BeheerLeerlijnenLearningPathIdRouteRoute: typeof BeheerLeerlijnenLearningPathIdRouteRouteWithChildren
  BeheerLocatiesLocationIdRouteRoute: typeof BeheerLocatiesLocationIdRouteRouteWithChildren
  BeheerMedewerkersUserIdRouteRoute: typeof BeheerMedewerkersUserIdRouteRouteWithChildren
  BeheerOrganisatiesOrganizationIdRouteRoute: typeof BeheerOrganisatiesOrganizationIdRouteRouteWithChildren
  AgendaLesLessonIdRoute: typeof AgendaLesLessonIdRoute
  BeheerContactpersonenAanmakenRoute: typeof BeheerContactpersonenAanmakenRoute
  BeheerCursistenAanmakenRoute: typeof BeheerCursistenAanmakenRoute
  BeheerGroepenAanmakenRoute: typeof BeheerGroepenAanmakenRoute
  BeheerIntakesAanmakenRoute: typeof BeheerIntakesAanmakenRoute
  BeheerIntakesIntakePlannenRoute: typeof BeheerIntakesIntakePlannenRoute
  BeheerLaptopsAanmakenRoute: typeof BeheerLaptopsAanmakenRoute
  BeheerLeerlijnenAanmakenRoute: typeof BeheerLeerlijnenAanmakenRoute
  BeheerLessenNieuweLesRoute: typeof BeheerLessenNieuweLesRoute
  BeheerOrganisatiesAanmakenRoute: typeof BeheerOrganisatiesAanmakenRoute
  AuthConfirm_accountIndexRoute: typeof AuthConfirm_accountIndexRoute
  AuthFailed_ssoIndexRoute: typeof AuthFailed_ssoIndexRoute
  AuthSso_callbackIndexRoute: typeof AuthSso_callbackIndexRoute
  BeheerContactpersonenIndexRoute: typeof BeheerContactpersonenIndexRoute
  BeheerContractenIndexRoute: typeof BeheerContractenIndexRoute
  BeheerCursistenIndexRoute: typeof BeheerCursistenIndexRoute
  BeheerFeestdagenIndexRoute: typeof BeheerFeestdagenIndexRoute
  BeheerGroepenIndexRoute: typeof BeheerGroepenIndexRoute
  BeheerIntakesIndexRoute: typeof BeheerIntakesIndexRoute
  BeheerLaptopsIndexRoute: typeof BeheerLaptopsIndexRoute
  BeheerLeerlijnenIndexRoute: typeof BeheerLeerlijnenIndexRoute
  BeheerLesmaterialenIndexRoute: typeof BeheerLesmaterialenIndexRoute
  BeheerLessenIndexRoute: typeof BeheerLessenIndexRoute
  BeheerLocatiesIndexRoute: typeof BeheerLocatiesIndexRoute
  BeheerMedewerkersIndexRoute: typeof BeheerMedewerkersIndexRoute
  BeheerOrganisatiesIndexRoute: typeof BeheerOrganisatiesIndexRoute
  BeheerRoostersIndexRoute: typeof BeheerRoostersIndexRoute
  BeheerToetsenIndexRoute: typeof BeheerToetsenIndexRoute
  DuoContractenlijstenIndexRoute: typeof DuoContractenlijstenIndexRoute
  DuoExamenresultatenIndexRoute: typeof DuoExamenresultatenIndexRoute
  DuoFacturenIndexRoute: typeof DuoFacturenIndexRoute
  DuoTerugmeldingenIndexRoute: typeof DuoTerugmeldingenIndexRoute
  FacturatieCursistenIndexRoute: typeof FacturatieCursistenIndexRoute
  FacturatieFacturenIndexRoute: typeof FacturatieFacturenIndexRoute
  OnboardingDocentOnboardingIndexRoute: typeof OnboardingDocentOnboardingIndexRoute
  BeheerTodoStudentRegistrationIdControlerenRoute: typeof BeheerTodoStudentRegistrationIdControlerenRoute
  BeheerTodoStudentRegistrationIdVergelijkenRoute: typeof BeheerTodoStudentRegistrationIdVergelijkenRoute
  FacturatieCursistenStudentIdFactuurGenererenRoute: typeof FacturatieCursistenStudentIdFactuurGenererenRoute
  BeheerContractenNieuwContractIndexRoute: typeof BeheerContractenNieuwContractIndexRoute
  BeheerFeestdagenAanmakenIndexRoute: typeof BeheerFeestdagenAanmakenIndexRoute
  BeheerIntakesIntakeIdIndexRoute: typeof BeheerIntakesIntakeIdIndexRoute
  BeheerLesmaterialenAanmakenIndexRoute: typeof BeheerLesmaterialenAanmakenIndexRoute
  BeheerLocatiesAanmakenIndexRoute: typeof BeheerLocatiesAanmakenIndexRoute
  BeheerToetsenAanmakenIndexRoute: typeof BeheerToetsenAanmakenIndexRoute
  FacturatieFacturenInvoiceIdIndexRoute: typeof FacturatieFacturenInvoiceIdIndexRoute
  BeheerContractenWijzigenContractIdContractGegevensRoute: typeof BeheerContractenWijzigenContractIdContractGegevensRoute
  BeheerContractenWijzigenContractIdLocatiesRoute: typeof BeheerContractenWijzigenContractIdLocatiesRoute
  BeheerContractenWijzigenContractIdTeamGegevensRoute: typeof BeheerContractenWijzigenContractIdTeamGegevensRoute
  BeheerContractenWijzigenContractIdVakantiesRoute: typeof BeheerContractenWijzigenContractIdVakantiesRoute
  BeheerGroepenWijzigenGroupIdLocatiesWijzigenRoute: typeof BeheerGroepenWijzigenGroupIdLocatiesWijzigenRoute
  BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRoute: typeof BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRoute
  BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRoute: typeof BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/todo': {
      id: '/todo'
      path: '/todo'
      fullPath: '/todo'
      preLoaderRoute: typeof TodoRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-support': {
      id: '/test-support'
      path: '/test-support'
      fullPath: '/test-support'
      preLoaderRoute: typeof TestSupportRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiel': {
      id: '/profiel'
      path: '/profiel'
      fullPath: '/profiel'
      preLoaderRoute: typeof ProfielRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/todo/': {
      id: '/todo/'
      path: '/'
      fullPath: '/todo/'
      preLoaderRoute: typeof TodoIndexRouteImport
      parentRoute: typeof TodoRouteRoute
    }
    '/test-support/': {
      id: '/test-support/'
      path: '/'
      fullPath: '/test-support/'
      preLoaderRoute: typeof TestSupportIndexRouteImport
      parentRoute: typeof TestSupportRouteRoute
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/onboarding'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/geen-rol/': {
      id: '/geen-rol/'
      path: '/geen-rol'
      fullPath: '/geen-rol/'
      preLoaderRoute: typeof GeenRolIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/freelancer_omzetten/': {
      id: '/freelancer_omzetten/'
      path: '/freelancer_omzetten'
      fullPath: '/freelancer_omzetten/'
      preLoaderRoute: typeof Freelancer_omzettenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facturatie/': {
      id: '/facturatie/'
      path: '/facturatie'
      fullPath: '/facturatie/'
      preLoaderRoute: typeof FacturatieIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/duo/': {
      id: '/duo/'
      path: '/duo'
      fullPath: '/duo/'
      preLoaderRoute: typeof DuoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/correspondentie/': {
      id: '/correspondentie/'
      path: '/correspondentie'
      fullPath: '/correspondentie/'
      preLoaderRoute: typeof CorrespondentieIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/': {
      id: '/beheer/'
      path: '/beheer'
      fullPath: '/beheer/'
      preLoaderRoute: typeof BeheerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agenda/': {
      id: '/agenda/'
      path: '/agenda'
      fullPath: '/agenda/'
      preLoaderRoute: typeof AgendaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test-support/rapportage-todo-aanmaken': {
      id: '/test-support/rapportage-todo-aanmaken'
      path: '/rapportage-todo-aanmaken'
      fullPath: '/test-support/rapportage-todo-aanmaken'
      preLoaderRoute: typeof TestSupportRapportageTodoAanmakenRouteImport
      parentRoute: typeof TestSupportRouteRoute
    }
    '/onboarding/ongeldige_token': {
      id: '/onboarding/ongeldige_token'
      path: '/onboarding/ongeldige_token'
      fullPath: '/onboarding/ongeldige_token'
      preLoaderRoute: typeof OnboardingOngeldige_tokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/$token': {
      id: '/onboarding/$token'
      path: '/onboarding/$token'
      fullPath: '/onboarding/$token'
      preLoaderRoute: typeof OnboardingTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/$token': {
      id: '/login/$token'
      path: '/login/$token'
      fullPath: '/login/$token'
      preLoaderRoute: typeof LoginTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/correspondentie/$threadId': {
      id: '/correspondentie/$threadId'
      path: '/correspondentie/$threadId'
      fullPath: '/correspondentie/$threadId'
      preLoaderRoute: typeof CorrespondentieThreadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profiel/zakelijke_gegevens/': {
      id: '/profiel/zakelijke_gegevens/'
      path: '/zakelijke_gegevens'
      fullPath: '/profiel/zakelijke_gegevens/'
      preLoaderRoute: typeof ProfielZakelijke_gegevensIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/persoonlijke_gegevens/': {
      id: '/profiel/persoonlijke_gegevens/'
      path: '/persoonlijke_gegevens'
      fullPath: '/profiel/persoonlijke_gegevens/'
      preLoaderRoute: typeof ProfielPersoonlijke_gegevensIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/locaties/': {
      id: '/profiel/locaties/'
      path: '/locaties'
      fullPath: '/profiel/locaties/'
      preLoaderRoute: typeof ProfielLocatiesIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/lesbevoegdheid/': {
      id: '/profiel/lesbevoegdheid/'
      path: '/lesbevoegdheid'
      fullPath: '/profiel/lesbevoegdheid/'
      preLoaderRoute: typeof ProfielLesbevoegdheidIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/groepen/': {
      id: '/profiel/groepen/'
      path: '/groepen'
      fullPath: '/profiel/groepen/'
      preLoaderRoute: typeof ProfielGroepenIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/dossier/': {
      id: '/profiel/dossier/'
      path: '/dossier'
      fullPath: '/profiel/dossier/'
      preLoaderRoute: typeof ProfielDossierIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/beschikbaarheid/': {
      id: '/profiel/beschikbaarheid/'
      path: '/beschikbaarheid'
      fullPath: '/profiel/beschikbaarheid/'
      preLoaderRoute: typeof ProfielBeschikbaarheidIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/agenda/': {
      id: '/profiel/agenda/'
      path: '/agenda'
      fullPath: '/profiel/agenda/'
      preLoaderRoute: typeof ProfielAgendaIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/onboarding/docent-onboarding/': {
      id: '/onboarding/docent-onboarding/'
      path: '/onboarding/docent-onboarding'
      fullPath: '/onboarding/docent-onboarding/'
      preLoaderRoute: typeof OnboardingDocentOnboardingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facturatie/facturen/': {
      id: '/facturatie/facturen/'
      path: '/facturatie/facturen'
      fullPath: '/facturatie/facturen/'
      preLoaderRoute: typeof FacturatieFacturenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/facturatie/cursisten/': {
      id: '/facturatie/cursisten/'
      path: '/facturatie/cursisten'
      fullPath: '/facturatie/cursisten/'
      preLoaderRoute: typeof FacturatieCursistenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/duo/terugmeldingen/': {
      id: '/duo/terugmeldingen/'
      path: '/duo/terugmeldingen'
      fullPath: '/duo/terugmeldingen/'
      preLoaderRoute: typeof DuoTerugmeldingenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/duo/facturen/': {
      id: '/duo/facturen/'
      path: '/duo/facturen'
      fullPath: '/duo/facturen/'
      preLoaderRoute: typeof DuoFacturenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/duo/examenresultaten/': {
      id: '/duo/examenresultaten/'
      path: '/duo/examenresultaten'
      fullPath: '/duo/examenresultaten/'
      preLoaderRoute: typeof DuoExamenresultatenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/duo/contractenlijsten/': {
      id: '/duo/contractenlijsten/'
      path: '/duo/contractenlijsten'
      fullPath: '/duo/contractenlijsten/'
      preLoaderRoute: typeof DuoContractenlijstenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/toetsen/': {
      id: '/beheer/toetsen/'
      path: '/beheer/toetsen'
      fullPath: '/beheer/toetsen/'
      preLoaderRoute: typeof BeheerToetsenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/roosters/': {
      id: '/beheer/roosters/'
      path: '/beheer/roosters'
      fullPath: '/beheer/roosters/'
      preLoaderRoute: typeof BeheerRoostersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/organisaties/': {
      id: '/beheer/organisaties/'
      path: '/beheer/organisaties'
      fullPath: '/beheer/organisaties/'
      preLoaderRoute: typeof BeheerOrganisatiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/medewerkers/': {
      id: '/beheer/medewerkers/'
      path: '/beheer/medewerkers'
      fullPath: '/beheer/medewerkers/'
      preLoaderRoute: typeof BeheerMedewerkersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/locaties/': {
      id: '/beheer/locaties/'
      path: '/beheer/locaties'
      fullPath: '/beheer/locaties/'
      preLoaderRoute: typeof BeheerLocatiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/lessen/': {
      id: '/beheer/lessen/'
      path: '/beheer/lessen'
      fullPath: '/beheer/lessen/'
      preLoaderRoute: typeof BeheerLessenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/lesmaterialen/': {
      id: '/beheer/lesmaterialen/'
      path: '/beheer/lesmaterialen'
      fullPath: '/beheer/lesmaterialen/'
      preLoaderRoute: typeof BeheerLesmaterialenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/leerlijnen/': {
      id: '/beheer/leerlijnen/'
      path: '/beheer/leerlijnen'
      fullPath: '/beheer/leerlijnen/'
      preLoaderRoute: typeof BeheerLeerlijnenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/laptops/': {
      id: '/beheer/laptops/'
      path: '/beheer/laptops'
      fullPath: '/beheer/laptops/'
      preLoaderRoute: typeof BeheerLaptopsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/intakes/': {
      id: '/beheer/intakes/'
      path: '/beheer/intakes'
      fullPath: '/beheer/intakes/'
      preLoaderRoute: typeof BeheerIntakesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/groepen/': {
      id: '/beheer/groepen/'
      path: '/beheer/groepen'
      fullPath: '/beheer/groepen/'
      preLoaderRoute: typeof BeheerGroepenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/feestdagen/': {
      id: '/beheer/feestdagen/'
      path: '/beheer/feestdagen'
      fullPath: '/beheer/feestdagen/'
      preLoaderRoute: typeof BeheerFeestdagenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/cursisten/': {
      id: '/beheer/cursisten/'
      path: '/beheer/cursisten'
      fullPath: '/beheer/cursisten/'
      preLoaderRoute: typeof BeheerCursistenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/': {
      id: '/beheer/contracten/'
      path: '/beheer/contracten'
      fullPath: '/beheer/contracten/'
      preLoaderRoute: typeof BeheerContractenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contactpersonen/': {
      id: '/beheer/contactpersonen/'
      path: '/beheer/contactpersonen'
      fullPath: '/beheer/contactpersonen/'
      preLoaderRoute: typeof BeheerContactpersonenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sso_callback/': {
      id: '/auth/sso_callback/'
      path: '/auth/sso_callback'
      fullPath: '/auth/sso_callback/'
      preLoaderRoute: typeof AuthSso_callbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/failed_sso/': {
      id: '/auth/failed_sso/'
      path: '/auth/failed_sso'
      fullPath: '/auth/failed_sso/'
      preLoaderRoute: typeof AuthFailed_ssoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/confirm_account/': {
      id: '/auth/confirm_account/'
      path: '/auth/confirm_account'
      fullPath: '/auth/confirm_account/'
      preLoaderRoute: typeof AuthConfirm_accountIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/organisaties/aanmaken': {
      id: '/beheer/organisaties/aanmaken'
      path: '/beheer/organisaties/aanmaken'
      fullPath: '/beheer/organisaties/aanmaken'
      preLoaderRoute: typeof BeheerOrganisatiesAanmakenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/lessen/nieuwe-les': {
      id: '/beheer/lessen/nieuwe-les'
      path: '/beheer/lessen/nieuwe-les'
      fullPath: '/beheer/lessen/nieuwe-les'
      preLoaderRoute: typeof BeheerLessenNieuweLesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/leerlijnen/aanmaken': {
      id: '/beheer/leerlijnen/aanmaken'
      path: '/beheer/leerlijnen/aanmaken'
      fullPath: '/beheer/leerlijnen/aanmaken'
      preLoaderRoute: typeof BeheerLeerlijnenAanmakenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/laptops/aanmaken': {
      id: '/beheer/laptops/aanmaken'
      path: '/beheer/laptops/aanmaken'
      fullPath: '/beheer/laptops/aanmaken'
      preLoaderRoute: typeof BeheerLaptopsAanmakenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/intakes/intake-plannen': {
      id: '/beheer/intakes/intake-plannen'
      path: '/beheer/intakes/intake-plannen'
      fullPath: '/beheer/intakes/intake-plannen'
      preLoaderRoute: typeof BeheerIntakesIntakePlannenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/intakes/aanmaken': {
      id: '/beheer/intakes/aanmaken'
      path: '/beheer/intakes/aanmaken'
      fullPath: '/beheer/intakes/aanmaken'
      preLoaderRoute: typeof BeheerIntakesAanmakenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/groepen/aanmaken': {
      id: '/beheer/groepen/aanmaken'
      path: '/beheer/groepen/aanmaken'
      fullPath: '/beheer/groepen/aanmaken'
      preLoaderRoute: typeof BeheerGroepenAanmakenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/cursisten/aanmaken': {
      id: '/beheer/cursisten/aanmaken'
      path: '/beheer/cursisten/aanmaken'
      fullPath: '/beheer/cursisten/aanmaken'
      preLoaderRoute: typeof BeheerCursistenAanmakenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contactpersonen/aanmaken': {
      id: '/beheer/contactpersonen/aanmaken'
      path: '/beheer/contactpersonen/aanmaken'
      fullPath: '/beheer/contactpersonen/aanmaken'
      preLoaderRoute: typeof BeheerContactpersonenAanmakenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agenda/les/$lessonId': {
      id: '/agenda/les/$lessonId'
      path: '/agenda/les/$lessonId'
      fullPath: '/agenda/les/$lessonId'
      preLoaderRoute: typeof AgendaLesLessonIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/organisaties/$organizationId': {
      id: '/beheer/organisaties/$organizationId'
      path: '/beheer/organisaties/$organizationId'
      fullPath: '/beheer/organisaties/$organizationId'
      preLoaderRoute: typeof BeheerOrganisatiesOrganizationIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/medewerkers/$userId': {
      id: '/beheer/medewerkers/$userId'
      path: '/beheer/medewerkers/$userId'
      fullPath: '/beheer/medewerkers/$userId'
      preLoaderRoute: typeof BeheerMedewerkersUserIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/locaties/$locationId': {
      id: '/beheer/locaties/$locationId'
      path: '/beheer/locaties/$locationId'
      fullPath: '/beheer/locaties/$locationId'
      preLoaderRoute: typeof BeheerLocatiesLocationIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/leerlijnen/$learningPathId': {
      id: '/beheer/leerlijnen/$learningPathId'
      path: '/beheer/leerlijnen/$learningPathId'
      fullPath: '/beheer/leerlijnen/$learningPathId'
      preLoaderRoute: typeof BeheerLeerlijnenLearningPathIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/laptops/$laptopId': {
      id: '/beheer/laptops/$laptopId'
      path: '/beheer/laptops/$laptopId'
      fullPath: '/beheer/laptops/$laptopId'
      preLoaderRoute: typeof BeheerLaptopsLaptopIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/groepen/$groupId': {
      id: '/beheer/groepen/$groupId'
      path: '/beheer/groepen/$groupId'
      fullPath: '/beheer/groepen/$groupId'
      preLoaderRoute: typeof BeheerGroepenGroupIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/cursisten/$studentId': {
      id: '/beheer/cursisten/$studentId'
      path: '/beheer/cursisten/$studentId'
      fullPath: '/beheer/cursisten/$studentId'
      preLoaderRoute: typeof BeheerCursistenStudentIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/$contractId': {
      id: '/beheer/contracten/$contractId'
      path: '/beheer/contracten/$contractId'
      fullPath: '/beheer/contracten/$contractId'
      preLoaderRoute: typeof BeheerContractenContractIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contactpersonen/$organizationUserId': {
      id: '/beheer/contactpersonen/$organizationUserId'
      path: '/beheer/contactpersonen/$organizationUserId'
      fullPath: '/beheer/contactpersonen/$organizationUserId'
      preLoaderRoute: typeof BeheerContactpersonenOrganizationUserIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/todo/$category/$todoId/': {
      id: '/todo/$category/$todoId/'
      path: '/$category/$todoId'
      fullPath: '/todo/$category/$todoId/'
      preLoaderRoute: typeof TodoCategoryTodoIdIndexRouteImport
      parentRoute: typeof TodoRouteRoute
    }
    '/profiel/zakelijke_gegevens/invullen/': {
      id: '/profiel/zakelijke_gegevens/invullen/'
      path: '/zakelijke_gegevens/invullen'
      fullPath: '/profiel/zakelijke_gegevens/invullen/'
      preLoaderRoute: typeof ProfielZakelijke_gegevensInvullenIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/lesbevoegdheid/invullen/': {
      id: '/profiel/lesbevoegdheid/invullen/'
      path: '/lesbevoegdheid/invullen'
      fullPath: '/profiel/lesbevoegdheid/invullen/'
      preLoaderRoute: typeof ProfielLesbevoegdheidInvullenIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/profiel/beschikbaarheid/invullen/': {
      id: '/profiel/beschikbaarheid/invullen/'
      path: '/beschikbaarheid/invullen'
      fullPath: '/profiel/beschikbaarheid/invullen/'
      preLoaderRoute: typeof ProfielBeschikbaarheidInvullenIndexRouteImport
      parentRoute: typeof ProfielRouteRoute
    }
    '/facturatie/facturen/$invoiceId/': {
      id: '/facturatie/facturen/$invoiceId/'
      path: '/facturatie/facturen/$invoiceId'
      fullPath: '/facturatie/facturen/$invoiceId/'
      preLoaderRoute: typeof FacturatieFacturenInvoiceIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/toetsen/aanmaken/': {
      id: '/beheer/toetsen/aanmaken/'
      path: '/beheer/toetsen/aanmaken'
      fullPath: '/beheer/toetsen/aanmaken/'
      preLoaderRoute: typeof BeheerToetsenAanmakenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/organisaties/$organizationId/': {
      id: '/beheer/organisaties/$organizationId/'
      path: '/'
      fullPath: '/beheer/organisaties/$organizationId/'
      preLoaderRoute: typeof BeheerOrganisatiesOrganizationIdIndexRouteImport
      parentRoute: typeof BeheerOrganisatiesOrganizationIdRouteRoute
    }
    '/beheer/locaties/aanmaken/': {
      id: '/beheer/locaties/aanmaken/'
      path: '/beheer/locaties/aanmaken'
      fullPath: '/beheer/locaties/aanmaken/'
      preLoaderRoute: typeof BeheerLocatiesAanmakenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/locaties/$locationId/': {
      id: '/beheer/locaties/$locationId/'
      path: '/'
      fullPath: '/beheer/locaties/$locationId/'
      preLoaderRoute: typeof BeheerLocatiesLocationIdIndexRouteImport
      parentRoute: typeof BeheerLocatiesLocationIdRouteRoute
    }
    '/beheer/lesmaterialen/aanmaken/': {
      id: '/beheer/lesmaterialen/aanmaken/'
      path: '/beheer/lesmaterialen/aanmaken'
      fullPath: '/beheer/lesmaterialen/aanmaken/'
      preLoaderRoute: typeof BeheerLesmaterialenAanmakenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/leerlijnen/$learningPathId/': {
      id: '/beheer/leerlijnen/$learningPathId/'
      path: '/'
      fullPath: '/beheer/leerlijnen/$learningPathId/'
      preLoaderRoute: typeof BeheerLeerlijnenLearningPathIdIndexRouteImport
      parentRoute: typeof BeheerLeerlijnenLearningPathIdRouteRoute
    }
    '/beheer/intakes/$intakeId/': {
      id: '/beheer/intakes/$intakeId/'
      path: '/beheer/intakes/$intakeId'
      fullPath: '/beheer/intakes/$intakeId/'
      preLoaderRoute: typeof BeheerIntakesIntakeIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/feestdagen/aanmaken/': {
      id: '/beheer/feestdagen/aanmaken/'
      path: '/beheer/feestdagen/aanmaken'
      fullPath: '/beheer/feestdagen/aanmaken/'
      preLoaderRoute: typeof BeheerFeestdagenAanmakenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/nieuw-contract/': {
      id: '/beheer/contracten/nieuw-contract/'
      path: '/beheer/contracten/nieuw-contract'
      fullPath: '/beheer/contracten/nieuw-contract/'
      preLoaderRoute: typeof BeheerContractenNieuwContractIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/$contractId/': {
      id: '/beheer/contracten/$contractId/'
      path: '/'
      fullPath: '/beheer/contracten/$contractId/'
      preLoaderRoute: typeof BeheerContractenContractIdIndexRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/facturatie/cursisten/$studentId/factuur-genereren': {
      id: '/facturatie/cursisten/$studentId/factuur-genereren'
      path: '/facturatie/cursisten/$studentId/factuur-genereren'
      fullPath: '/facturatie/cursisten/$studentId/factuur-genereren'
      preLoaderRoute: typeof FacturatieCursistenStudentIdFactuurGenererenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/todo/$studentRegistrationId/vergelijken': {
      id: '/beheer/todo/$studentRegistrationId/vergelijken'
      path: '/beheer/todo/$studentRegistrationId/vergelijken'
      fullPath: '/beheer/todo/$studentRegistrationId/vergelijken'
      preLoaderRoute: typeof BeheerTodoStudentRegistrationIdVergelijkenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/todo/$studentRegistrationId/controleren': {
      id: '/beheer/todo/$studentRegistrationId/controleren'
      path: '/beheer/todo/$studentRegistrationId/controleren'
      fullPath: '/beheer/todo/$studentRegistrationId/controleren'
      preLoaderRoute: typeof BeheerTodoStudentRegistrationIdControlerenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/laptops/$laptopId/leengeschiedenis': {
      id: '/beheer/laptops/$laptopId/leengeschiedenis'
      path: '/leengeschiedenis'
      fullPath: '/beheer/laptops/$laptopId/leengeschiedenis'
      preLoaderRoute: typeof BeheerLaptopsLaptopIdLeengeschiedenisRouteImport
      parentRoute: typeof BeheerLaptopsLaptopIdRouteRoute
    }
    '/beheer/organisaties/$organizationId/notities/': {
      id: '/beheer/organisaties/$organizationId/notities/'
      path: '/notities'
      fullPath: '/beheer/organisaties/$organizationId/notities/'
      preLoaderRoute: typeof BeheerOrganisatiesOrganizationIdNotitiesIndexRouteImport
      parentRoute: typeof BeheerOrganisatiesOrganizationIdRouteRoute
    }
    '/beheer/organisaties/$organizationId/gegevens/': {
      id: '/beheer/organisaties/$organizationId/gegevens/'
      path: '/gegevens'
      fullPath: '/beheer/organisaties/$organizationId/gegevens/'
      preLoaderRoute: typeof BeheerOrganisatiesOrganizationIdGegevensIndexRouteImport
      parentRoute: typeof BeheerOrganisatiesOrganizationIdRouteRoute
    }
    '/beheer/organisaties/$organizationId/documenten/': {
      id: '/beheer/organisaties/$organizationId/documenten/'
      path: '/documenten'
      fullPath: '/beheer/organisaties/$organizationId/documenten/'
      preLoaderRoute: typeof BeheerOrganisatiesOrganizationIdDocumentenIndexRouteImport
      parentRoute: typeof BeheerOrganisatiesOrganizationIdRouteRoute
    }
    '/beheer/organisaties/$organizationId/cursisten/': {
      id: '/beheer/organisaties/$organizationId/cursisten/'
      path: '/cursisten'
      fullPath: '/beheer/organisaties/$organizationId/cursisten/'
      preLoaderRoute: typeof BeheerOrganisatiesOrganizationIdCursistenIndexRouteImport
      parentRoute: typeof BeheerOrganisatiesOrganizationIdRouteRoute
    }
    '/beheer/organisaties/$organizationId/contracten/': {
      id: '/beheer/organisaties/$organizationId/contracten/'
      path: '/contracten'
      fullPath: '/beheer/organisaties/$organizationId/contracten/'
      preLoaderRoute: typeof BeheerOrganisatiesOrganizationIdContractenIndexRouteImport
      parentRoute: typeof BeheerOrganisatiesOrganizationIdRouteRoute
    }
    '/beheer/organisaties/$organizationId/contactpersonen/': {
      id: '/beheer/organisaties/$organizationId/contactpersonen/'
      path: '/contactpersonen'
      fullPath: '/beheer/organisaties/$organizationId/contactpersonen/'
      preLoaderRoute: typeof BeheerOrganisatiesOrganizationIdContactpersonenIndexRouteImport
      parentRoute: typeof BeheerOrganisatiesOrganizationIdRouteRoute
    }
    '/beheer/medewerkers/$userId/zakelijke_gegevens/': {
      id: '/beheer/medewerkers/$userId/zakelijke_gegevens/'
      path: '/zakelijke_gegevens'
      fullPath: '/beheer/medewerkers/$userId/zakelijke_gegevens/'
      preLoaderRoute: typeof BeheerMedewerkersUserIdZakelijke_gegevensIndexRouteImport
      parentRoute: typeof BeheerMedewerkersUserIdRouteRoute
    }
    '/beheer/medewerkers/$userId/persoonlijke_gegevens/': {
      id: '/beheer/medewerkers/$userId/persoonlijke_gegevens/'
      path: '/persoonlijke_gegevens'
      fullPath: '/beheer/medewerkers/$userId/persoonlijke_gegevens/'
      preLoaderRoute: typeof BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRouteImport
      parentRoute: typeof BeheerMedewerkersUserIdRouteRoute
    }
    '/beheer/medewerkers/$userId/leslocaties/': {
      id: '/beheer/medewerkers/$userId/leslocaties/'
      path: '/leslocaties'
      fullPath: '/beheer/medewerkers/$userId/leslocaties/'
      preLoaderRoute: typeof BeheerMedewerkersUserIdLeslocatiesIndexRouteImport
      parentRoute: typeof BeheerMedewerkersUserIdRouteRoute
    }
    '/beheer/medewerkers/$userId/lesbevoegdheid/': {
      id: '/beheer/medewerkers/$userId/lesbevoegdheid/'
      path: '/lesbevoegdheid'
      fullPath: '/beheer/medewerkers/$userId/lesbevoegdheid/'
      preLoaderRoute: typeof BeheerMedewerkersUserIdLesbevoegdheidIndexRouteImport
      parentRoute: typeof BeheerMedewerkersUserIdRouteRoute
    }
    '/beheer/medewerkers/$userId/groepen/': {
      id: '/beheer/medewerkers/$userId/groepen/'
      path: '/groepen'
      fullPath: '/beheer/medewerkers/$userId/groepen/'
      preLoaderRoute: typeof BeheerMedewerkersUserIdGroepenIndexRouteImport
      parentRoute: typeof BeheerMedewerkersUserIdRouteRoute
    }
    '/beheer/medewerkers/$userId/dossier/': {
      id: '/beheer/medewerkers/$userId/dossier/'
      path: '/dossier'
      fullPath: '/beheer/medewerkers/$userId/dossier/'
      preLoaderRoute: typeof BeheerMedewerkersUserIdDossierIndexRouteImport
      parentRoute: typeof BeheerMedewerkersUserIdRouteRoute
    }
    '/beheer/medewerkers/$userId/beschikbaarheid/': {
      id: '/beheer/medewerkers/$userId/beschikbaarheid/'
      path: '/beschikbaarheid'
      fullPath: '/beheer/medewerkers/$userId/beschikbaarheid/'
      preLoaderRoute: typeof BeheerMedewerkersUserIdBeschikbaarheidIndexRouteImport
      parentRoute: typeof BeheerMedewerkersUserIdRouteRoute
    }
    '/beheer/medewerkers/$userId/agenda/': {
      id: '/beheer/medewerkers/$userId/agenda/'
      path: '/agenda'
      fullPath: '/beheer/medewerkers/$userId/agenda/'
      preLoaderRoute: typeof BeheerMedewerkersUserIdAgendaIndexRouteImport
      parentRoute: typeof BeheerMedewerkersUserIdRouteRoute
    }
    '/beheer/locaties/$locationId/notities/': {
      id: '/beheer/locaties/$locationId/notities/'
      path: '/notities'
      fullPath: '/beheer/locaties/$locationId/notities/'
      preLoaderRoute: typeof BeheerLocatiesLocationIdNotitiesIndexRouteImport
      parentRoute: typeof BeheerLocatiesLocationIdRouteRoute
    }
    '/beheer/locaties/$locationId/gegevens/': {
      id: '/beheer/locaties/$locationId/gegevens/'
      path: '/gegevens'
      fullPath: '/beheer/locaties/$locationId/gegevens/'
      preLoaderRoute: typeof BeheerLocatiesLocationIdGegevensIndexRouteImport
      parentRoute: typeof BeheerLocatiesLocationIdRouteRoute
    }
    '/beheer/locaties/$locationId/documenten/': {
      id: '/beheer/locaties/$locationId/documenten/'
      path: '/documenten'
      fullPath: '/beheer/locaties/$locationId/documenten/'
      preLoaderRoute: typeof BeheerLocatiesLocationIdDocumentenIndexRouteImport
      parentRoute: typeof BeheerLocatiesLocationIdRouteRoute
    }
    '/beheer/groepen/$groupId/toets-overzicht/': {
      id: '/beheer/groepen/$groupId/toets-overzicht/'
      path: '/toets-overzicht'
      fullPath: '/beheer/groepen/$groupId/toets-overzicht/'
      preLoaderRoute: typeof BeheerGroepenGroupIdToetsOverzichtIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/students/': {
      id: '/beheer/groepen/$groupId/students/'
      path: '/students'
      fullPath: '/beheer/groepen/$groupId/students/'
      preLoaderRoute: typeof BeheerGroepenGroupIdStudentsIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/rooster/': {
      id: '/beheer/groepen/$groupId/rooster/'
      path: '/rooster'
      fullPath: '/beheer/groepen/$groupId/rooster/'
      preLoaderRoute: typeof BeheerGroepenGroupIdRoosterIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/presentie-overzicht/': {
      id: '/beheer/groepen/$groupId/presentie-overzicht/'
      path: '/presentie-overzicht'
      fullPath: '/beheer/groepen/$groupId/presentie-overzicht/'
      preLoaderRoute: typeof BeheerGroepenGroupIdPresentieOverzichtIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/notities/': {
      id: '/beheer/groepen/$groupId/notities/'
      path: '/notities'
      fullPath: '/beheer/groepen/$groupId/notities/'
      preLoaderRoute: typeof BeheerGroepenGroupIdNotitiesIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/lessen/': {
      id: '/beheer/groepen/$groupId/lessen/'
      path: '/lessen'
      fullPath: '/beheer/groepen/$groupId/lessen/'
      preLoaderRoute: typeof BeheerGroepenGroupIdLessenIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/lesmaterialen/': {
      id: '/beheer/groepen/$groupId/lesmaterialen/'
      path: '/lesmaterialen'
      fullPath: '/beheer/groepen/$groupId/lesmaterialen/'
      preLoaderRoute: typeof BeheerGroepenGroupIdLesmaterialenIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/gegevens/': {
      id: '/beheer/groepen/$groupId/gegevens/'
      path: '/gegevens'
      fullPath: '/beheer/groepen/$groupId/gegevens/'
      preLoaderRoute: typeof BeheerGroepenGroupIdGegevensIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/documenten/': {
      id: '/beheer/groepen/$groupId/documenten/'
      path: '/documenten'
      fullPath: '/beheer/groepen/$groupId/documenten/'
      preLoaderRoute: typeof BeheerGroepenGroupIdDocumentenIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/correspondentie/': {
      id: '/beheer/groepen/$groupId/correspondentie/'
      path: '/correspondentie'
      fullPath: '/beheer/groepen/$groupId/correspondentie/'
      preLoaderRoute: typeof BeheerGroepenGroupIdCorrespondentieIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/cursisten/$studentId/voortgang/': {
      id: '/beheer/cursisten/$studentId/voortgang/'
      path: '/voortgang'
      fullPath: '/beheer/cursisten/$studentId/voortgang/'
      preLoaderRoute: typeof BeheerCursistenStudentIdVoortgangIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/tweede-aanspreekpunt/': {
      id: '/beheer/cursisten/$studentId/tweede-aanspreekpunt/'
      path: '/tweede-aanspreekpunt'
      fullPath: '/beheer/cursisten/$studentId/tweede-aanspreekpunt/'
      preLoaderRoute: typeof BeheerCursistenStudentIdTweedeAanspreekpuntIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/rapportages/': {
      id: '/beheer/cursisten/$studentId/rapportages/'
      path: '/rapportages'
      fullPath: '/beheer/cursisten/$studentId/rapportages/'
      preLoaderRoute: typeof BeheerCursistenStudentIdRapportagesIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/notities/': {
      id: '/beheer/cursisten/$studentId/notities/'
      path: '/notities'
      fullPath: '/beheer/cursisten/$studentId/notities/'
      preLoaderRoute: typeof BeheerCursistenStudentIdNotitiesIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/lessen/': {
      id: '/beheer/cursisten/$studentId/lessen/'
      path: '/lessen'
      fullPath: '/beheer/cursisten/$studentId/lessen/'
      preLoaderRoute: typeof BeheerCursistenStudentIdLessenIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/laptops/': {
      id: '/beheer/cursisten/$studentId/laptops/'
      path: '/laptops'
      fullPath: '/beheer/cursisten/$studentId/laptops/'
      preLoaderRoute: typeof BeheerCursistenStudentIdLaptopsIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/intake/': {
      id: '/beheer/cursisten/$studentId/intake/'
      path: '/intake'
      fullPath: '/beheer/cursisten/$studentId/intake/'
      preLoaderRoute: typeof BeheerCursistenStudentIdIntakeIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/gegevens/': {
      id: '/beheer/cursisten/$studentId/gegevens/'
      path: '/gegevens'
      fullPath: '/beheer/cursisten/$studentId/gegevens/'
      preLoaderRoute: typeof BeheerCursistenStudentIdGegevensIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/examenresultaten/': {
      id: '/beheer/cursisten/$studentId/examenresultaten/'
      path: '/examenresultaten'
      fullPath: '/beheer/cursisten/$studentId/examenresultaten/'
      preLoaderRoute: typeof BeheerCursistenStudentIdExamenresultatenIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/documenten/': {
      id: '/beheer/cursisten/$studentId/documenten/'
      path: '/documenten'
      fullPath: '/beheer/cursisten/$studentId/documenten/'
      preLoaderRoute: typeof BeheerCursistenStudentIdDocumentenIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/correspondentie/': {
      id: '/beheer/cursisten/$studentId/correspondentie/'
      path: '/correspondentie'
      fullPath: '/beheer/cursisten/$studentId/correspondentie/'
      preLoaderRoute: typeof BeheerCursistenStudentIdCorrespondentieIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/beschikbaarheid/': {
      id: '/beheer/cursisten/$studentId/beschikbaarheid/'
      path: '/beschikbaarheid'
      fullPath: '/beheer/cursisten/$studentId/beschikbaarheid/'
      preLoaderRoute: typeof BeheerCursistenStudentIdBeschikbaarheidIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/contracten/$contractId/notities/': {
      id: '/beheer/contracten/$contractId/notities/'
      path: '/notities'
      fullPath: '/beheer/contracten/$contractId/notities/'
      preLoaderRoute: typeof BeheerContractenContractIdNotitiesIndexRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/beheer/contracten/$contractId/gegevens/': {
      id: '/beheer/contracten/$contractId/gegevens/'
      path: '/gegevens'
      fullPath: '/beheer/contracten/$contractId/gegevens/'
      preLoaderRoute: typeof BeheerContractenContractIdGegevensIndexRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/beheer/contracten/$contractId/dossier/': {
      id: '/beheer/contracten/$contractId/dossier/'
      path: '/dossier'
      fullPath: '/beheer/contracten/$contractId/dossier/'
      preLoaderRoute: typeof BeheerContractenContractIdDossierIndexRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/beheer/contracten/$contractId/correspondentie/': {
      id: '/beheer/contracten/$contractId/correspondentie/'
      path: '/correspondentie'
      fullPath: '/beheer/contracten/$contractId/correspondentie/'
      preLoaderRoute: typeof BeheerContractenContractIdCorrespondentieIndexRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten/': {
      id: '/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten/'
      path: '/gekoppelde-cursisten'
      fullPath: '/beheer/contactpersonen/$organizationUserId/gekoppelde-cursisten/'
      preLoaderRoute: typeof BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRouteImport
      parentRoute: typeof BeheerContactpersonenOrganizationUserIdRouteRoute
    }
    '/beheer/contactpersonen/$organizationUserId/gegevens/': {
      id: '/beheer/contactpersonen/$organizationUserId/gegevens/'
      path: '/gegevens'
      fullPath: '/beheer/contactpersonen/$organizationUserId/gegevens/'
      preLoaderRoute: typeof BeheerContactpersonenOrganizationUserIdGegevensIndexRouteImport
      parentRoute: typeof BeheerContactpersonenOrganizationUserIdRouteRoute
    }
    '/beheer/organisaties/$organizationId/contactpersonen/aanmaken': {
      id: '/beheer/organisaties/$organizationId/contactpersonen/aanmaken'
      path: '/contactpersonen/aanmaken'
      fullPath: '/beheer/organisaties/$organizationId/contactpersonen/aanmaken'
      preLoaderRoute: typeof BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRouteImport
      parentRoute: typeof BeheerOrganisatiesOrganizationIdRouteRoute
    }
    '/beheer/medewerkers/$userId/lesbevoegdheid/controleren': {
      id: '/beheer/medewerkers/$userId/lesbevoegdheid/controleren'
      path: '/lesbevoegdheid/controleren'
      fullPath: '/beheer/medewerkers/$userId/lesbevoegdheid/controleren'
      preLoaderRoute: typeof BeheerMedewerkersUserIdLesbevoegdheidControlerenRouteImport
      parentRoute: typeof BeheerMedewerkersUserIdRouteRoute
    }
    '/beheer/locaties/$locationId/classrooms/$classroom': {
      id: '/beheer/locaties/$locationId/classrooms/$classroom'
      path: '/classrooms/$classroom'
      fullPath: '/beheer/locaties/$locationId/classrooms/$classroom'
      preLoaderRoute: typeof BeheerLocatiesLocationIdClassroomsClassroomRouteImport
      parentRoute: typeof BeheerLocatiesLocationIdRouteRoute
    }
    '/beheer/leerlijnen/$learningPathId/modules/$moduleId': {
      id: '/beheer/leerlijnen/$learningPathId/modules/$moduleId'
      path: '/modules/$moduleId'
      fullPath: '/beheer/leerlijnen/$learningPathId/modules/$moduleId'
      preLoaderRoute: typeof BeheerLeerlijnenLearningPathIdModulesModuleIdRouteImport
      parentRoute: typeof BeheerLeerlijnenLearningPathIdRouteRoute
    }
    '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen': {
      id: '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen'
      path: '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen'
      fullPath: '/beheer/groepen/wijzigen/$groupId/locaties-wijzigen'
      preLoaderRoute: typeof BeheerGroepenWijzigenGroupIdLocatiesWijzigenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/groepen/$groupId/toets-overzicht/$entryId': {
      id: '/beheer/groepen/$groupId/toets-overzicht/$entryId'
      path: '/toets-overzicht/$entryId'
      fullPath: '/beheer/groepen/$groupId/toets-overzicht/$entryId'
      preLoaderRoute: typeof BeheerGroepenGroupIdToetsOverzichtEntryIdRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/lessen/nieuwe-les': {
      id: '/beheer/groepen/$groupId/lessen/nieuwe-les'
      path: '/lessen/nieuwe-les'
      fullPath: '/beheer/groepen/$groupId/lessen/nieuwe-les'
      preLoaderRoute: typeof BeheerGroepenGroupIdLessenNieuweLesRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/groepen/$groupId/correspondentie/$threadId': {
      id: '/beheer/groepen/$groupId/correspondentie/$threadId'
      path: '/correspondentie/$threadId'
      fullPath: '/beheer/groepen/$groupId/correspondentie/$threadId'
      preLoaderRoute: typeof BeheerGroepenGroupIdCorrespondentieThreadIdRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/cursisten/$studentId/correspondentie/$threadId': {
      id: '/beheer/cursisten/$studentId/correspondentie/$threadId'
      path: '/correspondentie/$threadId'
      fullPath: '/beheer/cursisten/$studentId/correspondentie/$threadId'
      preLoaderRoute: typeof BeheerCursistenStudentIdCorrespondentieThreadIdRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/contracten/wijzigen/$contractId/vakanties': {
      id: '/beheer/contracten/wijzigen/$contractId/vakanties'
      path: '/beheer/contracten/wijzigen/$contractId/vakanties'
      fullPath: '/beheer/contracten/wijzigen/$contractId/vakanties'
      preLoaderRoute: typeof BeheerContractenWijzigenContractIdVakantiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/wijzigen/$contractId/team-gegevens': {
      id: '/beheer/contracten/wijzigen/$contractId/team-gegevens'
      path: '/beheer/contracten/wijzigen/$contractId/team-gegevens'
      fullPath: '/beheer/contracten/wijzigen/$contractId/team-gegevens'
      preLoaderRoute: typeof BeheerContractenWijzigenContractIdTeamGegevensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/wijzigen/$contractId/locaties': {
      id: '/beheer/contracten/wijzigen/$contractId/locaties'
      path: '/beheer/contracten/wijzigen/$contractId/locaties'
      fullPath: '/beheer/contracten/wijzigen/$contractId/locaties'
      preLoaderRoute: typeof BeheerContractenWijzigenContractIdLocatiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/wijzigen/$contractId/contract-gegevens': {
      id: '/beheer/contracten/wijzigen/$contractId/contract-gegevens'
      path: '/beheer/contracten/wijzigen/$contractId/contract-gegevens'
      fullPath: '/beheer/contracten/wijzigen/$contractId/contract-gegevens'
      preLoaderRoute: typeof BeheerContractenWijzigenContractIdContractGegevensRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/contracten/$contractId/organisaties/$organization': {
      id: '/beheer/contracten/$contractId/organisaties/$organization'
      path: '/organisaties/$organization'
      fullPath: '/beheer/contracten/$contractId/organisaties/$organization'
      preLoaderRoute: typeof BeheerContractenContractIdOrganisatiesOrganizationRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/beheer/contracten/$contractId/correspondentie/$threadId': {
      id: '/beheer/contracten/$contractId/correspondentie/$threadId'
      path: '/correspondentie/$threadId'
      fullPath: '/beheer/contracten/$contractId/correspondentie/$threadId'
      preLoaderRoute: typeof BeheerContractenContractIdCorrespondentieThreadIdRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/beheer/organisaties/$organizationId/notities/$noteThreadId/': {
      id: '/beheer/organisaties/$organizationId/notities/$noteThreadId/'
      path: '/notities/$noteThreadId'
      fullPath: '/beheer/organisaties/$organizationId/notities/$noteThreadId/'
      preLoaderRoute: typeof BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRouteImport
      parentRoute: typeof BeheerOrganisatiesOrganizationIdRouteRoute
    }
    '/beheer/locaties/$locationId/notities/$noteThreadId/': {
      id: '/beheer/locaties/$locationId/notities/$noteThreadId/'
      path: '/notities/$noteThreadId'
      fullPath: '/beheer/locaties/$locationId/notities/$noteThreadId/'
      preLoaderRoute: typeof BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRouteImport
      parentRoute: typeof BeheerLocatiesLocationIdRouteRoute
    }
    '/beheer/groepen/$groupId/notities/$noteThreadId/': {
      id: '/beheer/groepen/$groupId/notities/$noteThreadId/'
      path: '/notities/$noteThreadId'
      fullPath: '/beheer/groepen/$groupId/notities/$noteThreadId/'
      preLoaderRoute: typeof BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRouteImport
      parentRoute: typeof BeheerGroepenGroupIdRouteRoute
    }
    '/beheer/cursisten/$studentId/rapportages/$reportId/': {
      id: '/beheer/cursisten/$studentId/rapportages/$reportId/'
      path: '/rapportages/$reportId'
      fullPath: '/beheer/cursisten/$studentId/rapportages/$reportId/'
      preLoaderRoute: typeof BeheerCursistenStudentIdRapportagesReportIdIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/cursisten/$studentId/notities/$noteThreadId/': {
      id: '/beheer/cursisten/$studentId/notities/$noteThreadId/'
      path: '/notities/$noteThreadId'
      fullPath: '/beheer/cursisten/$studentId/notities/$noteThreadId/'
      preLoaderRoute: typeof BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRouteImport
      parentRoute: typeof BeheerCursistenStudentIdRouteRoute
    }
    '/beheer/contracten/$contractId/notities/$noteThreadId/': {
      id: '/beheer/contracten/$contractId/notities/$noteThreadId/'
      path: '/notities/$noteThreadId'
      fullPath: '/beheer/contracten/$contractId/notities/$noteThreadId/'
      preLoaderRoute: typeof BeheerContractenContractIdNotitiesNoteThreadIdIndexRouteImport
      parentRoute: typeof BeheerContractenContractIdRouteRoute
    }
    '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/': {
      id: '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/'
      path: '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId'
      fullPath: '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/'
      preLoaderRoute: typeof BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen': {
      id: '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen'
      path: '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen'
      fullPath: '/beheer/intakes/$intakeId/resultaat/$studentId/$studentProjectOrganizationId/wijzigen'
      preLoaderRoute: typeof BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ProfielRouteRouteChildren {
  ProfielAgendaIndexRoute: typeof ProfielAgendaIndexRoute
  ProfielBeschikbaarheidIndexRoute: typeof ProfielBeschikbaarheidIndexRoute
  ProfielDossierIndexRoute: typeof ProfielDossierIndexRoute
  ProfielGroepenIndexRoute: typeof ProfielGroepenIndexRoute
  ProfielLesbevoegdheidIndexRoute: typeof ProfielLesbevoegdheidIndexRoute
  ProfielLocatiesIndexRoute: typeof ProfielLocatiesIndexRoute
  ProfielPersoonlijke_gegevensIndexRoute: typeof ProfielPersoonlijke_gegevensIndexRoute
  ProfielZakelijke_gegevensIndexRoute: typeof ProfielZakelijke_gegevensIndexRoute
  ProfielBeschikbaarheidInvullenIndexRoute: typeof ProfielBeschikbaarheidInvullenIndexRoute
  ProfielLesbevoegdheidInvullenIndexRoute: typeof ProfielLesbevoegdheidInvullenIndexRoute
  ProfielZakelijke_gegevensInvullenIndexRoute: typeof ProfielZakelijke_gegevensInvullenIndexRoute
}

const ProfielRouteRouteChildren: ProfielRouteRouteChildren = {
  ProfielAgendaIndexRoute: ProfielAgendaIndexRoute,
  ProfielBeschikbaarheidIndexRoute: ProfielBeschikbaarheidIndexRoute,
  ProfielDossierIndexRoute: ProfielDossierIndexRoute,
  ProfielGroepenIndexRoute: ProfielGroepenIndexRoute,
  ProfielLesbevoegdheidIndexRoute: ProfielLesbevoegdheidIndexRoute,
  ProfielLocatiesIndexRoute: ProfielLocatiesIndexRoute,
  ProfielPersoonlijke_gegevensIndexRoute:
    ProfielPersoonlijke_gegevensIndexRoute,
  ProfielZakelijke_gegevensIndexRoute: ProfielZakelijke_gegevensIndexRoute,
  ProfielBeschikbaarheidInvullenIndexRoute:
    ProfielBeschikbaarheidInvullenIndexRoute,
  ProfielLesbevoegdheidInvullenIndexRoute:
    ProfielLesbevoegdheidInvullenIndexRoute,
  ProfielZakelijke_gegevensInvullenIndexRoute:
    ProfielZakelijke_gegevensInvullenIndexRoute,
}

const ProfielRouteRouteWithChildren = ProfielRouteRoute._addFileChildren(
  ProfielRouteRouteChildren,
)

interface TestSupportRouteRouteChildren {
  TestSupportRapportageTodoAanmakenRoute: typeof TestSupportRapportageTodoAanmakenRoute
  TestSupportIndexRoute: typeof TestSupportIndexRoute
}

const TestSupportRouteRouteChildren: TestSupportRouteRouteChildren = {
  TestSupportRapportageTodoAanmakenRoute:
    TestSupportRapportageTodoAanmakenRoute,
  TestSupportIndexRoute: TestSupportIndexRoute,
}

const TestSupportRouteRouteWithChildren =
  TestSupportRouteRoute._addFileChildren(TestSupportRouteRouteChildren)

interface TodoRouteRouteChildren {
  TodoIndexRoute: typeof TodoIndexRoute
  TodoCategoryTodoIdIndexRoute: typeof TodoCategoryTodoIdIndexRoute
}

const TodoRouteRouteChildren: TodoRouteRouteChildren = {
  TodoIndexRoute: TodoIndexRoute,
  TodoCategoryTodoIdIndexRoute: TodoCategoryTodoIdIndexRoute,
}

const TodoRouteRouteWithChildren = TodoRouteRoute._addFileChildren(
  TodoRouteRouteChildren,
)

interface BeheerContactpersonenOrganizationUserIdRouteRouteChildren {
  BeheerContactpersonenOrganizationUserIdGegevensIndexRoute: typeof BeheerContactpersonenOrganizationUserIdGegevensIndexRoute
  BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRoute: typeof BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRoute
}

const BeheerContactpersonenOrganizationUserIdRouteRouteChildren: BeheerContactpersonenOrganizationUserIdRouteRouteChildren =
  {
    BeheerContactpersonenOrganizationUserIdGegevensIndexRoute:
      BeheerContactpersonenOrganizationUserIdGegevensIndexRoute,
    BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRoute:
      BeheerContactpersonenOrganizationUserIdGekoppeldeCursistenIndexRoute,
  }

const BeheerContactpersonenOrganizationUserIdRouteRouteWithChildren =
  BeheerContactpersonenOrganizationUserIdRouteRoute._addFileChildren(
    BeheerContactpersonenOrganizationUserIdRouteRouteChildren,
  )

interface BeheerContractenContractIdRouteRouteChildren {
  BeheerContractenContractIdIndexRoute: typeof BeheerContractenContractIdIndexRoute
  BeheerContractenContractIdCorrespondentieThreadIdRoute: typeof BeheerContractenContractIdCorrespondentieThreadIdRoute
  BeheerContractenContractIdOrganisatiesOrganizationRoute: typeof BeheerContractenContractIdOrganisatiesOrganizationRoute
  BeheerContractenContractIdCorrespondentieIndexRoute: typeof BeheerContractenContractIdCorrespondentieIndexRoute
  BeheerContractenContractIdDossierIndexRoute: typeof BeheerContractenContractIdDossierIndexRoute
  BeheerContractenContractIdGegevensIndexRoute: typeof BeheerContractenContractIdGegevensIndexRoute
  BeheerContractenContractIdNotitiesIndexRoute: typeof BeheerContractenContractIdNotitiesIndexRoute
  BeheerContractenContractIdNotitiesNoteThreadIdIndexRoute: typeof BeheerContractenContractIdNotitiesNoteThreadIdIndexRoute
}

const BeheerContractenContractIdRouteRouteChildren: BeheerContractenContractIdRouteRouteChildren =
  {
    BeheerContractenContractIdIndexRoute: BeheerContractenContractIdIndexRoute,
    BeheerContractenContractIdCorrespondentieThreadIdRoute:
      BeheerContractenContractIdCorrespondentieThreadIdRoute,
    BeheerContractenContractIdOrganisatiesOrganizationRoute:
      BeheerContractenContractIdOrganisatiesOrganizationRoute,
    BeheerContractenContractIdCorrespondentieIndexRoute:
      BeheerContractenContractIdCorrespondentieIndexRoute,
    BeheerContractenContractIdDossierIndexRoute:
      BeheerContractenContractIdDossierIndexRoute,
    BeheerContractenContractIdGegevensIndexRoute:
      BeheerContractenContractIdGegevensIndexRoute,
    BeheerContractenContractIdNotitiesIndexRoute:
      BeheerContractenContractIdNotitiesIndexRoute,
    BeheerContractenContractIdNotitiesNoteThreadIdIndexRoute:
      BeheerContractenContractIdNotitiesNoteThreadIdIndexRoute,
  }

const BeheerContractenContractIdRouteRouteWithChildren =
  BeheerContractenContractIdRouteRoute._addFileChildren(
    BeheerContractenContractIdRouteRouteChildren,
  )

interface BeheerCursistenStudentIdRouteRouteChildren {
  BeheerCursistenStudentIdCorrespondentieThreadIdRoute: typeof BeheerCursistenStudentIdCorrespondentieThreadIdRoute
  BeheerCursistenStudentIdBeschikbaarheidIndexRoute: typeof BeheerCursistenStudentIdBeschikbaarheidIndexRoute
  BeheerCursistenStudentIdCorrespondentieIndexRoute: typeof BeheerCursistenStudentIdCorrespondentieIndexRoute
  BeheerCursistenStudentIdDocumentenIndexRoute: typeof BeheerCursistenStudentIdDocumentenIndexRoute
  BeheerCursistenStudentIdExamenresultatenIndexRoute: typeof BeheerCursistenStudentIdExamenresultatenIndexRoute
  BeheerCursistenStudentIdGegevensIndexRoute: typeof BeheerCursistenStudentIdGegevensIndexRoute
  BeheerCursistenStudentIdIntakeIndexRoute: typeof BeheerCursistenStudentIdIntakeIndexRoute
  BeheerCursistenStudentIdLaptopsIndexRoute: typeof BeheerCursistenStudentIdLaptopsIndexRoute
  BeheerCursistenStudentIdLessenIndexRoute: typeof BeheerCursistenStudentIdLessenIndexRoute
  BeheerCursistenStudentIdNotitiesIndexRoute: typeof BeheerCursistenStudentIdNotitiesIndexRoute
  BeheerCursistenStudentIdRapportagesIndexRoute: typeof BeheerCursistenStudentIdRapportagesIndexRoute
  BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute: typeof BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute
  BeheerCursistenStudentIdVoortgangIndexRoute: typeof BeheerCursistenStudentIdVoortgangIndexRoute
  BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRoute: typeof BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRoute
  BeheerCursistenStudentIdRapportagesReportIdIndexRoute: typeof BeheerCursistenStudentIdRapportagesReportIdIndexRoute
}

const BeheerCursistenStudentIdRouteRouteChildren: BeheerCursistenStudentIdRouteRouteChildren =
  {
    BeheerCursistenStudentIdCorrespondentieThreadIdRoute:
      BeheerCursistenStudentIdCorrespondentieThreadIdRoute,
    BeheerCursistenStudentIdBeschikbaarheidIndexRoute:
      BeheerCursistenStudentIdBeschikbaarheidIndexRoute,
    BeheerCursistenStudentIdCorrespondentieIndexRoute:
      BeheerCursistenStudentIdCorrespondentieIndexRoute,
    BeheerCursistenStudentIdDocumentenIndexRoute:
      BeheerCursistenStudentIdDocumentenIndexRoute,
    BeheerCursistenStudentIdExamenresultatenIndexRoute:
      BeheerCursistenStudentIdExamenresultatenIndexRoute,
    BeheerCursistenStudentIdGegevensIndexRoute:
      BeheerCursistenStudentIdGegevensIndexRoute,
    BeheerCursistenStudentIdIntakeIndexRoute:
      BeheerCursistenStudentIdIntakeIndexRoute,
    BeheerCursistenStudentIdLaptopsIndexRoute:
      BeheerCursistenStudentIdLaptopsIndexRoute,
    BeheerCursistenStudentIdLessenIndexRoute:
      BeheerCursistenStudentIdLessenIndexRoute,
    BeheerCursistenStudentIdNotitiesIndexRoute:
      BeheerCursistenStudentIdNotitiesIndexRoute,
    BeheerCursistenStudentIdRapportagesIndexRoute:
      BeheerCursistenStudentIdRapportagesIndexRoute,
    BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute:
      BeheerCursistenStudentIdTweedeAanspreekpuntIndexRoute,
    BeheerCursistenStudentIdVoortgangIndexRoute:
      BeheerCursistenStudentIdVoortgangIndexRoute,
    BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRoute:
      BeheerCursistenStudentIdNotitiesNoteThreadIdIndexRoute,
    BeheerCursistenStudentIdRapportagesReportIdIndexRoute:
      BeheerCursistenStudentIdRapportagesReportIdIndexRoute,
  }

const BeheerCursistenStudentIdRouteRouteWithChildren =
  BeheerCursistenStudentIdRouteRoute._addFileChildren(
    BeheerCursistenStudentIdRouteRouteChildren,
  )

interface BeheerGroepenGroupIdRouteRouteChildren {
  BeheerGroepenGroupIdCorrespondentieThreadIdRoute: typeof BeheerGroepenGroupIdCorrespondentieThreadIdRoute
  BeheerGroepenGroupIdLessenNieuweLesRoute: typeof BeheerGroepenGroupIdLessenNieuweLesRoute
  BeheerGroepenGroupIdToetsOverzichtEntryIdRoute: typeof BeheerGroepenGroupIdToetsOverzichtEntryIdRoute
  BeheerGroepenGroupIdCorrespondentieIndexRoute: typeof BeheerGroepenGroupIdCorrespondentieIndexRoute
  BeheerGroepenGroupIdDocumentenIndexRoute: typeof BeheerGroepenGroupIdDocumentenIndexRoute
  BeheerGroepenGroupIdGegevensIndexRoute: typeof BeheerGroepenGroupIdGegevensIndexRoute
  BeheerGroepenGroupIdLesmaterialenIndexRoute: typeof BeheerGroepenGroupIdLesmaterialenIndexRoute
  BeheerGroepenGroupIdLessenIndexRoute: typeof BeheerGroepenGroupIdLessenIndexRoute
  BeheerGroepenGroupIdNotitiesIndexRoute: typeof BeheerGroepenGroupIdNotitiesIndexRoute
  BeheerGroepenGroupIdPresentieOverzichtIndexRoute: typeof BeheerGroepenGroupIdPresentieOverzichtIndexRoute
  BeheerGroepenGroupIdRoosterIndexRoute: typeof BeheerGroepenGroupIdRoosterIndexRoute
  BeheerGroepenGroupIdStudentsIndexRoute: typeof BeheerGroepenGroupIdStudentsIndexRoute
  BeheerGroepenGroupIdToetsOverzichtIndexRoute: typeof BeheerGroepenGroupIdToetsOverzichtIndexRoute
  BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRoute: typeof BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRoute
}

const BeheerGroepenGroupIdRouteRouteChildren: BeheerGroepenGroupIdRouteRouteChildren =
  {
    BeheerGroepenGroupIdCorrespondentieThreadIdRoute:
      BeheerGroepenGroupIdCorrespondentieThreadIdRoute,
    BeheerGroepenGroupIdLessenNieuweLesRoute:
      BeheerGroepenGroupIdLessenNieuweLesRoute,
    BeheerGroepenGroupIdToetsOverzichtEntryIdRoute:
      BeheerGroepenGroupIdToetsOverzichtEntryIdRoute,
    BeheerGroepenGroupIdCorrespondentieIndexRoute:
      BeheerGroepenGroupIdCorrespondentieIndexRoute,
    BeheerGroepenGroupIdDocumentenIndexRoute:
      BeheerGroepenGroupIdDocumentenIndexRoute,
    BeheerGroepenGroupIdGegevensIndexRoute:
      BeheerGroepenGroupIdGegevensIndexRoute,
    BeheerGroepenGroupIdLesmaterialenIndexRoute:
      BeheerGroepenGroupIdLesmaterialenIndexRoute,
    BeheerGroepenGroupIdLessenIndexRoute: BeheerGroepenGroupIdLessenIndexRoute,
    BeheerGroepenGroupIdNotitiesIndexRoute:
      BeheerGroepenGroupIdNotitiesIndexRoute,
    BeheerGroepenGroupIdPresentieOverzichtIndexRoute:
      BeheerGroepenGroupIdPresentieOverzichtIndexRoute,
    BeheerGroepenGroupIdRoosterIndexRoute:
      BeheerGroepenGroupIdRoosterIndexRoute,
    BeheerGroepenGroupIdStudentsIndexRoute:
      BeheerGroepenGroupIdStudentsIndexRoute,
    BeheerGroepenGroupIdToetsOverzichtIndexRoute:
      BeheerGroepenGroupIdToetsOverzichtIndexRoute,
    BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRoute:
      BeheerGroepenGroupIdNotitiesNoteThreadIdIndexRoute,
  }

const BeheerGroepenGroupIdRouteRouteWithChildren =
  BeheerGroepenGroupIdRouteRoute._addFileChildren(
    BeheerGroepenGroupIdRouteRouteChildren,
  )

interface BeheerLaptopsLaptopIdRouteRouteChildren {
  BeheerLaptopsLaptopIdLeengeschiedenisRoute: typeof BeheerLaptopsLaptopIdLeengeschiedenisRoute
}

const BeheerLaptopsLaptopIdRouteRouteChildren: BeheerLaptopsLaptopIdRouteRouteChildren =
  {
    BeheerLaptopsLaptopIdLeengeschiedenisRoute:
      BeheerLaptopsLaptopIdLeengeschiedenisRoute,
  }

const BeheerLaptopsLaptopIdRouteRouteWithChildren =
  BeheerLaptopsLaptopIdRouteRoute._addFileChildren(
    BeheerLaptopsLaptopIdRouteRouteChildren,
  )

interface BeheerLeerlijnenLearningPathIdRouteRouteChildren {
  BeheerLeerlijnenLearningPathIdIndexRoute: typeof BeheerLeerlijnenLearningPathIdIndexRoute
  BeheerLeerlijnenLearningPathIdModulesModuleIdRoute: typeof BeheerLeerlijnenLearningPathIdModulesModuleIdRoute
}

const BeheerLeerlijnenLearningPathIdRouteRouteChildren: BeheerLeerlijnenLearningPathIdRouteRouteChildren =
  {
    BeheerLeerlijnenLearningPathIdIndexRoute:
      BeheerLeerlijnenLearningPathIdIndexRoute,
    BeheerLeerlijnenLearningPathIdModulesModuleIdRoute:
      BeheerLeerlijnenLearningPathIdModulesModuleIdRoute,
  }

const BeheerLeerlijnenLearningPathIdRouteRouteWithChildren =
  BeheerLeerlijnenLearningPathIdRouteRoute._addFileChildren(
    BeheerLeerlijnenLearningPathIdRouteRouteChildren,
  )

interface BeheerLocatiesLocationIdRouteRouteChildren {
  BeheerLocatiesLocationIdIndexRoute: typeof BeheerLocatiesLocationIdIndexRoute
  BeheerLocatiesLocationIdClassroomsClassroomRoute: typeof BeheerLocatiesLocationIdClassroomsClassroomRoute
  BeheerLocatiesLocationIdDocumentenIndexRoute: typeof BeheerLocatiesLocationIdDocumentenIndexRoute
  BeheerLocatiesLocationIdGegevensIndexRoute: typeof BeheerLocatiesLocationIdGegevensIndexRoute
  BeheerLocatiesLocationIdNotitiesIndexRoute: typeof BeheerLocatiesLocationIdNotitiesIndexRoute
  BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRoute: typeof BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRoute
}

const BeheerLocatiesLocationIdRouteRouteChildren: BeheerLocatiesLocationIdRouteRouteChildren =
  {
    BeheerLocatiesLocationIdIndexRoute: BeheerLocatiesLocationIdIndexRoute,
    BeheerLocatiesLocationIdClassroomsClassroomRoute:
      BeheerLocatiesLocationIdClassroomsClassroomRoute,
    BeheerLocatiesLocationIdDocumentenIndexRoute:
      BeheerLocatiesLocationIdDocumentenIndexRoute,
    BeheerLocatiesLocationIdGegevensIndexRoute:
      BeheerLocatiesLocationIdGegevensIndexRoute,
    BeheerLocatiesLocationIdNotitiesIndexRoute:
      BeheerLocatiesLocationIdNotitiesIndexRoute,
    BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRoute:
      BeheerLocatiesLocationIdNotitiesNoteThreadIdIndexRoute,
  }

const BeheerLocatiesLocationIdRouteRouteWithChildren =
  BeheerLocatiesLocationIdRouteRoute._addFileChildren(
    BeheerLocatiesLocationIdRouteRouteChildren,
  )

interface BeheerMedewerkersUserIdRouteRouteChildren {
  BeheerMedewerkersUserIdLesbevoegdheidControlerenRoute: typeof BeheerMedewerkersUserIdLesbevoegdheidControlerenRoute
  BeheerMedewerkersUserIdAgendaIndexRoute: typeof BeheerMedewerkersUserIdAgendaIndexRoute
  BeheerMedewerkersUserIdBeschikbaarheidIndexRoute: typeof BeheerMedewerkersUserIdBeschikbaarheidIndexRoute
  BeheerMedewerkersUserIdDossierIndexRoute: typeof BeheerMedewerkersUserIdDossierIndexRoute
  BeheerMedewerkersUserIdGroepenIndexRoute: typeof BeheerMedewerkersUserIdGroepenIndexRoute
  BeheerMedewerkersUserIdLesbevoegdheidIndexRoute: typeof BeheerMedewerkersUserIdLesbevoegdheidIndexRoute
  BeheerMedewerkersUserIdLeslocatiesIndexRoute: typeof BeheerMedewerkersUserIdLeslocatiesIndexRoute
  BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRoute: typeof BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRoute
  BeheerMedewerkersUserIdZakelijke_gegevensIndexRoute: typeof BeheerMedewerkersUserIdZakelijke_gegevensIndexRoute
}

const BeheerMedewerkersUserIdRouteRouteChildren: BeheerMedewerkersUserIdRouteRouteChildren =
  {
    BeheerMedewerkersUserIdLesbevoegdheidControlerenRoute:
      BeheerMedewerkersUserIdLesbevoegdheidControlerenRoute,
    BeheerMedewerkersUserIdAgendaIndexRoute:
      BeheerMedewerkersUserIdAgendaIndexRoute,
    BeheerMedewerkersUserIdBeschikbaarheidIndexRoute:
      BeheerMedewerkersUserIdBeschikbaarheidIndexRoute,
    BeheerMedewerkersUserIdDossierIndexRoute:
      BeheerMedewerkersUserIdDossierIndexRoute,
    BeheerMedewerkersUserIdGroepenIndexRoute:
      BeheerMedewerkersUserIdGroepenIndexRoute,
    BeheerMedewerkersUserIdLesbevoegdheidIndexRoute:
      BeheerMedewerkersUserIdLesbevoegdheidIndexRoute,
    BeheerMedewerkersUserIdLeslocatiesIndexRoute:
      BeheerMedewerkersUserIdLeslocatiesIndexRoute,
    BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRoute:
      BeheerMedewerkersUserIdPersoonlijke_gegevensIndexRoute,
    BeheerMedewerkersUserIdZakelijke_gegevensIndexRoute:
      BeheerMedewerkersUserIdZakelijke_gegevensIndexRoute,
  }

const BeheerMedewerkersUserIdRouteRouteWithChildren =
  BeheerMedewerkersUserIdRouteRoute._addFileChildren(
    BeheerMedewerkersUserIdRouteRouteChildren,
  )

interface BeheerOrganisatiesOrganizationIdRouteRouteChildren {
  BeheerOrganisatiesOrganizationIdIndexRoute: typeof BeheerOrganisatiesOrganizationIdIndexRoute
  BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRoute: typeof BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRoute
  BeheerOrganisatiesOrganizationIdContactpersonenIndexRoute: typeof BeheerOrganisatiesOrganizationIdContactpersonenIndexRoute
  BeheerOrganisatiesOrganizationIdContractenIndexRoute: typeof BeheerOrganisatiesOrganizationIdContractenIndexRoute
  BeheerOrganisatiesOrganizationIdCursistenIndexRoute: typeof BeheerOrganisatiesOrganizationIdCursistenIndexRoute
  BeheerOrganisatiesOrganizationIdDocumentenIndexRoute: typeof BeheerOrganisatiesOrganizationIdDocumentenIndexRoute
  BeheerOrganisatiesOrganizationIdGegevensIndexRoute: typeof BeheerOrganisatiesOrganizationIdGegevensIndexRoute
  BeheerOrganisatiesOrganizationIdNotitiesIndexRoute: typeof BeheerOrganisatiesOrganizationIdNotitiesIndexRoute
  BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRoute: typeof BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRoute
}

const BeheerOrganisatiesOrganizationIdRouteRouteChildren: BeheerOrganisatiesOrganizationIdRouteRouteChildren =
  {
    BeheerOrganisatiesOrganizationIdIndexRoute:
      BeheerOrganisatiesOrganizationIdIndexRoute,
    BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRoute:
      BeheerOrganisatiesOrganizationIdContactpersonenAanmakenRoute,
    BeheerOrganisatiesOrganizationIdContactpersonenIndexRoute:
      BeheerOrganisatiesOrganizationIdContactpersonenIndexRoute,
    BeheerOrganisatiesOrganizationIdContractenIndexRoute:
      BeheerOrganisatiesOrganizationIdContractenIndexRoute,
    BeheerOrganisatiesOrganizationIdCursistenIndexRoute:
      BeheerOrganisatiesOrganizationIdCursistenIndexRoute,
    BeheerOrganisatiesOrganizationIdDocumentenIndexRoute:
      BeheerOrganisatiesOrganizationIdDocumentenIndexRoute,
    BeheerOrganisatiesOrganizationIdGegevensIndexRoute:
      BeheerOrganisatiesOrganizationIdGegevensIndexRoute,
    BeheerOrganisatiesOrganizationIdNotitiesIndexRoute:
      BeheerOrganisatiesOrganizationIdNotitiesIndexRoute,
    BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRoute:
      BeheerOrganisatiesOrganizationIdNotitiesNoteThreadIdIndexRoute,
  }

const BeheerOrganisatiesOrganizationIdRouteRouteWithChildren =
  BeheerOrganisatiesOrganizationIdRouteRoute._addFileChildren(
    BeheerOrganisatiesOrganizationIdRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProfielRouteRoute: ProfielRouteRouteWithChildren,
  TestSupportRouteRoute: TestSupportRouteRouteWithChildren,
  TodoRouteRoute: TodoRouteRouteWithChildren,
  CorrespondentieThreadIdRoute: CorrespondentieThreadIdRoute,
  LoginTokenRoute: LoginTokenRoute,
  OnboardingTokenRoute: OnboardingTokenRoute,
  OnboardingOngeldige_tokenRoute: OnboardingOngeldige_tokenRoute,
  AgendaIndexRoute: AgendaIndexRoute,
  BeheerIndexRoute: BeheerIndexRoute,
  CorrespondentieIndexRoute: CorrespondentieIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DuoIndexRoute: DuoIndexRoute,
  FacturatieIndexRoute: FacturatieIndexRoute,
  Freelancer_omzettenIndexRoute: Freelancer_omzettenIndexRoute,
  GeenRolIndexRoute: GeenRolIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  BeheerContactpersonenOrganizationUserIdRouteRoute:
    BeheerContactpersonenOrganizationUserIdRouteRouteWithChildren,
  BeheerContractenContractIdRouteRoute:
    BeheerContractenContractIdRouteRouteWithChildren,
  BeheerCursistenStudentIdRouteRoute:
    BeheerCursistenStudentIdRouteRouteWithChildren,
  BeheerGroepenGroupIdRouteRoute: BeheerGroepenGroupIdRouteRouteWithChildren,
  BeheerLaptopsLaptopIdRouteRoute: BeheerLaptopsLaptopIdRouteRouteWithChildren,
  BeheerLeerlijnenLearningPathIdRouteRoute:
    BeheerLeerlijnenLearningPathIdRouteRouteWithChildren,
  BeheerLocatiesLocationIdRouteRoute:
    BeheerLocatiesLocationIdRouteRouteWithChildren,
  BeheerMedewerkersUserIdRouteRoute:
    BeheerMedewerkersUserIdRouteRouteWithChildren,
  BeheerOrganisatiesOrganizationIdRouteRoute:
    BeheerOrganisatiesOrganizationIdRouteRouteWithChildren,
  AgendaLesLessonIdRoute: AgendaLesLessonIdRoute,
  BeheerContactpersonenAanmakenRoute: BeheerContactpersonenAanmakenRoute,
  BeheerCursistenAanmakenRoute: BeheerCursistenAanmakenRoute,
  BeheerGroepenAanmakenRoute: BeheerGroepenAanmakenRoute,
  BeheerIntakesAanmakenRoute: BeheerIntakesAanmakenRoute,
  BeheerIntakesIntakePlannenRoute: BeheerIntakesIntakePlannenRoute,
  BeheerLaptopsAanmakenRoute: BeheerLaptopsAanmakenRoute,
  BeheerLeerlijnenAanmakenRoute: BeheerLeerlijnenAanmakenRoute,
  BeheerLessenNieuweLesRoute: BeheerLessenNieuweLesRoute,
  BeheerOrganisatiesAanmakenRoute: BeheerOrganisatiesAanmakenRoute,
  AuthConfirm_accountIndexRoute: AuthConfirm_accountIndexRoute,
  AuthFailed_ssoIndexRoute: AuthFailed_ssoIndexRoute,
  AuthSso_callbackIndexRoute: AuthSso_callbackIndexRoute,
  BeheerContactpersonenIndexRoute: BeheerContactpersonenIndexRoute,
  BeheerContractenIndexRoute: BeheerContractenIndexRoute,
  BeheerCursistenIndexRoute: BeheerCursistenIndexRoute,
  BeheerFeestdagenIndexRoute: BeheerFeestdagenIndexRoute,
  BeheerGroepenIndexRoute: BeheerGroepenIndexRoute,
  BeheerIntakesIndexRoute: BeheerIntakesIndexRoute,
  BeheerLaptopsIndexRoute: BeheerLaptopsIndexRoute,
  BeheerLeerlijnenIndexRoute: BeheerLeerlijnenIndexRoute,
  BeheerLesmaterialenIndexRoute: BeheerLesmaterialenIndexRoute,
  BeheerLessenIndexRoute: BeheerLessenIndexRoute,
  BeheerLocatiesIndexRoute: BeheerLocatiesIndexRoute,
  BeheerMedewerkersIndexRoute: BeheerMedewerkersIndexRoute,
  BeheerOrganisatiesIndexRoute: BeheerOrganisatiesIndexRoute,
  BeheerRoostersIndexRoute: BeheerRoostersIndexRoute,
  BeheerToetsenIndexRoute: BeheerToetsenIndexRoute,
  DuoContractenlijstenIndexRoute: DuoContractenlijstenIndexRoute,
  DuoExamenresultatenIndexRoute: DuoExamenresultatenIndexRoute,
  DuoFacturenIndexRoute: DuoFacturenIndexRoute,
  DuoTerugmeldingenIndexRoute: DuoTerugmeldingenIndexRoute,
  FacturatieCursistenIndexRoute: FacturatieCursistenIndexRoute,
  FacturatieFacturenIndexRoute: FacturatieFacturenIndexRoute,
  OnboardingDocentOnboardingIndexRoute: OnboardingDocentOnboardingIndexRoute,
  BeheerTodoStudentRegistrationIdControlerenRoute:
    BeheerTodoStudentRegistrationIdControlerenRoute,
  BeheerTodoStudentRegistrationIdVergelijkenRoute:
    BeheerTodoStudentRegistrationIdVergelijkenRoute,
  FacturatieCursistenStudentIdFactuurGenererenRoute:
    FacturatieCursistenStudentIdFactuurGenererenRoute,
  BeheerContractenNieuwContractIndexRoute:
    BeheerContractenNieuwContractIndexRoute,
  BeheerFeestdagenAanmakenIndexRoute: BeheerFeestdagenAanmakenIndexRoute,
  BeheerIntakesIntakeIdIndexRoute: BeheerIntakesIntakeIdIndexRoute,
  BeheerLesmaterialenAanmakenIndexRoute: BeheerLesmaterialenAanmakenIndexRoute,
  BeheerLocatiesAanmakenIndexRoute: BeheerLocatiesAanmakenIndexRoute,
  BeheerToetsenAanmakenIndexRoute: BeheerToetsenAanmakenIndexRoute,
  FacturatieFacturenInvoiceIdIndexRoute: FacturatieFacturenInvoiceIdIndexRoute,
  BeheerContractenWijzigenContractIdContractGegevensRoute:
    BeheerContractenWijzigenContractIdContractGegevensRoute,
  BeheerContractenWijzigenContractIdLocatiesRoute:
    BeheerContractenWijzigenContractIdLocatiesRoute,
  BeheerContractenWijzigenContractIdTeamGegevensRoute:
    BeheerContractenWijzigenContractIdTeamGegevensRoute,
  BeheerContractenWijzigenContractIdVakantiesRoute:
    BeheerContractenWijzigenContractIdVakantiesRoute,
  BeheerGroepenWijzigenGroupIdLocatiesWijzigenRoute:
    BeheerGroepenWijzigenGroupIdLocatiesWijzigenRoute,
  BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRoute:
    BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdWijzigenRoute,
  BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRoute:
    BeheerIntakesIntakeIdResultaatStudentIdStudentProjectOrganizationIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
